{
  "common": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "add": "Ajouter",
    "search": "Rechercher",
    "loading": "Chargement...",
    "error": "Erreur",
    "success": "Succès",
    "back": "Retour",
    "next": "Suivant",
    "previous": "Précédent",
    "close": "Fermer",
    "appName": "{brand}",
    "searchPlaceholder": "Rechercher...",
    "connectionReconnecting": "Reconnexion...",
    "connectionLostClickRetry": "Connexion perdue. Cliquez pour réessayer.",
    "connectionOffline": "Hors ligne",
    "searchExpandedPlaceholder": "Rechercher des fonctionnalités ou docs...",
    "searchPromptEmpty": "Saisissez du texte pour rechercher des fonctionnalités ou des documents",
    "searchSectionApplication": "Application",
    "searchSectionDocumentation": "Documentation",
    "searchNoFeatureResults": "Aucune fonctionnalité ne correspond à cette requête",
    "searchNoDocResults": "Aucune documentation ne correspond à cette requête",
    "description": "Description",
    "preview": "Aperçu",
    "addTag": "Ajouter un tag...",
    "searchProjects": "Rechercher des projets...",
    "searchModels": "Rechercher des modèles...",
    "all": "Tous",
    "favorites": "Favoris",
    "searchResource": "Rechercher {{resource}}...",
    "selectAll": "Tout sélectionner",
    "clearAll": "Tout effacer",
    "resetToDefault": "Rétablir par défaut",
    "noOptionsAvailable": "Aucune option disponible",
    "noMoreItems": "Plus aucun élément",
    "clearSearch": "Effacer la recherche",
    "apply": "Appliquer",
    "clear": "Effacer",
    "yes": "Oui",
    "no": "Non",
    "notResource": "Non {{resource}}",
    "afterDate": "Après {{date}}",
    "beforeDate": "Avant {{date}}",
    "removeFilter": "Supprimer le filtre {{label}}",
    "removeFilterWithColon": "Supprimer le filtre : {{label}}",
    "showResource": "Afficher {{resource}}",
    "hideResource": "Masquer {{resource}}",
    "saveChanges": "Enregistrer les modifications",
    "processing": "Traitement en cours...",
    "copy": "Copier",
    "copied": "Copié",
    "or": "ou",
    "filters": "Filtres",
    "searchItem": "Rechercher {{item}}...",
    "searchItemAria": "Rechercher {{item}}",
    "searchPrompts": "Rechercher des prompts...",
    "showItem": "Afficher {{item}}",
    "hideItem": "Masquer {{item}}"
  },
  "productDocs": {
    "title": "Product documentation",
    "lead": "Guides for getting started, models, tools, Agent Studio, observability, and administration — served from the same site as the platform.",
    "openNewTab": "Open in new tab",
    "openSameWindow": "Open in this window",
    "hint": "Docs are not shown inside the app shell because some login or edge responses set X-Frame-Options: DENY on pages that are not meant to be embedded. Opening in a new tab or full window keeps clickjacking protection intact and is the recommended way to read documentation."
  },
  "agentStore": {
    "title": "Magasin d'agents",
    "subtitle": "Découvrez et déployez des agents IA d'entreprise",
    "search": "Rechercher des agents par nom...",
    "manage": "Gérer",
    "manageTooltip": "Gérer le magasin d'agents",
    "loading": "Chargement des agents...",
    "all": "Tous",
    "allAgents": "Tous les agents",
    "allAgentsCount": "Tous les agents ({{count}})",
    "resultsFound_one": "{{count}} agent trouvé",
    "resultsFound_other": "{{count}} agents trouvés",
    "view": "Voir",
    "open": "Ouvrir",
    "openApp": "Ouvrir l'application",
    "pending": "En attente",
    "subscribe": "S'abonner",
    "unnamedAgent": "Agent",
    "categoryOther": "Autre",
    "noDescription": "Aucune description disponible",
    "noAgents": "Aucun agent trouvé",
    "noAgentsInCategory": "Aucun agent trouvé dans {{category}}",
    "tryAdjusting": "Essayez d'ajuster vos critères de recherche ou de filtre"
  },
  "catalogFilters": {
    "filters": "Filtres",
    "filtersApplied": "Filtres ({{count}} appliqués)",
    "clearAll": "Tout effacer",
    "creator": "Créateur",
    "allCreators": "Tous les créateurs",
    "searchCreators": "Rechercher des créateurs...",
    "rating": "Note",
    "allRatings": "Toutes les notes",
    "rating5": "5 étoiles",
    "rating4Up": "4 étoiles et plus",
    "rating3Up": "3 étoiles et plus",
    "allOf": "Tous : {{label}}"
  },
  "nav": {
    "home": "Accueil",
    "ideate": "Plateforme d'intelligence décisionnelle",
    "solutions": "Solutions",
    "agentStore": "Magasin d'agents",
    "projects": "Projets",
    "data": "Données",
    "agentStudio": "Studio d'agents",
    "agentWorkflows": "Flux de travail d'agents",
    "registry": "Registre",
    "registryUnified": "Registre",
    "aiTransparency": "Transparence IA",
    "workflowStore": "Boutique de flux",
    "workflowRegistry": "Registre des flux",
    "agentDeployments": "Déploiements d'agents",
    "workflowDeployments": "Déploiements de flux",
    "workflowStoreBrowse": "Parcourir les flux",
    "workflowStoreManage": "Gérer la boutique de flux",
    "workflowStoreAbout": "Détails du flux",
    "simulations": "Simulations",
    "evalsSimulations": "Évaluations",
    "benchmarks": "Benchmarks",
    "monitoring": "Surveillance",
    "cache": "Cache",
    "agentEvals": "Évaluations d'agents",
    "evalTemplates": "Modèles d'évaluation",
    "environments": "Environnements",
    "evaluations": "Évaluations",
    "agents": "Agents",
    "models": "Modèles",
    "tools": "Outils",
    "prompts": "Invites",
    "skills": "Compétences",
    "knowledge": "Connaissances",
    "connections": "Connexions",
    "docs": "Documentation",
    "admin": "Administration",
    "platformAdmin": "Admin plateforme",
    "settings": "Paramètres",
    "chat": "Chat",
    "goToHome": "Aller à l'accueil",
    "userMenu": "Menu utilisateur",
    "account": "Compte",
    "switchRole": "Changer de rôle",
    "tenant": "Locataire",
    "logout": "Déconnexion",
    "help": "Aide",
    "helpDocumentation": "Aide et documentation",
    "themeDarkModeTitle": "Mode sombre",
    "themeLightModeTitle": "Mode clair",
    "themeSwitchToDarkAria": "Passer en mode sombre",
    "themeSwitchToLightAria": "Passer en mode clair",
    "sections": {
      "agentDevelop": "Développement d'agents",
      "observability": "Observabilité",
      "agentOps": "Opérations agents",
      "resources": "Ressources",
      "admin": "Administration",
      "aiBlueprints": "Blueprints",
      "enterpriseOntology": "Enterprise Ontology"
    },
    "ontologyCanvas": "Canvas Ontologie",
    "ontoEval": "Onto Eval",
    "dataModels": "Modèles de données",
    "kpiLibrary": "Bibliothèque KPI",
    "semanticHub": "Hub sémantique",
    "migrationsStudio": "Studio de migrations",
    "dataPipelines": "Studio de données",
    "pipelineDesigner": "Studio ML",
    "dataExplorer": "Explorateur de données",
    "dataObservability": "Observabilité des données",
    "switchToDataflow": "{brand} Ontology Studio",
    "blueprints": "Modèles",
    "autopilot": "Plateforme décisionnelle",
    "brandMilkyway": "{brand}",
    "brandPlatform": "{brand} Platform",
    "switchToMilkyway": "{brand}",
    "switchToPlatform": "{brand} Platform"
  },
  "settings": {
    "title": "Paramètres",
    "description": "Gérez les paramètres et préférences de votre compte",
    "profile": "Profil utilisateur",
    "appearance": "Apparence",
    "language": "Langue",
    "languageDescription": "Choisissez votre langue préférée",
    "theme": "Thème",
    "light": "Clair",
    "dark": "Sombre",
    "appearanceHeading": "Apparence",
    "appearanceSubtitle": "Personnalisez l'apparence de votre espace de travail",
    "colorTheme": "Thème de couleur",
    "colorThemeDescription": "Choisissez une palette de couleurs pour l'application",
    "displayModeSection": "Mode d'affichage",
    "displayModeDescription": "Choisissez entre le mode clair et sombre",
    "themeDefaultBadge": "Par défaut",
    "loadingAppearance": "Chargement des paramètres d'apparence...",
    "notifications": {
      "title": "Notifications"
    },
    "integrations": {
      "title": "Intégrations"
    }
  },
  "models": {
    "title": "Modèles",
    "addModel": "Ajouter un modèle",
    "editModel": "Modifier le modèle",
    "modelName": "Nom du modèle",
    "provider": "Fournisseur",
    "baseUrl": "URL de base",
    "chat": "Discuter",
    "deleteConfirm": "Êtes-vous sûr de vouloir supprimer ce modèle ?",
    "noModels": "Aucun modèle trouvé",
    "filterProvider": "Fournisseur",
    "filterStatus": "Statut",
    "filterCreator": "Créateur",
    "statusActive": "Actif",
    "statusDeprecated": "Obsolète",
    "columnModelName": "Nom du modèle",
    "columnProvider": "Fournisseur",
    "columnStatus": "Statut",
    "columnAccess": "Accès",
    "columnCreatedBy": "Créé par",
    "columnCreatedAt": "Créé le",
    "columnUpdatedAt": "Mis à jour le",
    "columnActions": "Actions",
    "actionChat": "Discuter",
    "actionTestConnection": "Tester la connexion",
    "actionSetDefault": "Définir par défaut",
    "actionRemoveDefault": "Supprimer par défaut",
    "actionManageAccess": "Gérer l'accès",
    "actionExport": "Exporter",
    "actionEdit": "Modifier",
    "actionDelete": "Supprimer",
    "bulkExportSelected": "Exporter la sélection",
    "bulkDeleteSelected": "Supprimer la sélection",
    "modelArena": "Arène des modèles",
    "modelArenaTitle": "Comparer 2 modèles dans l'arène",
    "pricingCatalog": "Catalogue des tarifs",
    "pricingCatalogTitle": "Afficher et modifier les tarifs USD par 1M",
    "deleteModalTitle": "Supprimer le modèle",
    "deleteModalMessage": "Êtes-vous sûr de vouloir supprimer « {{name}} » ? Cette action est irréversible.",
    "bulkDeleteModalTitle": "Supprimer les modèles sélectionnés",
    "bulkDeleteModalMessage": "Êtes-vous sûr de vouloir supprimer {{count}} modèle{{s}} ? Cette action est irréversible.",
    "bulkDeleteModalConfirm": "Supprimer {{count}} modèle{{s}}",
    "loadingModels": "Chargement des modèles...",
    "favorites": "Favoris",
    "filterBarTitle": "Filtres",
    "searchPlaceholder": "Rechercher des modèles...",
    "defaultModelTooltip": "Modèle par défaut",
    "pricing": {
      "title": "Catalogue des prix",
      "description": "USD par million de jetons — trié par entrée la moins chère parmi les modèles visibles. Utilisez {{endpoint}} pour comparer les fournisseurs.",
      "descriptionPrefix": "USD par million de jetons — trié par entrée la moins chère parmi les modèles visibles. Utilisez",
      "descriptionSuffix": "pour comparer les fournisseurs.",
      "allProviders": "Tous les fournisseurs",
      "fromInput": "dès ${{price}}/in",
      "fromInputTooltip": "À partir de ${{price}} / 1M d'entrées (modèles visibles)",
      "viewMore": "Voir {{count}} de plus",
      "searchPlaceholder": "Rechercher des modèles ou fournisseurs…",
      "emptyMessage": "Aucun modèle trouvé.",
      "loadingMessage": "Chargement du catalogue des prix…",
      "loadModelsFailed": "Échec du chargement des modèles",
      "harvestSuccess": "Collecte des prix terminée : {{summary}}",
      "harvestFailed": "Échec de la collecte des prix",
      "modelsPriced": "{{count}} modèle tarifé",
      "modelsPriced_plural": "{{count}} modèles tarifés",
      "skippedCount": "{{count}} ignoré(s)",
      "errorsCount": "{{count}} erreur",
      "errorsCount_plural": "{{count}} erreurs",
      "viewHistory": "Voir l'historique",
      "noPricing": "Aucun tarif",
      "live": "En direct",
      "notOpenEnded": "Non illimité",
      "notOpenEndedTooltip": "La dernière ligne est un intervalle fermé — vérifiez qu'un intervalle ouvert existe pour la tarification future.",
      "columns": {
        "model": "Modèle",
        "inputRate": "Taux d'entrée",
        "outputRate": "Taux de sortie",
        "interval": "Intervalle",
        "source": "Source"
      },
      "history": {
        "title": "Historique des prix",
        "subtitle": "Historique complet des tarifs. La ligne de catalogue active est affichée en premier ; les intervalles manuels et les taux collectés peuvent être modifiés. Seuls les intervalles manuels peuvent être supprimés.",
        "currentCatalogRate": "Tarif actuel du catalogue",
        "liveOpenEnded": "En direct (illimité)",
        "notOpenEnded": "Non illimité",
        "notOpenEndedTooltip": "Aucun intervalle illimité — affichage de la période fermée la plus récente.",
        "searchPlaceholder": "Rechercher source, dates, taux…",
        "emptyMessage": "Aucune ligne d'historique ne correspond à cette recherche.",
        "loadingMessage": "Chargement de l'historique des prix…",
        "failedToLoad": "Échec du chargement de l'historique des prix",
        "refresh": "Actualiser",
        "addManualInterval": "Ajouter un intervalle manuel",
        "activeRate": "Tarif actif",
        "historical": "Historique",
        "effectiveFrom": "Date de début",
        "effectiveUntil": "Date de fin",
        "unit": "Unité",
        "inputRate": "Taux d'entrée",
        "outputRate": "Taux de sortie",
        "source": "Source",
        "deleteModalTitle": "Supprimer l'intervalle de tarification",
        "deleteModalMessage": "Êtes-vous sûr de vouloir supprimer cet intervalle de tarification manuel ? Cette action ne peut pas être annulée.",
        "delete": "Supprimer",
        "intervalAdded": "Intervalle de tarification ajouté",
        "intervalUpdated": "Intervalle de tarification mis à jour",
        "intervalDeleted": "Intervalle de tarification supprimé",
        "failedToAdd": "Échec de l'ajout de l'intervalle de tarification",
        "failedToUpdate": "Échec de la mise à jour de l'intervalle de tarification",
        "failedToDelete": "Échec de la suppression de l'intervalle de tarification",
        "units": {
          "perMinute": "par minute",
          "perMillionChars": "par 1M de caractères",
          "perMillionTokens": "par 1M de jetons"
        }
      },
      "modal": {
        "addTitle": "Ajouter un intervalle de tarification",
        "editTitle": "Modifier l'intervalle de tarification",
        "model": "Modèle",
        "selectModel": "Sélectionner un modèle...",
        "effectiveFrom": "Date de début",
        "effectiveUntil": "Date de fin",
        "effectiveUntilHelp": "Facultatif — laissez vide pour un intervalle ouvert (tarification actuellement active).",
        "unit": "Unité",
        "unitOptions": {
          "tokens": "Par 1M de jetons (LLM / plongements)",
          "minute": "Par minute (STT / audio)",
          "chars": "Par 1M de caractères (TTS)"
        },
        "fieldLabels": {
          "usdPerMinute": "USD par minute",
          "outputPriceOptional": "Prix de sortie (facultatif)",
          "inputPriceOptional": "Prix d'entrée (facultatif)",
          "usdPer1MChars": "USD par 1M de caractères",
          "inputUsdPer1MTokens": "USD d'entrée par 1M de jetons",
          "outputUsdPer1MTokens": "USD de sortie par 1M de jetons"
        },
        "validation": {
          "selectModel": "Veuillez sélectionner un modèle",
          "effectiveFromRequired": "La date de début est obligatoire",
          "effectiveFromFormat": "La date de début doit être au format AAAA-MM-JJ",
          "effectiveUntilFormat": "La date de fin doit être au format AAAA-MM-JJ",
          "effectiveUntilAfterFrom": "La date de fin doit être postérieure ou égale à la date de début",
          "inputNonNegative": "L'USD d'entrée doit être un nombre positif ou nul",
          "outputNonNegative": "L'USD de sortie doit être un nombre positif ou nul"
        },
        "cancel": "Annuler",
        "save": "Enregistrer l'intervalle",
        "add": "Ajouter l'intervalle",
        "saving": "Enregistrement en cours..."
      }
    },
    "form": {
      "addTitle": "Ajouter un modèle",
      "editTitle": "Modifier le modèle",
      "loadingQuota": "Chargement du quota...",
      "modelType": "Type de modèle",
      "cannotChangeTypeAfterCreation": "Ne peut pas être modifié après la création ({{type}})",
      "provider": "Fournisseur",
      "providerTooltip": "Sélectionnez le fournisseur IA. {{count}} fournisseur(s) compatible(s) affiché(s) pour le type de modèle sélectionné.",
      "showingEmbeddingProviders": "Affichage de {{count}} fournisseurs prenant en charge les plongements",
      "showingTypeProviders": "Affichage de {{count}} fournisseurs pour {{type}}",
      "providerLockedTooltip": "Le fournisseur ne peut pas être modifié après la création.",
      "selectModel": "Sélectionner un modèle",
      "optionalTemplate": "(modèle optionnel)",
      "discoverFallbackTooltip": "Privilégiez Découvrir ci-dessus pour les points de terminaison réels ; les modèles sont une solution de repli.",
      "availableModelsTooltip": "Choisissez parmi les modèles {{provider}} {{type}} disponibles ({{count}} disponibles)",
      "selectAModel": "Sélectionner un modèle",
      "selectATypeModel": "Sélectionner un modèle {{type}}",
      "discovered": "découvert",
      "baseUrl": "URL de base",
      "baseUrlTooltip": "Requis pour les fournisseurs locaux comme Ollama ou LM Studio. Laisser vide pour les fournisseurs cloud.",
      "apiKeyRef": "Référence de clé API",
      "apiKeyRefTooltip": "Nom de la variable d'environnement contenant la clé API du fournisseur (configurée dans le déploiement backend).",
      "displayName": "Nom d'affichage",
      "displayNameModelIdSetTooltip": "L'ID du modèle sera défini à partir du modèle sélectionné ci-dessus.",
      "displayNameAutoGeneratedTooltip": "L'ID du modèle sera généré automatiquement à partir du nom d'affichage si aucun modèle n'est sélectionné.",
      "fullModelNamePreview": "Aperçu du nom complet du modèle :",
      "displayNamePlaceholder": "ex. : Chat Completion",
      "apiVersion": "Version d'API",
      "apiVersionTooltip": "Version de l'API requise par la passerelle",
      "paramProfile": "Profil de paramètres",
      "defaultParams": "Paramètres par défaut (JSON)",
      "defaultParamsTooltip": "Objet JSON facultatif contenant les paramètres par défaut envoyés au modèle à chaque requête (par ex. temperature, max_tokens).",
      "testSuccess": "✓ Test de connexion réussi",
      "testFailed": "✗ Échec du test de connexion",
      "modelResponse": "Réponse du modèle :",
      "testing": "Test en cours...",
      "testConnection": "Tester la connexion",
      "testConnectionTitle": "Tester la connexion avant d'enregistrer",
      "addModel": "Ajouter un modèle",
      "adding": "Ajout en cours...",
      "saving": "Enregistrement en cours...",
      "quotaExceeded": "Quota de modèles dépassé",
      "noChangesToSave": "Aucune modification à enregistrer",
      "selectProvider": "Sélectionner un fournisseur"
    },
    "tags": {
      "llm": "Texte",
      "image": "Image",
      "embedding": "Plongement",
      "audio": "Audio",
      "video": "Vidéo",
      "reranker": "Rerank",
      "tts": "Synthèse vocale",
      "stt": "Reconnaissance vocale"
    },
    "tagDescriptions": {
      "llm": "Les modèles de texte génèrent des réponses pour les tâches de chat et de complétion",
      "image": "Les modèles d'image génèrent, modifient ou analysent du contenu visuel",
      "embedding": "Les modèles de plongement convertissent le texte en vecteurs pour la recherche sémantique et la similarité",
      "audio": "Les modèles audio traitent et génèrent du son et de la musique",
      "video": "Les modèles vidéo génèrent et éditent du contenu vidéo",
      "reranker": "Les modèles de reclassement évaluent et ordonnent les documents par pertinence",
      "tts": "Les modèles vocaux génèrent de la voix à partir de texte — pas pour le chat ou la complétion",
      "stt": "Les modèles de transcription convertissent l'audio en texte — pas pour le chat ou la complétion"
    },
    "emptyState": {
      "permissionDenied": "Vous n'avez pas l'autorisation d'afficher les modèles. Contactez votre administrateur pour y accéder.",
      "noResultsSearch": "Aucun modèle trouvé correspondant à votre recherche.",
      "default": "Aucun modèle trouvé. Créez votre premier modèle pour commencer."
    }
  },
  "chat": {
    "title": "Chat",
    "placeholder": "Tapez votre message...",
    "send": "Envoyer",
    "modelNotSelected": "Aucun modèle sélectionné",
    "modelNotFound": "Modèle introuvable",
    "failedToLoad": "Échec du chargement du modèle",
    "failedToSend": "Échec de l'envoi du message",
    "ollamaNotRunning": "Impossible de se connecter à Ollama. Assurez-vous qu'Ollama est en cours d'exécution : ollama serve",
    "modelNotFoundOllama": "Modèle introuvable ou Ollama n'est pas en cours d'exécution. Veuillez vérifier votre installation Ollama.",
    "modelArena": {
      "title": "Arène de modèles",
      "vs": "VS",
      "selectModel": "Sélectionner un modèle",
      "startConversation": "Démarrer une conversation",
      "processing": "Traitement en cours...",
      "recording": "Enregistrement...",
      "record": "Enregistrer",
      "stop": "Arrêter",
      "or": "ou",
      "uploadAudio": "Téléverser l'audio",
      "query": "Requête",
      "documents": "Documents (un par ligne, min 2)",
      "compare": "Comparer",
      "enterInput": "Saisir...",
      "noImageOrText": "Aucune image ou texte retourné",
      "noVideoReturned": "Aucune vidéo retournée",
      "copied": "Copié",
      "copy": "Copier",
      "copyResponse": "Copier la réponse",
      "startRecording": "Démarrer l'enregistrement",
      "stopRecording": "Arrêter l'enregistrement",
      "cannotChangeModel": "Le modèle ne peut pas être modifié une fois la conversation démarrée",
      "cannotChangeType": "Le type de modèle ne peut pas être modifié une fois la conversation démarrée",
      "noModelsAvailable": "Aucun modèle disponible",
      "addAnotherModel": "Ajouter un autre modèle à comparer",
      "onlyOneModelAvailable": "Un seul modèle est disponible. L'arène de modèles nécessite deux modèles différents.",
      "sameModelSelected": "Vous avez sélectionné le même modèle des deux côtés. Veuillez sélectionner un modèle différent.",
      "startBeforeRating": "Démarrez une conversation avant d'évaluer cette session",
      "restoreView": "Restaurer la vue partagée",
      "expandLeft": "Agrandir le panneau gauche",
      "expandRight": "Agrandir le panneau droit",
      "selectModel2": "Sélectionner un modèle...",
      "searchModels": "Rechercher des modèles...",
      "syncedToBoth": "{{placeholder}} (synchronisé aux deux)",
      "placeholders": {
        "searchQuery": "Entrer la requête de recherche...",
        "rerankDocs": "Texte du document 1...\nTexte du document 2...\nTexte du document 3...",
        "tts": "Entrer le texte à synthétiser...",
        "image": "Décrire l'image à générer...",
        "video": "Décrire la vidéo à générer... (peut prendre quelques minutes)"
      },
      "types": {
        "llm": "Texte",
        "image": "Image",
        "audio": "Audio",
        "video": "Vidéo",
        "reranker": "Rerank",
        "tts": "Parole",
        "stt": "Transcription"
      },
      "typeDescriptions": {
        "llm": "Les modèles texte génèrent des réponses pour le chat et la complétion",
        "image": "Les modèles image génèrent ou modifient des images à partir de prompts texte",
        "audio": "Les modèles audio traitent ou génèrent du contenu audio non vocal",
        "video": "Les modèles vidéo génèrent ou analysent du contenu vidéo",
        "reranker": "Les modèles de rerank réordonnent les documents pour améliorer la pertinence RAG",
        "tts": "Les modèles de parole génèrent de l'audio à partir de texte",
        "stt": "Les modèles de transcription convertissent l'audio en texte"
      }
    },
    "newChat": "Nouveau chat",
    "newSession": "Nouveau chat",
    "endOfSessions": "Fin des sessions",
    "noSessionsYet": "Aucune session d'arène de modèles",
    "startNewConversation": "Démarrer une nouvelle conversation",
    "startConversation": "Démarrer une conversation",
    "startConversationWithModel": "Démarrer une conversation avec ce modèle",
    "configuration": "Configuration",
    "collapseConfig": "Réduire",
    "expandConfig": "Configuration",
    "backToModels": "Retour aux modèles",
    "refreshSessions": "Actualiser les sessions",
    "activeSessionEmpty": "La session active est vide",
    "newModelArena": "Nouvelle arène de modèles",
    "loadingDot": "Chargement...",
    "loadingMore": "Chargement en cours...",
    "sessionRenamed": "Session renommée",
    "failedToRename": "Échec du renommage de la session",
    "sessionDeleted": "Session supprimée avec succès",
    "failedToDelete": "Échec de la suppression de la session",
    "deleteSession": "Supprimer la session d'arène de modèles",
    "deleteSessionConfirm": "Êtes-vous sûr de vouloir supprimer cette session d'arène de modèles ? Cela supprimera également les deux sessions de modèles individuels. Cette action est irréversible.",
    "rename": "Renommer",
    "delete": "Supprimer",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "selectPrompt": "Sélectionner un prompt...",
    "searchPrompts": "Rechercher des prompts...",
    "selectSkills": "Sélectionner des compétences...",
    "searchSkills": "Rechercher des compétences...",
    "version": "Version",
    "rateSession": "Évaluer la session",
    "rateThisSession": "Évaluer cette session",
    "updateFeedback": "Mettre à jour les commentaires",
    "helpful": "Utile",
    "notHelpful": "Pas utile",
    "rated": "Noté {{value}}/10",
    "feedbackProvided": "Commentaires fournis",
    "startBeforeRating": "Commencez une conversation avant d'évaluer cette session",
    "selectHelpful": "Veuillez sélectionner Utile ou Pas utile avant de soumettre",
    "failedToSaveComparisonFeedback": "Échec de l'enregistrement des commentaires de comparaison",
    "feedbackSubmitted": "Commentaires soumis avec succès",
    "failedToSubmitSessionFeedback": "Échec de la soumission des commentaires de session",
    "promptTemplate": "Modèle de prompt",
    "skills": "Compétences",
    "model": "Modèle",
    "sttModel": "Synthèse vocale (pièces jointes)",
    "knowledge": "Connaissances",
    "tools": "Outils",
    "settings": "Paramètres"
  },
  "admin": {
    "title": "Administration",
    "users": "Utilisateurs",
    "roles": "Rôles",
    "pending": "En attente",
    "active": "Actif"
  },
  "solutions": {
    "title": "Solutions",
    "subtitle": "Découvrez et partagez des dépôts et du code avec des liens rapides vers QA, UAT et la production.",
    "addSolution": "Ajouter une solution",
    "dialogTitle": "Ajouter une solution",
    "editDialogTitle": "Modifier la solution",
    "submit": "Ajouter au catalogue",
    "submitEdit": "Enregistrer les modifications",
    "empty": "Aucune solution pour l’instant. Ajoutez la première pour aider votre équipe à trouver les environnements plus vite.",
    "openGithub": "Ouvrir le dépôt GitHub",
    "editSolution": "Modifier la solution",
    "deleteSolution": "Supprimer la solution",
    "deleteSelected": "Supprimer la sélection",
    "openEditor": "Ouvrir l’éditeur",
    "sourceGithub": "URL GitHub",
    "sourceCode": "Fichiers de code",
    "codeHint": "Après la création, vous serez redirigé vers l’éditeur de code pour ajouter et modifier les fichiers.",
    "shortcutHint": "Astuce : Ctrl/⌘ + Entrée envoie le formulaire.",
    "toast": {
      "created": "Solution ajoutée au catalogue.",
      "updated": "Solution mise à jour.",
      "deleted": "Solution supprimée.",
      "bulkDeleted": "{{deleted}} solution(s) supprimée(s). {{skipped}} ignorée(s).",
      "conflict": "Cette solution a été modifiée ailleurs. Actualisez la page pour charger la dernière version."
    },
    "fields": {
      "name": "Nom de la solution",
      "description": "Description",
      "githubUrl": "URL du dépôt GitHub",
      "sourceType": "Type de source",
      "tags": "Étiquettes",
      "owner": "Propriétaire"
    },
    "placeholders": {
      "description": "Résumé court (2–3 lignes)"
    },
    "validation": {
      "nameRequired": "Le nom est obligatoire.",
      "nameTooLong": "Le nom doit contenir au plus {{max}} caractères.",
      "descriptionTooLong": "La description doit contenir au plus {{max}} caractères.",
      "githubRequired": "L’URL GitHub est obligatoire.",
      "githubInvalid": "Saisissez une URL https valide vers un dépôt GitHub.",
      "urlInvalid": "Doit être une URL http(s) valide."
    },
    "confirmDeleteTitle": "Supprimer la solution",
    "confirmDeleteMessage": "Voulez-vous vraiment supprimer « {{name}} » ? La solution et tous ses fichiers seront définitivement supprimés.",
    "confirmBulkDeleteTitle": "Supprimer les solutions sélectionnées",
    "confirmBulkDeleteMessage": "Voulez-vous vraiment supprimer {{count}} solution(s) ? Elles et tous leurs fichiers seront définitivement supprimés.",
    "editor": {
      "explorer": "Explorateur",
      "newFile": "Nouveau fichier",
      "noFiles": "Aucun fichier pour l’instant.",
      "addFirstFile": "Ajouter un fichier",
      "selectFile": "Sélectionnez un fichier dans l’explorateur pour commencer à modifier.",
      "noFileSelected": "Aucun fichier sélectionné",
      "saveChanges": "Enregistrer les modifications",
      "saved": "Enregistré",
      "unsavedChanges": "Modifications non enregistrées",
      "deleteFile": "Supprimer le fichier",
      "confirmDelete": "Supprimer « {{file}} » ? Cette action est irréversible.",
      "delete": "Supprimer",
      "fileExists": "Un fichier avec ce chemin existe déjà.",
      "notFound": "Solution introuvable.",
      "backToList": "Retour aux solutions",
      "settings": "Paramètres",
      "metadataTitle": "Paramètres de la solution",
      "metadataSaved": "Paramètres enregistrés."
    }
  },
  "tenant": {
    "switch": "Changer de locataire",
    "subdomain": "Sous-domaine:"
  },
  "home": {
    "tabs": {
      "overview": "Aperçu",
      "agents": "Agents",
      "workflows": "Flux de travail",
      "evals": "Évaluations",
      "sessions": "Sessions",
      "cost": "Coût",
      "platform": "Plateforme"
    },
    "dateRangeAriaLabel": "Plage de dates du tableau de bord",
    "sectionInfoAriaLabel": "Informations sur la section",
    "viewLabel": "Voir {{label}}",
    "loading": "Chargement du tableau de bord...",
    "loadFailed": "Échec du chargement des données",
    "retry": "Réessayer",
    "noDataAvailable": "Aucune donnée disponible",
    "noData": "Aucune donnée",
    "quickActions": {
      "createAgent": "Créer un agent",
      "newWorkflow": "Nouveau flux de travail",
      "runEval": "Lancer une évaluation",
      "aiAgentBuilder": "Générateur d'agents IA",
      "aiWorkflowsBuilder": "Générateur de flux de travail IA",
      "agentStore": "Boutique d'agents",
      "tools": "Outils"
    },
    "activity": {
      "title": "Activité récente",
      "export": "Exporter",
      "filterAll": "Tout",
      "filterUpdate": "Modification",
      "filterCreate": "Création",
      "filterDelete": "Suppression",
      "noActivityFound": "Aucune activité trouvée",
      "actionCreate": "CRÉATION",
      "actionUpdate": "MODIFICATION",
      "actionDelete": "SUPPRESSION",
      "actionRead": "LECTURE",
      "resourceIdTitle": "ID de ressource",
      "viewAll": "Tout voir"
    },
    "overview": {
      "kpi": {
        "totalAgents": "Total des agents",
        "totalAgentsHintDefault": "Créés durant la période sélectionnée",
        "totalAgentsHintAllTenants": "Créés durant la période sélectionnée · tous les tenants · hors archivés",
        "totalAgentsHintStudio": "Créés durant la période sélectionnée · même périmètre qu'Agent Studio",
        "totalWorkflows": "Total des flux de travail",
        "activeUsers": "Utilisateurs actifs",
        "activeDeployments": "Déploiements actifs",
        "activeDeploymentsHint": "Déploiements actifs créés durant la période sélectionnée",
        "sessions": "Sessions",
        "evalRuns": "Exécutions d'évaluation",
        "toolCalls": "Appels d'outils",
        "archivedDelta": "archivés",
        "totalProjects": "Total des projets",
        "activeProjects": "Projets actifs",
        "modelsAvailable": "Modèles disponibles",
        "toolsAvailable": "Outils disponibles",
        "activeConnections": "Connexions actives",
        "pendingApprovals": "Approbations en attente",
        "actionNeeded": "Action requise"
      },
      "funnel": {
        "active": "Actif",
        "deployments": "Déploiements"
      },
      "series": {
        "agentsCreated": "Agents créés",
        "projects": "Projets",
        "sessions": "Sessions",
        "workflows": "Flux de travail",
        "evals": "Évaluations",
        "medianRuntime": "Durée médiane d'exécution (ms)",
        "retryRate": "Taux de nouvelle tentative %",
        "slaBreaches": "Dépassements de SLA"
      },
      "platformTrendTitle": "Tendance de la plateforme",
      "platformTrendSubtitle": "Croissance et activité des entités de la plateforme dans le temps",
      "loadingPlatformTrend": "Chargement de la tendance de la plateforme...",
      "loadingActivity": "Chargement de l'activité...",
      "quickActionsTitle": "Actions rapides",
      "adoptionHealthTitle": "Adoption et santé",
      "adoptionFunnelTitle": "Entonnoir d'adoption",
      "adoptionFunnelSubtitle": "Parcours des projets, de la création à l'utilisation active",
      "adoptionFunnelInfo": "Montre comment les projets progressent de la création jusqu'au déploiement actif et à l'utilisation en session. Chaque barre représente le nombre de projets ayant atteint cette étape.",
      "topRiskSignalTitle": "Principal signal de risque",
      "topRiskSignalSubtitle": "Risque et alertes de santé les plus critiques de la plateforme",
      "topRiskSignalInfo": "Met en évidence le risque le plus critique pour la plateforme actuellement, en fonction des taux d'échec des workflows et des tendances d'activité des sessions. Le graphique affiche le nombre de dépassements de SLA.",
      "riskSeverityWarn": "avertissement",
      "noActiveRiskSignal": "Aucun signal de risque actif",
      "metricFallback": "Métrique",
      "workflowHealthTitle": "Santé des flux de travail",
      "workflowHealthSubtitle": "Indicateurs de performance et de fiabilité des exécutions",
      "workflowHealthInfo": "Suit la santé des exécutions de workflows. La durée médiane indique la vitesse de traitement, le taux de nouvelle tentative signale des problèmes de fiabilité, et les dépassements de SLA signalent les exécutions échouées ou expirées.",
      "actionableHighlightsTitle": "Points clés à traiter",
      "actionableHighlightsSubtitle": "Principales entités classées par activité et recommandations",
      "actionableHighlightsInfo": "Principaux projets classés par activité de session et couverture d'évaluation.\n\nÉtat de santé :\n• Bon : > 0 sessions, > 0 évaluations\n• Avertissement : > 0 sessions, 0 évaluations\n• Mauvais : 0 sessions\n\nChaque ligne indique le nombre de sessions, d'exécutions d'évaluation et une action recommandée pour améliorer l'adoption ou la qualité de la plateforme.",
      "noHighlightsYet": "Aucun point clé pour le moment",
      "table": {
        "entity": "Entité",
        "type": "Type",
        "sessions": "Sessions",
        "evalRuns": "Exécutions d'évaluation",
        "failurePercent": "% d'échec",
        "health": "Santé",
        "recommendedAction": "Action recommandée"
      }
    },
    "na": "N/D",
    "agents": {
      "kpi": {
        "draft": "Brouillon",
        "published": "Publié",
        "registered": "Enregistré",
        "deployed": "Déployé",
        "storeListings": "Fiches boutique"
      },
      "sections": {
        "byEnvironment": "Agents par environnement",
        "byStatus": "Statut des agents",
        "registryStatus": "Statut du registre",
        "deploymentPipeline": "Pipeline de déploiement",
        "byProjectsTitle": "Agents par projets",
        "byProjectsSubtitle": "Répartition des agents entre les projets"
      },
      "barName": "Agents"
    },
    "workflows": {
      "kpi": {
        "executions": "Exécutions",
        "successRate": "Taux de réussite",
        "activeSchedules": "Planifications actives"
      },
      "sections": {
        "executionStatus": "Statut d'exécution",
        "triggerSource": "Source de déclenchement",
        "executionVolumeTitle": "Volume d'exécutions",
        "executionVolumeSubtitle": "Total des exécutions de workflows sur la période sélectionnée",
        "successRateTrendTitle": "Tendance du taux de réussite",
        "successRateTrendSubtitle": "Pourcentage d'exécutions réussies dans le temps",
        "scheduleOverview": "Aperçu des planifications",
        "recentExecutions": "Exécutions récentes"
      },
      "noRecentExecutions": "Aucune exécution récente",
      "series": {
        "executions": "Exécutions",
        "successPercent": "Réussite %"
      },
      "statusActive": "Actif",
      "statusPaused": "En pause",
      "everySeconds": "Toutes les {{seconds}}s",
      "table": {
        "workflow": "Workflow",
        "type": "Type",
        "schedule": "Planification",
        "status": "Statut",
        "nextRun": "Prochaine exécution",
        "trigger": "Déclencheur",
        "duration": "Durée",
        "started": "Démarré"
      }
    },
    "evals": {
      "kpi": {
        "totalEvalSessions": "Total des sessions d'évaluation",
        "totalEvalSessionsHint": "Sessions créées durant la période sélectionnée (respecte le filtre de date).",
        "avgEvalQualityScore": "Score moyen de qualité d'évaluation",
        "avgEvalQualityScoreHint": "Score moyen des métriques de synthèse sur les sessions d'évaluation de la période sélectionnée.",
        "passRate": "Taux de réussite",
        "passRateHint": "Part des métriques de synthèse atteignant ≥70 % durant la période sélectionnée."
      },
      "zones": {
        "poor": "Faible",
        "fair": "Moyen",
        "good": "Bon"
      },
      "sections": {
        "averageScoreTitle": "Score moyen de qualité d'évaluation",
        "sessionsByStatus": "Sessions par statut",
        "sessionsTrendTitle": "Tendance des sessions d'évaluation",
        "sessionsTrendSubtitle": "Volume de sessions d'évaluation dans le temps",
        "frameworkDistribution": "Répartition par framework",
        "topEvaluatedAgents": "Principaux agents évalués"
      },
      "series": {
        "evalSessions": "Sessions d'évaluation"
      },
      "table": {
        "agent": "Agent",
        "evalSessions": "Sessions d'évaluation",
        "latestScore": "Dernier score",
        "framework": "Framework"
      }
    },
    "sessions": {
      "kpi": {
        "activeSessionsInPeriod": "Sessions actives (période)",
        "activeSessionsHint": "Sessions ayant eu au moins un message ou un tour dans la période sélectionnée.",
        "avgTurnsPerSession": "Tours moyens / session",
        "avgTurnsHint": "Nombre moyen de tours conversationnels par session parmi les sessions actives durant la période sélectionnée.",
        "messages": "Messages",
        "avgLatency": "Latence moyenne",
        "avgCostPerCall": "Coût moyen / appel",
        "avgCostPerCallHint": "Correspond à l'onglet Coût (journaux LLM + événements d'utilisation)."
      },
      "sections": {
        "byEnvironment": "Sessions par environnement",
        "byEnvironmentSubtitle": "Répartition des sessions actives à travers différents environnements.",
        "visibilityDistribution": "Répartition de la visibilité",
        "visibilityDistributionSubtitle": "Répartition des sessions par niveau de visibilité.",
        "sessionTrendTitle": "Tendance des sessions",
        "sessionTrendSubtitle": "Nombre de sessions quotidien sur la période sélectionnée.",
        "messagesTrendTitle": "Tendance des messages",
        "messagesTrendSubtitle": "Volume quotidien de messages sur l'ensemble des sessions.",
        "tokenUsageTitle": "Utilisation des tokens",
        "tokenUsageSubtitle": "Mêmes totaux quotidiens que l'onglet Coût (journaux LLM + événements d'utilisation).",
        "latencyTrendTitle": "Tendance de latence",
        "latencyTrendSubtitle": "Latences de réponse moyennes et par percentile dans le temps.",
        "topAgentsBySessions": "Principaux agents par sessions"
      },
      "series": {
        "tokens": "Tokens",
        "avgLatency": "Latence moyenne",
        "p90Latency": "Latence P90",
        "p95Latency": "Latence P95",
        "p99Latency": "Latence P99"
      },
      "table": {
        "agent": "Agent",
        "sessions": "Sessions",
        "messages": "Messages",
        "avgLatency": "Latence moyenne",
        "avgTokens": "Tokens moyens"
      }
    },
    "cost": {
      "kpi": {
        "totalTokens": "Total des tokens",
        "inputTokens": "Tokens d'entrée",
        "outputTokens": "Tokens de sortie",
        "cachedTokens": "Tokens en cache",
        "estCost": "Coût estimé",
        "llmCalls": "Appels LLM",
        "avgTokensPerCall": "Tokens moyens/appel",
        "dailyAvgCost": "Coût moyen quotidien",
        "peakUsageDate": "Date de pic d'utilisation",
        "peakTokens": "Pic de tokens",
        "dailyAvgTokens": "Tokens moyens quotidiens",
        "avgCostPerCall": "Coût moyen/appel"
      },
      "sections": {
        "tokenUsageTrendTitle": "Tendance d'utilisation des tokens",
        "tokenUsageTrendSubtitle": "Volume de tokens traités dans le temps",
        "costTrendTitle": "Tendance des coûts",
        "costTrendSubtitle": "Coût opérationnel estimé dans le temps",
        "tokensByServiceTitle": "Tokens par service",
        "tokensByServiceSubtitle": "Utilisation totale des tokens selon les différents services système",
        "costByServiceTitle": "Coût estimé par service",
        "costByServiceSubtitle": "Répartition de l'impact financier par service système",
        "tokensByConsumerTitle": "Tokens par consommateur",
        "tokensByConsumerSubtitle": "Consommation de tokens répartie par consommateurs d'API",
        "costByConsumerTitle": "Coût estimé par consommateur",
        "costByConsumerSubtitle": "Répartition des coûts entre les différents consommateurs d'API",
        "tokenDistByModelTitle": "Répartition des tokens par modèle",
        "tokenDistByModelSubtitle": "Utilisation proportionnelle des tokens selon les différents modèles IA",
        "costByModelTitle": "Estimation des coûts par modèle",
        "costByModelSubtitle": "Dépenses estimées attribuées à chaque modèle IA",
        "tokensByProjectTitle": "Consommation de tokens par projet",
        "tokensByProjectSubtitle": "Total des tokens utilisés par projet enregistré",
        "costByProjectTitle": "Coût estimé par projet",
        "costByProjectSubtitle": "Répartition financière de l'utilisation de l'IA par projet",
        "tokensByAgentTitle": "Consommation de tokens par agent",
        "tokensByAgentSubtitle": "Utilisation des tokens suivie par agent IA individuel",
        "costByAgentTitle": "Coût estimé par agent",
        "costByAgentSubtitle": "Impact financier des agents IA spécifiques",
        "tokensByWorkflowTitle": "Consommation de tokens par workflow",
        "tokensByWorkflowSubtitle": "Volume de tokens traité par les workflows automatisés",
        "costByWorkflowTitle": "Coût estimé par workflow",
        "costByWorkflowSubtitle": "Coût attribué à l'exécution des workflows IA",
        "tokensByEnvironmentTitle": "Consommation de tokens par environnement",
        "tokensByEnvironmentSubtitle": "Indicateurs d'utilisation répartis entre les environnements de déploiement",
        "costByEnvironmentTitle": "Coût estimé par environnement",
        "costByEnvironmentSubtitle": "Répartition financière par environnement de déploiement",
        "tokensByUsersTitle": "Consommation de tokens par utilisateurs",
        "tokensByUsersSubtitle": "Volume de tokens utilisé par utilisateur final",
        "costByUsersTitle": "Coût estimé par utilisateurs",
        "costByUsersSubtitle": "Dépenses opérationnelles attribuées à des utilisateurs spécifiques",
        "topCostDriversTitle": "Principaux facteurs de coût",
        "topCostDriversSubtitle": "Agents et workflows les plus consommateurs contribuant aux coûts de la plateforme"
      },
      "noDataRange": {
        "projectToken": "Aucune donnée de tokens par projet sur cette période.",
        "projectCost": "Aucune donnée de coût par projet sur cette période.",
        "agentToken": "Aucune donnée de tokens par agent sur cette période.",
        "agentCost": "Aucune donnée de coût par agent sur cette période.",
        "workflowToken": "Aucune donnée de tokens par workflow sur cette période.",
        "workflowCost": "Aucune donnée de coût par workflow sur cette période.",
        "environmentToken": "Aucune donnée de tokens par environnement sur cette période.",
        "environmentCost": "Aucune donnée de coût par environnement sur cette période.",
        "userToken": "Aucune donnée de tokens par utilisateur sur cette période.",
        "userCost": "Aucune donnée de coût par utilisateur sur cette période."
      },
      "barName": {
        "tokens": "Tokens",
        "usd": "USD",
        "models": "Modèles"
      },
      "table": {
        "driver": "Facteur",
        "type": "Type",
        "typeAgent": "Agent",
        "typeWorkflow": "Workflow",
        "totalTokens": "Total des tokens",
        "inputTokens": "Tokens d'entrée",
        "outputTokens": "Tokens de sortie",
        "estCost": "Coût estimé"
      }
    },
    "platform": {
      "kpi": {
        "totalTenants": "Total des tenants",
        "totalUsers": "Total des utilisateurs",
        "rejectedUsers": "Utilisateurs rejetés"
      },
      "sections": {
        "userGrowthTitle": "Croissance des utilisateurs",
        "usersByRoleTitle": "Utilisateurs par rôle",
        "approvalDecisionsTitle": "Décisions d'approbation",
        "userStatusDistributionTitle": "Répartition des statuts utilisateurs",
        "auditActivityTitle": "Activité d'audit",
        "tenantOverviewTitle": "Aperçu des tenants"
      },
      "series": {
        "newUsers": "Nouveaux utilisateurs",
        "approved": "Approuvés",
        "rejected": "Rejetés"
      },
      "table": {
        "tenant": "Tenant",
        "users": "Utilisateurs",
        "projects": "Projets",
        "agents": "Agents",
        "created": "Créé"
      }
    }
  },
  "blueprints": {
    "common": {
      "all": "Tout",
      "cancel": "Annuler",
      "deepThinkingDesc": "Analyse approfondie",
      "deepThinkingLabel": "Réflexion approfondie",
      "delete": "Supprimer",
      "deleteBlueprintMessage": "Supprimer « {{name}} » ? Cette action est irréversible.",
      "deleteBlueprintTitle": "Supprimer le blueprint ?",
      "dismiss": "Ignorer",
      "expressModeDesc": "Génération rapide et directe",
      "expressModeLabel": "Mode Express",
      "loading": "Chargement des blueprints...",
      "modeDeep": "Approfondi",
      "modeFast": "Rapide",
      "noProjectsFound": "Aucun projet trouvé. Veuillez créer un projet et le sélectionner pour continuer.",
      "noProjectsFoundBusinessUser": "Aucun projet n'est assigné à votre compte. Contactez votre administrateur pour être ajouté à un projet avant de continuer.",
      "noSystemBlueprints": "Aucun blueprint système.",
      "proceed": "Continuer",
      "removeAttachedFile": "Supprimer le fichier joint",
      "scopeLibrary": "Personnalisé",
      "scopeSystem": "Système",
      "searchAriaLabel": "Rechercher des blueprints",
      "searchPlaceholder": "Rechercher des blueprints…",
      "searchSelectProjectPlaceholder": "Rechercher et sélectionner un projet...",
      "selectProjectLabel": "Un projet est requis pour commencer :",
      "selectProjectTitle": "Sélectionner un projet",
      "selectThinkingModeTitle": "Sélectionner le mode de réflexion",
      "sourceAriaLabel": "Source des blueprints",
      "stopRecording": "Arrêter l'enregistrement",
      "systemBadge": "Système",
      "systemBadgeTitle": "Base de la plateforme — lecture seule",
      "targetAgent": "Agent",
      "targetWorkflow": "Flux de travail",
      "thinkingModeHeader": "Mode de réflexion",
      "uploadFile": "Téléverser un fichier",
      "voiceInput": "Saisie vocale"
    },
    "list": {
      "activeBlueprintsTitle": "Blueprints actifs",
      "addToSpotlight": "Ajouter à la vitrine",
      "archive": "Archiver",
      "archiveBlueprintMessage": "Archiver « {{name}} » ? Il sera masqué des listes actives.",
      "archiveBlueprintTitle": "Archiver le blueprint ?",
      "archivedBlueprintsTitle": "Blueprints archivés",
      "backTitle": "Retour",
      "cardActionsAriaLabel": "Actions de la carte",
      "catalogScopeTitle": "Portée du catalogue de blueprints",
      "closeAriaLabel": "Fermer",
      "delete": "Supprimer",
      "done": "Terminé",
      "edit": "Modifier",
      "errorCount": "{{count}} erreur(s)",
      "export": "Exporter",
      "filters": {
        "status": "Statut",
        "draft": "Brouillon",
        "pendingReview": "En attente de revue",
        "pending": "En attente",
        "approved": "Approuvé",
        "archived": "Archivé",
        "industry": "Domaine",
        "creator": "Créateur"
      },
      "filtersTitle": "Filtres",
      "fork": "Dupliquer",
      "goBackAriaLabel": "Retour",
      "importAriaLabel": "Importer un blueprint",
      "importCompleteHeading": "Importation terminée",
      "importErrorSubtitle": "Certains éléments n'ont pas pu être importés. Voir les détails ci-dessous.",
      "importFinishedWithErrorsHeading": "Importation terminée avec des erreurs",
      "importSuccessSubtitle": "Votre blueprint a été importé comme brouillon et est prêt à être révisé.",
      "importTitle": "Importer un blueprint depuis un fichier YAML",
      "loadingMore": "Chargement d'autres blueprints...",
      "newBlueprint": "Nouveau blueprint",
      "noBlueprintsMatchFilters": "Aucun blueprint ne correspond à vos filtres.",
      "noBlueprintsYet": "Aucun blueprint pour le moment.",
      "pageSubtitle": "Spécifications de processus pour Conversational Workflow et Agent Builder",
      "pageTitle": "Blueprints",
      "refreshAriaLabel": "Actualiser la liste",
      "refreshTitle": "Actualiser",
      "removeFromSpotlight": "Retirer de la vitrine",
      "spotlightBadgeTitle": "Vitrine {{rank}} — affiché en premier sur la page d'accueil du DIP (Démarrage rapide)",
      "spotlightFullTitle": "La vitrine est pleine (max {{max}}). Retirez-en un d'abord.",
      "statCreated": "Créés",
      "statFailed": "Échoués",
      "statSkipped": "Ignorés",
      "systemCreatorFallback": "Système",
      "toasts": {
        "addedToSpotlight": "Blueprint ajouté à la vitrine DIP",
        "archiveFailed": "Échec de l'archivage",
        "blueprintArchived": "Blueprint archivé",
        "blueprintDeleted": "Blueprint supprimé",
        "blueprintExported": "Blueprint exporté",
        "blueprintForked": "Blueprint dupliqué",
        "blueprintImported": "Blueprint importé",
        "blueprintUnarchived": "Blueprint désarchivé",
        "couldNotAddToSpotlight": "Impossible d'ajouter à la vitrine",
        "couldNotRemoveFromSpotlight": "Impossible de retirer de la vitrine",
        "deleteFailed": "Échec de la suppression",
        "exportFailed": "Échec de l'exportation",
        "forkFailed": "Échec de la duplication",
        "importCompletedWithErrors": "Importation terminée avec des erreurs",
        "importFailed": "Échec de l'importation",
        "importedWithWarnings": "Blueprint importé avec {{count}} avertissement(s)",
        "removedFromSpotlight": "Retiré de la vitrine DIP",
        "unarchiveFailed": "Échec du désarchivage"
      },
      "typeAgent": "Agent",
      "typeTabsAriaLabel": "Type de blueprint",
      "typeWorkflow": "Flux de travail",
      "unarchive": "Désarchiver",
      "unarchiveBlueprintMessage": "Restaurer « {{name}} » au statut de brouillon ?",
      "unarchiveBlueprintTitle": "Désarchiver le blueprint ?",
      "warningCount": "{{count}} avertissement(s)"
    }
  },
  "ideate": {
    "aiPrefix": "IA",
    "backToPlatformAriaLabel": "Retour à la plateforme d'intelligence décisionnelle",
    "blueprintDeletedToast": "Blueprint supprimé",
    "blueprintFallback": "Blueprint",
    "blueprintLaunchHeader": "Lancement du blueprint",
    "buildWithBlueprint": "Créer avec un blueprint",
    "buildDirectLabel": "Construire directement",
    "buildDirectHint": "Ignorer les questions de suivi et construire à partir d'une spécification complète. Activez-le avant de joindre un fichier. Désactivé, les questions actuelles restent.",
    "chooseProjectPlaceholder": "Choisir un projet…",
    "complianceAriaLabel": "Exigences de conformité",
    "complianceLabel": "Conformité",
    "couldNotOpenSharedSession": "Impossible d'ouvrir la session partagée",
    "deleteFailedToast": "Échec de la suppression",
    "deleteSessionMessage": "Voulez-vous vraiment supprimer cette session ? Cette action est irréversible.",
    "deleteSessionTitle": "Supprimer la session",
    "deployAriaLabel": "Déployer {{name}} avec {{brand}}",
    "deployWithDip": "Déployer avec la plateforme d'intelligence décisionnelle",
    "deployWithDipAriaLabel": "Déployer {{name}} avec la plateforme d'intelligence décisionnelle",
    "deployWithTitle": "Déployer avec {{brand}}",
    "guidedLaunchDesc": "Recherche web complète, clarification et validation LLM",
    "guidedLaunchLabel": "Lancement guidé",
    "importHeader": "Importer",
    "importN8nDesc": "Importer un JSON n8n existant dans AI Workflows",
    "importN8nLabel": "Importer un workflow n8n",
    "lookingForBlueprints": "Recherche de blueprints dans ce domaine…",
    "moreIndustries": "Plus",
    "noBlueprintsAvailable": "Aucun blueprint disponible. Ajoutez des blueprints pour essayer.",
    "noBlueprintsForFilter": "Aucun blueprint disponible pour ce filtre.",
    "noBlueprintsForIndustry": "Aucun blueprint pour ce domaine.",
    "placeholderAgent": "Décrivez un agent à créer...",
    "placeholderWorkflow": "Décrivez un cas d'usage à automatiser...",
    "placeholderWorkflowShort": "Décrivez un workflow à automatiser...",
    "preBuiltBlueprints": "Blueprints préconçus",
    "quickLaunchDesc": "Ignorer la recherche ; utiliser les directives et KPI du blueprint tels quels",
    "quickLaunchLabel": "Lancement rapide",
    "requireOptTitle": "Exiger {{label}}",
    "spotlightBadgeTitleShort": "Affiché en premier sur la page d'accueil du DIP (Démarrage rapide)",
    "spotlightRank": "Vitrine {{rank}}",
    "tagline": "Découvrir. Réinventer. Optimiser. Passer en production",
    "untitledSession": "Session sans titre",
    "uploadDocumentOrImage": "Téléverser un document ou une image",
    "compliance": {
      "soc2": "SOC 2 / SOX",
      "gdpr": "RGPD / Résidence des données",
      "hipaa": "HIPAA",
      "pii": "Masquage des données personnelles requis"
    }
  },
  "ontology": {
    "canvasTitle": "Canevas d'ontologie",
    "canvasSubtitle": "Traçabilité des données de bout en bout, de la source à l'analytique ML",
    "dataModelsTitle": "Modèles de données",
    "dataModelsSubtitle": "Catalogue de modèles de données d'entreprise multisecteur",
    "kpiLibraryTitle": "Bibliothèque de KPI",
    "kpiLibrarySubtitle": "Définitions de KPI métier et catalogue de métriques",
    "migrationsStudioTitle": "Studio de migrations",
    "migrationsStudioSubtitle": "Orchestrez la découverte jusqu'à la bascule avec des agents de migration IA, la validation et la traçabilité dans un seul espace de travail.",
    "pipelinesTitle": "Studio de données",
    "pipelinesSubtitle": "Transferts de migration, workflows d'orchestration et traitement lié aux KPI dans un seul catalogue",
    "observabilityTitle": "Observabilité des données",
    "observabilitySubtitle": "Surveillance de l'état des pipelines et suivi de la fraîcheur des données",
    "nodesSelected": "{{count}} nœuds sélectionnés",
    "overview": "Aperçu",
    "lineage": "Traçabilité",
    "buildTimeline": "Chronologie de build",
    "dataHealth": "Santé des données",
    "allFamilies": "Toutes les familles",
    "allTypes": "Tous les types",
    "mustHave": "Indispensable",
    "goodToHave": "Souhaitable",
    "totalKpis": "Total des KPI",
    "families": "Familles",
    "export": "Exporter en CSV",
    "exportCard": "Exporter…",
    "exportCardTitleDataModel": "Exporter le modèle de données",
    "exportCardTitleOntology": "Exporter l'ontologie",
    "exportCardTitleKpi": "Exporter les KPI",
    "exportCardSubtitle": "Choisissez un format de fichier, puis téléchargez.",
    "exportCardDownload": "Télécharger",
    "exportCardCancel": "Annuler",
    "exportFormatPortableJson": "JSON portable (aller-retour via Créer un modèle de données)",
    "exportFormatPortableYaml": "YAML portable (même contenu que le JSON)",
    "exportFormatDdl": "SQL DDL",
    "exportFormatDrawio": "XML Draw.io",
    "exportFormatTurtle": "Turtle (.ttl)",
    "exportFormatRdfXml": "RDF/XML",
    "exportFormatJsonLd": "JSON-LD",
    "version": "Version",
    "versions": "Versions",
    "latest": "dernière",
    "compareVersions": "Comparer",
    "neo4jGraph": "Graphe réseau",
    "diffAdded": "ajouté",
    "diffRemoved": "supprimé",
    "diffUnchanged": "inchangé",
    "diffNoChanges": "Aucune modification",
    "diffSelectTwo": "Sélectionnez deux versions différentes à comparer.",
    "exportFormatCsv": "CSV (import sur une autre instance)",
    "exportFormatKpiJson": "Instantané JSON (sauvegarde / outillage)",
    "exportKpiJsonNote": "Le CSV correspond à l'import CSV de la bibliothèque de KPI. Le JSON est destiné à la sauvegarde ou aux outils externes ; il n'y a pas encore d'import JSON.",
    "healthy": "Sain",
    "degraded": "Dégradé",
    "critical": "Critique",
    "running": "En cours",
    "completed": "Terminé",
    "failed": "Échoué",
    "scheduled": "Planifié",
    "published": "Publié",
    "draft": "Brouillon",
    "impactAnalysis": "Analyse d'impact",
    "impactActive": "Impact actif",
    "viewDataSample": "Voir l'échantillon de données",
    "resourceOverview": "Aperçu de la ressource",
    "pipelineDrawerCode": "Code",
    "pipelineDrawerRuns": "Exécutions",
    "pipelineDrawerMetadata": "Métadonnées",
    "pipelineDrawerNoCode": "Aucun code de transformation n'est encore enregistré pour ce nœud. Connectez un dépôt ou publiez depuis le générateur de pipeline.",
    "pipelineDrawerNoPipeline": "Aucun pipeline de données lié n'a été trouvé pour ce nœud.",
    "pipelineDrawerNoRuns": "Aucun historique d'exécution n'est disponible pour le pipeline lié.",
    "pipelineDrawerNoMetadata": "Aucun paramètre supplémentaire au-delà du script de transformation.",
    "pipelineLinkedJob": "Pipeline lié",
    "pipelineNodeParams": "Paramètres",
    "nodeInfoSection": "Informations sur le nœud",
    "unknownHealth": "Inconnu",
    "sourceChip": "Source",
    "dataExplorer": "Explorateur de données",
    "openInDataExplorerAriaLabel": "Ouvrir dans l'explorateur de données",
    "pipelineRunHistoryUnavailable": "L'historique d'exécution du pipeline n'est pas encore disponible depuis le backend.",
    "viewSample": "Voir l'échantillon",
    "metadataSectionTitle": "Métadonnées",
    "kvOwner": "Propriétaire",
    "kvDescription": "Description",
    "kvPipeline": "Pipeline",
    "kvSchedule": "Planification",
    "kvUpdated": "Mis à jour",
    "kvType": "Type",
    "kvLastUpdated": "Dernière mise à jour",
    "category": {
      "data_source": "Source de données",
      "data_extract": "Extraction de données",
      "pipeline_builder_dataset": "Jeu de données Pipeline Builder",
      "python_transform": "Transformation Python",
      "python_script_transform": "Script de transformation Python",
      "virtual_table": "Table virtuelle",
      "fusion_sync": "Synchronisation Fusion",
      "fusion_sheet": "Feuille Fusion",
      "kpi_node": "Nœud KPI",
      "ml_model": "Modèle ML"
    },
    "stage": {
      "source": "Sources",
      "ingestion": "Ingestion",
      "transformation": "Transformation",
      "kpi": "Couche KPI",
      "ml_analytics": "ML et analytique"
    },
    "toolbar": {
      "tools": "Outils",
      "layout": "Disposition",
      "undo": "Annuler",
      "redo": "Rétablir",
      "clean": "Nettoyer",
      "select": "Sélectionner",
      "expand": "Agrandir",
      "color": "Couleur",
      "find": "Rechercher",
      "remove": "Supprimer",
      "align": "Aligner",
      "flow": "Flux"
    },
    "legend": {
      "categoryLegend": "Légende des catégories",
      "closeLegend": "Fermer la légende"
    },
    "studio": {
      "loadingOntologies": "Chargement des ontologies…",
      "loadingPrevOntologies": "Chargement des ontologies précédentes…",
      "loadingMoreOntologies": "Chargement d'autres ontologies…",
      "industryFilterLabel": "Secteur",
      "allIndustries": "Tous les secteurs",
      "domainFilterLabel": "Domaine",
      "allDomains": "Tous les domaines",
      "subdomainFilterLabel": "Sous-domaine",
      "allSubdomains": "Tous les sous-domaines",
      "failedToDeleteOntology": "Échec de la suppression de l'ontologie",
      "ontologyImportedToast": "Ontologie « {{name}} » importée",
      "pageTitle": "Studio d'ontologie",
      "pageSubtitle": "Parcourez, importez ou créez des ontologies OWL/TTL avec l'IA à partir d'un modèle de données. Les ontologies issues du profileur apparaissent ici automatiquement une fois le profilage terminé dans Migrations Studio.",
      "evaluateButton": "Évaluer",
      "createOntologyButton": "Créer une ontologie",
      "ontologiesKpiLabel": "Ontologies",
      "yourOntologiesHeading": "Vos ontologies",
      "importTooltipBold": "Importer",
      "importTooltipRest": "un fichier OWL/TTL pour enregistrer une nouvelle ontologie. Les ontologies produites par le workflow du profileur sont enregistrées ici automatiquement.",
      "filtersTitle": "Filtres",
      "searchPlaceholder": "Rechercher des ontologies…",
      "clearSearchAriaLabel": "Effacer la recherche",
      "noOntologiesMatch": "Aucune ontologie ne correspond à votre recherche. Créez une ontologie en important un fichier OWL/TTL ou en la générant avec l'IA à partir d'un modèle de données, ou exécutez le profileur dans Migrations Studio pour enregistrer automatiquement une ontologie.",
      "ontologyActionsAriaLabel": "Actions pour l'ontologie {{name}}",
      "renameMenuItem": "Renommer",
      "industryTagsMenuItem": "Étiquettes de secteur",
      "deleteMenuItem": "Supprimer",
      "owlFileBadge": "Fichier OWL",
      "versionsCount": "{{count}} versions",
      "classesLabel": "classes",
      "individualsLabel": "individus",
      "removeFromCatalogTitle": "Retirer du catalogue",
      "removeFromCatalogMessage": "Retirer « {{name}} » du Studio d'ontologie ? L'ontologie est supprimée de façon réversible (retirée du catalogue). Les liens directs vers la visionneuse OWL peuvent sembler manquants jusqu'à une nouvelle importation.",
      "couldNotExportOntology": "Impossible d'exporter l'ontologie",
      "industryTagsUpdated": "Étiquettes de secteur mises à jour",
      "couldNotUpdateIndustryTags": "Impossible de mettre à jour les étiquettes de secteur",
      "industryDialogTitle": "Étiquettes de secteur",
      "industryDialogSubtitle": "Filtre de catalogue et badges pour {{name}}.",
      "unspecifiedOption": "Non spécifié",
      "industryFieldLabel": "Secteur",
      "saveButton": "Enregistrer",
      "savingButton": "Enregistrement…",
      "closeAriaLabel": "Fermer",
      "renameDialogTitle": "Renommer l'ontologie OWL",
      "renameDialogSubtitle": "Nom affiché sur les cartes et dans les listes (jusqu'à {{maxLength}} caractères).",
      "nameFieldLabel": "Nom",
      "nameRequiredError": "Le nom est requis",
      "nameMustContainLetterError": "Le nom doit contenir au moins une lettre ou un chiffre",
      "renameFailedError": "Échec du renommage"
    },
    "justNow": "À l'instant",
    "hoursAgo": "il y a {{hours}} h",
    "daysAgo": "il y a {{days}} j",
    "chooser": {
      "subtitle": "Importez un fichier OWL/TTL existant, ou créez une ontologie dense avec l'IA à partir d'un modèle de données enregistré et de questions de compétence.",
      "buildWithAiTitle": "Créer une ontologie avec l'IA",
      "buildWithAiDesc": "Choisissez un modèle de données, examinez les questions de compétence, synthétisez le OWL",
      "uploadTitle": "Téléverser OWL/TTL",
      "uploadDesc": "Téléverser un fichier d'ontologie existant"
    },
    "import": {
      "title": "Importer une ontologie OWL/TTL",
      "subtitle": "Téléversez un fichier Turtle (.ttl), OWL, RDF/XML ou JSON-LD pour créer une ontologie.",
      "industryHint": "Stocké sur la carte du catalogue et utilisé pour le filtrage avec les modèles de données et les KPI.",
      "nameLabel": "Nom de l'ontologie (facultatif)",
      "namePlaceholder": "Remplacer le titre détecté automatiquement à partir du fichier",
      "nameHint": "Affiché sur la carte du catalogue. Laissez vide pour utiliser le titre du fichier OWL.",
      "ontologyNameFieldLabel": "Nom de l'ontologie",
      "dropPrompt": "Déposez un fichier TTL/OWL ici, ou cliquez pour parcourir",
      "filePreviewHeader": "Aperçu du fichier",
      "importingButton": "Importation...",
      "importButton": "Importer l'ontologie",
      "importFailed": "Échec de l'importation"
    },
    "builder": {
      "backToStudioAriaLabel": "Retour au Studio d'ontologie",
      "pageTitle": "Créer une ontologie avec l'IA",
      "pageSubtitle": "Nommez l'ontologie, choisissez un modèle de données, examinez les questions de compétence, puis synthétisez le OWL et enregistrez-le dans le catalogue. Sûr en cas d'actualisation — rouvrez une session à tout moment.",
      "loadFailed": "Échec du chargement des modèles de données",
      "resumeFailed": "Impossible de reprendre la session d'ontologie",
      "sessionDiscarded": "Session abandonnée",
      "discardFailed": "Échec de l'abandon de la session",
      "nameSpecialCharsError": "Le nom de l'ontologie ne peut pas être composé uniquement de caractères spéciaux",
      "launchTextTooLong": "Le texte de lancement ne doit pas dépasser {{max}} caractères",
      "domainSpecialCharsError": "Le domaine ne peut pas être composé uniquement de caractères spéciaux",
      "subdomainSpecialCharsError": "Le sous-domaine ne peut pas être composé uniquement de caractères spéciaux",
      "enterNamePrompt": "Entrez un nom d'ontologie pour continuer",
      "enterDomainPrompt": "Entrez un domaine pour continuer",
      "selectDataModelPrompt": "Sélectionnez un modèle de données pour continuer",
      "selectOntologyLlmPrompt": "Sélectionnez un LLM d'ontologie pour continuer",
      "startFailed": "Échec du démarrage du générateur d'ontologie",
      "updateCqFailed": "Échec de la mise à jour des questions de compétence",
      "sendMessageFailed": "Échec de l'envoi du message",
      "synthesisFailed": "Échec de la synthèse",
      "registeredToast": "{{name}} enregistré",
      "ontologyFallback": "ontologie",
      "registrationFailed": "Échec de l'enregistrement",
      "dataModelFilterLabel": "Modèle de données",
      "selectDataModelPlaceholder": "Sélectionner un modèle de données…",
      "noDataModelsRegistered": "Aucun modèle de données enregistré",
      "modeFilterLabel": "Mode",
      "modeGuided": "Guidé — examiner chaque question de compétence",
      "modeExpress": "Express — parcours d'acceptation rapide",
      "ontologyLlmFilterLabel": "LLM d'ontologie",
      "selectOntologyLlmPlaceholder": "Sélectionner un LLM d'ontologie…",
      "noChatModelsRegistered": "Aucun modèle de discussion enregistré",
      "enrichmentLlmFilterLabel": "LLM d'enrichissement",
      "selectEnrichmentLlmPlaceholder": "Sélectionner un LLM d'enrichissement (facultatif)…",
      "stepSourceTitle": "Source",
      "stepSourceDesc": "Nommez l'ontologie et choisissez le modèle de données qui définit vos concepts",
      "stepQuestionsTitle": "Questions",
      "stepQuestionsDesc": "Acceptez, rejetez ou affinez les questions de compétence fondées sur ce modèle",
      "stepOntologyTitle": "Ontologie",
      "stepOntologyDesc": "Synthétisez les classes, propriétés et axiomes OWL vérifiés",
      "stepRegisterTitle": "Enregistrer",
      "stepRegisterDesc": "Publiez dans le catalogue d'ontologies pour Studio et les agents",
      "sourceFormSubtitle": "Nommez l'ontologie et choisissez le modèle de données pour fonder ses concepts.",
      "ontologyNameLabel": "Nom de l'ontologie",
      "ontologyNamePlaceholder": "ex. Ontologie du domaine des brevets",
      "domainLabel": "Domaine",
      "domainPlaceholder": "ex. Santé, Propriété intellectuelle",
      "subdomainLabel": "Sous-domaine",
      "subdomainPlaceholder": "ex. Réclamations, Poursuite de brevets",
      "loadingModels": "Chargement des modèles…",
      "loadingChatModels": "Chargement des modèles de discussion…",
      "enrichToggleTitle": "Enrichir les métadonnées avant la synthèse OWL",
      "enrichToggleDesc": "Utiliser un LLM pour développer les définitions et libellés avant la génération des classes.",
      "startBuildingButton": "Commencer la création",
      "backToBuilderAriaLabel": "Retour à Créer une ontologie avec l'IA",
      "ontologyBuilderFallback": "Générateur d'ontologie",
      "dataModelFallback": "Modèle de données",
      "chatEmptyLine1": "Votre entretien d'ontologie commence ici.",
      "chatEmptyLine2": "Examinez les questions de compétence proposées, puis acceptez celles auxquelles l'entreprise doit répondre.",
      "roleYou": "Vous",
      "roleAssistant": "Assistant",
      "workingStatus": "En cours…",
      "startingSessionStatus": "Démarrage de la session…",
      "synthesizingStatus": "Synthèse en cours",
      "chatInputPlaceholder": "Exprimez-vous librement — décrivez des questions métier, ou : tout accepter · suivant · continuer…",
      "expandSidePanel": "Développer le panneau latéral",
      "collapseSidePanel": "Réduire le panneau latéral",
      "reflectionHeading": "Réflexion et évaluation",
      "scoreFallback": "Score {{score}}",
      "addMoreQuestionsButton": "Ajouter d'autres questions d'ontologie",
      "registerLead": "Nommez l'ontologie et publiez-la dans le catalogue. Prévisualisez le graphe provisoire ci-dessous, puis confirmez le contrôle de profil avant l'enregistrement.",
      "graphReviewNudge": "Astuce : ouvrez OntoGraf ou Neo4j ci-dessus pour examiner la structure avant l'enregistrement.",
      "industryLabel": "Secteur",
      "registerToCatalogButton": "Enregistrer dans le catalogue",
      "resumingSession": "Reprise de la session d'ontologie…",
      "launchTitle": "Build an ontology",
      "launchTitleLead": "Créer des",
      "launchTitleAccent": "ontologies métier",
      "launchSubtitle": "Name it, pick a data model, and chat your way to a business ontology.",
      "nameYourOntology": "Name your ontology…",
      "dataModelPill": "Data model",
      "searchDataModels": "Search data models…",
      "pickDataModelHint": "Select a data model to continue",
      "noAiModelHint": "No AI model configured. Set one up in Admin.",
      "noDataModelsYet": "No data models yet",
      "createDataModel": "Create one",
      "settingsAria": "Settings",
      "settingsLocked": "Locked for this ontology",
      "aiModelLabel": "AI model",
      "reviewStyleLabel": "How to review questions",
      "modeReviewEach": "Ask me to review each question",
      "modeFillForMe": "Fill answers for me",
      "enrichDescriptions": "Enrich descriptions",
      "enrichmentModelLabel": "Enrichment model",
      "sameModel": "Same model",
      "openingLine": "Build {{name}} from {{model}}",
      "askQuestionPlaceholder": "Ask a question your ontology should answer…",
      "askChangePlaceholder": "Ask for a change or add another question…",
      "acceptRemaining": "Accept all ({{count}})",
      "buildOntology": "Build ontology",
      "buildReadyLead": "Your questions are ready. Build the ontology from them.",
      "rebuildReadyLead": "Questions changed since the last build. Rebuild to pick them up.",
      "rebuildOntology": "Rebuild ontology",
      "send": "Send",
      "questionsIntro": "Here are {{count}} questions your ontology should answer.",
      "questionsReviewed": "{{count}} questions reviewed · {{accepted}} accepted",
      "accept": "Accept",
      "drop": "Drop",
      "collapse": "Collapse",
      "undoQuestion": "Undo",
      "answerPlaceholder": "What should the answer be?",
      "questionAccepted": "Question accepted",
      "questionDropped": "Question dropped",
      "phaseBuilding": "Building your ontology…",
      "phaseConcepts": "Designing concepts…",
      "phaseLinks": "Linking relationships…",
      "phaseWriting": "Writing the ontology…",
      "phaseQuality": "Checking quality…",
      "buildFailed": "Couldn't build the ontology",
      "buildTakesAWhile": "This usually takes a few minutes. You can keep this tab open.",
      "buildEnginePhase": "The ontology engine is building this. For a large data model it can take 15 minutes or more.",
      "tryAgain": "Try again",
      "ontologyReady": "Ontology ready · {{concepts}} concepts · {{relationships}} relationships",
      "ontologyViewLabel": "Ontology view",
      "viewGraph": "Graph",
      "viewDraftPreview": "Preview",
      "viewOwl": "OWL",
      "earlierVersion": "Earlier version",
      "qualitySkipped": "Quality check was skipped",
      "qualityViolations": "{{count}} items may need a look",
      "qualityGaps": "A few gaps are still open",
      "tryAsking": "Try asking about {{hint}}",
      "details": "Details",
      "moreDetails": "More details",
      "registeredLine": "Registered {{name}} to your catalog.",
      "registeredQuiet": "This ontology is registered",
      "openOntology": "Open ontology",
      "buildAnother": "Build another",
      "moreActions": "More actions",
      "viewDataModel": "View data model",
      "deleteSession": "Delete session",
      "close": "Close"
    },
    "viewer": {
      "loadSummaryFailed": "Échec du chargement du résumé",
      "generatingSummary": "Génération du résumé de l'ontologie…",
      "retry": "Réessayer",
      "regenerateSummaryTitle": "Régénérer le résumé",
      "regenerateButton": "Régénérer",
      "classesLabel": "Classes",
      "objectPropsLabel": "Propriétés d'objet",
      "dataPropsLabel": "Propriétés de données",
      "individualsLabel": "Individus",
      "aboutThisOntology": "À propos de cette ontologie",
      "cachedSummary": "résumé en cache",
      "overview": "Aperçu",
      "noSummaryYet": "Aucun résumé disponible pour le moment. Utilisez Régénérer pour en créer un.",
      "propertiesLabel": "Propriétés",
      "moreCount": "+{{count}} de plus",
      "showLess": "Afficher moins",
      "tab": {
        "about": "À propos de l'ontologie",
        "ontograf": "OntoGraf",
        "neo4j-graph": "Graphe réseau",
        "object-properties": "Propriétés d'objet",
        "data-properties": "Propriétés de données",
        "annotation-properties": "Annotations",
        "individuals": "Individus",
        "compare": "Comparer"
      },
      "group": {
        "about": "À propos",
        "explore": "Explorer",
        "compare": "Comparer"
      },
      "ontologyNotFound": "Ontologie introuvable",
      "couldNotLoadOntology": "Impossible de charger l'ontologie",
      "backButton": "Retour",
      "noGraphData": "Aucune donnée de graphe disponible",
      "compareNeedsTwoVersions": "La comparaison de versions nécessite au moins deux versions dans cette famille.",
      "backToOntologies": "Ontologies",
      "builtWithAi": "Créé avec l'IA",
      "ontologyViewsAriaLabel": "Vues de l'ontologie",
      "viewGroupsAriaLabel": "Groupes de vues",
      "exploreViewsAriaLabel": "Vues d'exploration",
      "faqTitle": "FAQ",
      "configureFaqAriaLabel": "Configurer la FAQ",
      "exportTurtleTitle": "Exporter en Turtle",
      "classHierarchyAriaLabel": "Hiérarchie des classes",
      "expandClassHierarchy": "Développer la hiérarchie des classes",
      "showClassHierarchy": "Afficher la hiérarchie des classes",
      "collapseClassHierarchy": "Réduire la hiérarchie des classes",
      "collapseHierarchyPanel": "Réduire le panneau de hiérarchie",
      "askOntologyTitle": "Interroger l'ontologie",
      "askOntologySubtitle": "Interrogez les classes, propriétés et relations.",
      "askOntologyGreeting": "Posez des questions sur les classes, hiérarchies ou relations de cette ontologie.",
      "loading": "Chargement...",
      "name": "Nom",
      "domain": "Domaine",
      "range": "Plage",
      "characteristics": "Caractéristiques",
      "kind": {
        "object": "d'objet",
        "data": "de données",
        "annotation": "d'annotation"
      },
      "noPropertiesForClass": "Aucune propriété {{kind}} pour cette classe.",
      "noPropertiesFound": "Aucune propriété {{kind}} trouvée.",
      "iriLabel": "IRI",
      "unspecified": "(non spécifié)",
      "annotationsLabel": "Annotations",
      "typesLabel": "Types",
      "viewLabel": "Vue",
      "groupedByClass": "Groupé par classe",
      "flatList": "Liste à plat",
      "loadingIndividuals": "Chargement des individus…",
      "noIndividualsForClass": "Aucun individu pour cette classe.",
      "noIndividualsFound": "Aucun individu trouvé.",
      "dataPropertiesLabel": "Propriétés de données",
      "objectPropertiesLabel": "Propriétés d'objet"
    },
    "dataModels": {
      "cancel": "Annuler",
      "close": "Fermer",
      "description": "Description",
      "industryVertical": "Secteur d'activité",
      "modelName": "Nom du modèle",
      "nameInvalidChars": "Le nom du modèle ne peut contenir que des lettres, des chiffres, des espaces, des tirets et des underscores",
      "nameNeedsAlphanumeric": "Le nom du modèle doit contenir des caractères alphanumériques",
      "nameRequired": "Le nom du modèle est requis",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "selectIndustry": "Sélectionner un secteur",
      "status": {
        "draft": "brouillon",
        "published": "publié"
      },
      "createDialog": {
        "addColumn": "Ajouter une colonne",
        "addEntity": "Ajouter une entité",
        "back": "Retour",
        "columnNamePlaceholder": "nom_colonne",
        "columns": "Colonnes",
        "continue": "Continuer",
        "createFailed": "Impossible de créer le modèle de données",
        "createModel": "Créer le modèle",
        "createdSummary": "{{name}} a été créé en tant que brouillon avec {{count}} entités.",
        "createdSummaryWithColumns": "{{name}} a été créé en tant que brouillon avec {{count}} entités et {{columns}} colonnes.",
        "createdTitle": "Modèle de données créé",
        "creating": "Création en cours...",
        "descriptionPlaceholder": "Décrivez l'objectif et la portée de ce modèle de données...",
        "dimension": "dimension",
        "done": "Terminé",
        "duplicateEntityName": "Ce nom d'entité a déjà été ajouté",
        "enterModelName": "Saisissez un nom de modèle",
        "entityNameInvalidChars": "Le nom de l'entité ne peut contenir que des lettres, des chiffres et des underscores",
        "entityNameNeedsAlphanumeric": "Le nom de l'entité doit contenir des caractères alphanumériques",
        "entityNamePlaceholder": "Nom de l'entité (ex. Customer)",
        "fillOutField": "Veuillez remplir ce champ.",
        "foreignKey": "Clé étrangère",
        "missingIndustry": "Secteur manquant",
        "missingModelName": "Nom du modèle manquant",
        "modelNamePlaceholder": "ex. Modèle de données Retail commun",
        "modelNameRequired": "Nom du modèle *",
        "modelSummary": "Résumé du modèle",
        "needMoreEntities": "Ajoutez au moins 2 entités pour définir des relations.",
        "noColumnsYet": "Aucune colonne pour l'instant. Facultatif à la création — vous pouvez les ajouter plus tard dans la vue détaillée du modèle.",
        "noEntitiesYet": "Aucune entité ajoutée pour l'instant. Commencez à saisir ci-dessus pour ajouter des tables.",
        "nullable": "Nullable",
        "primaryKey": "Clé primaire",
        "removeColumn": "Supprimer la colonne",
        "removeEntity": "Supprimer {{name}}",
        "selectIndustryVertical": "Sélectionnez un secteur d'activité",
        "step1Desc": "Nom, secteur et description",
        "step1Label": "Informations de base",
        "step2Desc": "Ajouter des tables et des colonnes",
        "step2Intro": "Ajoutez des entités (tables), puis définissez les colonnes de chacune.",
        "step2Label": "Définir les entités",
        "step3Desc": "Définir les clés étrangères et les liens",
        "step3Intro": "Définissez les relations entre les entités.",
        "step3Label": "Relations",
        "step4Desc": "Valider et publier",
        "step4Label": "Vérifier et créer",
        "subtitle": "Définir un nouveau modèle de données d'entreprise",
        "summaryColumns": "Colonnes (nommées) :",
        "summaryEntities": "Entités :",
        "summaryIndustry": "Secteur :",
        "summaryName": "Nom :",
        "summaryRelationships": "Relations :",
        "title": "Créer un modèle de données",
        "typePlaceholder": "Type"
      },
      "detail": {
        "add": "Ajouter",
        "addColumnTitle": "Ajouter une colonne",
        "back": "Retour",
        "backToDataModels": "Retour aux modèles de données",
        "cardinality": "Cardinalité",
        "chooseBothTables": "Choisissez les deux tables",
        "columnNameRequired": "Le nom de la colonne est requis",
        "couldNotAddRelationship": "Impossible d'ajouter la relation",
        "couldNotApplyDdl": "Impossible d'appliquer le DDL",
        "couldNotDeleteColumn": "Impossible de supprimer la colonne",
        "couldNotDeleteRelationship": "Impossible de supprimer la relation",
        "couldNotLoadDdl": "Impossible de charger l'export DDL",
        "couldNotSaveColumn": "Impossible d'enregistrer la colonne",
        "couldNotUpdateRelationship": "Impossible de mettre à jour la relation",
        "dataType": "Type de données",
        "ddlCouldNotExportYet": "-- Impossible d'exporter le DDL pour le moment.\n",
        "ddlUnavailableLargeModel": "-- L'export DDL est disponible depuis le menu d'export pour les grands modèles.\n",
        "ddlValidationPassed": "Validation DDL réussie",
        "deleteColumnAria": "Supprimer la colonne {{name}}",
        "deleteColumnMessage": "Ceci supprime la colonne de l'entité du modèle de données.",
        "deleteColumnTitle": "Supprimer la colonne",
        "deleteRelationshipAria": "Supprimer la relation",
        "deleteRelationshipMessage": "Supprimer cette relation du modèle.",
        "deleteRelationshipTitle": "Supprimer la relation",
        "diagramExported": "Diagramme exporté",
        "drawioDownloaded": "Diagramme Draw.io téléchargé",
        "drawioExportFailed": "Échec de l'export Draw.io",
        "editColumnAria": "Modifier la colonne {{name}}",
        "editColumnTitle": "Modifier la colonne",
        "editRelationshipAria": "Modifier la relation",
        "editRelationshipTitle": "Modifier la relation",
        "exportFailed": "Échec de l'export",
        "fkColumnSource": "Colonne FK (source)",
        "foreignKeys": "Clés étrangères",
        "jsonSnapshotDownloaded": "Instantané JSON téléchargé",
        "modelNotFound": "Modèle introuvable",
        "modelUpdatedFromDdl": "Modèle mis à jour à partir du DDL",
        "name": "Nom",
        "noColumnsYet": "Aucune colonne pour l'instant. Ajoutez-en une pour définir cette entité.",
        "noDirectRelationships": "Aucune relation directe",
        "nothingToExport": "Rien à exporter",
        "nullableColumns": "Colonnes nullables",
        "optional": "facultatif",
        "optionalCapitalized": "Facultatif",
        "primaryKeys": "Clés primaires",
        "recordCount": "Nombre d'enregistrements",
        "relationshipAdded": "Relation ajoutée",
        "snapshotExportFailed": "Échec de l'export de l'instantané",
        "svgExportFailed": "Échec de l'export SVG",
        "svgExported": "SVG exporté",
        "tab": {
          "columns": "Colonnes",
          "relationships": "Relations",
          "stats": "Statistiques"
        },
        "tooManyTablesForImage": "Ce modèle comporte {{count}} tables — trop volumineux pour être rendu comme une image dans le navigateur. Utilisez plutôt « Exporter en Draw.io ».",
        "validation": "Validation",
        "validationFailed": "Échec de la validation",
        "viewMode": "Afficher",
        "modifyMode": "Modifier",
        "searchTablesPlaceholder": "Rechercher des tables et colonnes…",
        "filterErDiagramAriaLabel": "Filtrer le diagramme ER",
        "exportAsPng": "Exporter en PNG",
        "exportAsSvg": "Exporter en SVG",
        "exportJsonSnapshot": "Exporter l'instantané JSON",
        "exportAsDrawio": "Exporter en Draw.io",
        "relationshipButton": "Relation",
        "modelMetricsAriaLabel": "Métriques du modèle",
        "entitiesLabel": "Entités",
        "entAbbrev": "ent.",
        "relationshipsLabel": "Relations",
        "relAbbrev": "rel.",
        "totalRecordsLabel": "Total des enregistrements",
        "recAbbrev": "enr.",
        "linkedKpisLabel": "KPI liés",
        "kpiAbbrev": "KPI",
        "noEntitiesYet": "Aucune entité pour le moment",
        "noEntitiesDescription": "Appliquez le DDL à gauche ou importez un modèle pour remplir ce diagramme.",
        "askDataModelTitle": "Interroger le modèle de données",
        "askDataModelSubtitle": "Interroger les entités, colonnes et relations.",
        "askDataModelGreeting": "Posez des questions sur les tables, colonnes, relations ou statistiques de ce modèle de données.",
        "addRelationshipTitle": "Ajouter une relation",
        "addRelationshipSubtitle": "De → Vers · colonne FK facultative sur la table source",
        "fromTable": "Table source",
        "toTable": "Table cible",
        "selectEllipsis": "Sélectionner…",
        "fkColumnOnSource": "Colonne FK (source)",
        "optionalLowercase": "facultatif",
        "ddlRefreshTitle": "Remplacer l'éditeur par l'export du serveur",
        "ddlRefresh": "Actualiser",
        "ddlSwitchToModifyValidate": "Passez en mode Modifier pour valider",
        "ddlValidate": "Valider",
        "ddlSwitchToModifyApply": "Passez en mode Modifier pour appliquer",
        "ddlApply": "Appliquer"
      },
      "editDialog": {
        "invalidName": "Nom de modèle invalide",
        "saveChanges": "Enregistrer les modifications",
        "subtitle": "Mettre à jour le nom, le secteur et la description",
        "title": "Modifier le modèle de données",
        "updateFailed": "Impossible de mettre à jour le modèle de données",
        "updated": "Modèle de données mis à jour"
      },
      "importDialog": {
        "analyzing": "Analyse en cours...",
        "chooseFile": "Choisir un fichier",
        "chooseFiles": "Choisir des fichiers",
        "close": "Fermer",
        "createFromSampleData": "Créer à partir de données d'exemple",
        "createdSummary": "« {{name}} » créé : {{entities}} entités, {{columns}} colonnes, {{relationships}} relations.",
        "csvFilesLabel": "Fichiers CSV (un par table, jusqu'à 30)",
        "downloadSampleHint": "Téléchargez un fichier d'exemple pour voir la structure attendue",
        "excelWorkbook": "Classeur Excel",
        "fileLabel": "Fichier : {{name}} ({{size}} Ko)",
        "formatContent": "Contenu {{label}}",
        "import": "Importer",
        "importAsDataModel": "Importer en tant que modèle de données",
        "importFailed": "Échec de l'import",
        "importFailedTitle": "Échec de l'import",
        "importFormat": "Format d'import",
        "importSuccessful": "Import réussi",
        "importWithVisionModel": "Importer avec un modèle de vision",
        "importedSummary": "« {{name}} » importé : {{entities}} entités, {{columns}} colonnes, {{relationships}} relations.",
        "importing": "Import en cours...",
        "inferredModelNamePlaceholder": "Nom du modèle inféré",
        "loadSample": "Charger un exemple",
        "mediaFileTypes": "Fichier (PNG, JPEG, GIF, WebP, PDF, TXT, MD)",
        "mediaHelp": "Téléversez une capture d'écran de diagramme ER, un PDF exporté ou du texte non structuré. Le traitement utilise le modèle de votre tenant sur la plateforme {{brand}} ; les fichiers volumineux peuvent prendre quelques minutes.",
        "modelNameOptional": "Nom du modèle (facultatif)",
        "noFormatsAvailable": "Aucun format d'import disponible depuis le serveur.",
        "noImportModelConfigured": "Aucun modèle d'import configuré.",
        "noImportModelLlmHint": "Demandez à un administrateur de tenant d'ouvrir Admin → Paramètres généraux → Enterprise Ontology et de sélectionner un LLM avant d'utiliser cet onglet.",
        "noImportModelVisionHint": "Demandez à un administrateur de tenant d'ouvrir Admin → Paramètres généraux → Enterprise Ontology et de sélectionner un LLM capable de vision avant d'utiliser cet onglet.",
        "overrideTitleNoName": "Remplacer le titre si le fichier n'a pas de nom clair",
        "overrideTitlePlaceholder": "Remplacer le titre détecté automatiquement",
        "placeholderCsv": "Collez du CSV UTF-8 ou téléversez un .csv : soit tabulaire (ligne 1 = colonnes ; ligne 2 optionnelle = types), soit une grille de dictionnaire de données (Nom de table / Nom de colonne / Type de données / Clé primaire optionnelle / Table référencée).",
        "placeholderDbml": "Collez votre DBML (définitions de tables et lignes Ref)...",
        "placeholderDdl": "Collez vos instructions CREATE TABLE ici...",
        "placeholderDrawio": "Collez le contenu XML de votre Draw.io...",
        "placeholderJson": "Collez le JSON portable {{brand}} — le même format que Exporter le modèle de données → JSON portable (entités + relations).",
        "placeholderJsonSchema": "Collez votre JSON Schema avec les définitions...",
        "placeholderMermaid": "Collez votre bloc erDiagram...",
        "placeholderPlantuml": "Collez votre diagramme d'entités @startuml...",
        "placeholderXlsx": "Les imports Excel utilisent uniquement le téléversement de fichier. Chaque feuille est soit une table (ligne d'en-tête = colonnes), soit une grille de dictionnaire de données (lignes table/colonne/type), soit une feuille Relationships (Table source / Table cible / Colonne clé étrangère).",
        "sampleCsv": "Exemple CSV",
        "sampleHelp": "Téléversez un ou plusieurs fichiers CSV contenant des données d'exemple représentatives. Le système analyse les noms et valeurs des colonnes pour déduire les entités, les types de données, les clés primaires/étrangères et les relations entre tables.",
        "sampleXlsx": "Exemple XLSX",
        "subtitle": "Formats structurés, images et documents, ou déduction à partir de données CSV d'exemple",
        "tabMedia": "Images et documents",
        "tabSample": "À partir de données d'exemple",
        "tabStructured": "Formats structurés",
        "title": "Importer un modèle de données",
        "uploadFile": "Téléverser un fichier",
        "warningPrefix": "Avertissement :",
        "xlsxHelp": "Chaque feuille visible devient une ou plusieurs tables : les feuilles tabulaires utilisent la ligne 1 comme noms de colonnes ; les feuilles de dictionnaire de données (Nom de table + Nom de colonne + Type de données, Clé primaire / Table référencée / Cardinalité optionnelles) développent chaque ligne en une colonne logique. Utilisez une feuille Relationships (Table source, Table cible, Colonne clé étrangère, Cardinalité optionnelle) pour des relations explicites, ou indiquez la table référencée sur les lignes FK du dictionnaire. Les noms de feuilles de type instructions (README, Template, …) et ceux commençant par _ sont ignorés. Les FK restantes sont toujours déduites des noms de colonnes (par ex. store_sk → store) lorsque les cibles existent dans le classeur."
      },
      "industryTagDialog": {
        "subtitle": "Badge de catalogue et filtres pour {{name}}",
        "title": "Tags de secteur",
        "updateFailed": "Impossible de mettre à jour les tags de secteur",
        "updated": "Tags de secteur mis à jour"
      },
      "list": {
        "actionClone": "Cloner",
        "actionDelete": "Supprimer",
        "actionEdit": "Modifier",
        "actionIndustryTags": "Tags de secteur",
        "actionPublish": "Publier",
        "allCreators": "Tous les créateurs",
        "allIndustries": "Tous les secteurs",
        "clearSearch": "Effacer la recherche",
        "cloneFailed": "Impossible de cloner le modèle de données",
        "clonedAs": "Cloné sous « {{name}} »",
        "createDataModel": "Créer un modèle de données",
        "creator": "Créateur",
        "deleteDialogMessage": "Ceci supprime le modèle de données du catalogue. Les références KPI liées devront peut-être être mises à jour.",
        "deleteDialogTitle": "Supprimer le modèle de données",
        "deleteFailed": "Impossible de supprimer le modèle de données",
        "deleted": "Modèle de données supprimé",
        "emptyDescription": "Créez ou importez un modèle de données pour commencer.",
        "emptyTitle": "Aucun modèle de données pour l'instant",
        "entities": "entités",
        "exportFailed": "Impossible d'exporter le modèle de données",
        "filters": "Filtres",
        "import": "Importer",
        "industry": "Secteur",
        "kpis": "KPI",
        "loadFailed": "Échec du chargement des modèles de données",
        "loading": "Chargement des modèles de données…",
        "loadingMore": "Chargement d'autres modèles de données…",
        "loadingPrev": "Chargement des modèles de données précédents…",
        "noMatchDescription": "Essayez une autre recherche ou un autre filtre de secteur, ou créez un nouveau modèle.",
        "noMatchTitle": "Aucun modèle de données ne correspond",
        "publishFailed": "Publication impossible",
        "published": "Modèle de données publié",
        "refresh": "Actualiser",
        "refreshError": "Impossible d'actualiser le catalogue",
        "refreshList": "Actualiser la liste",
        "relationships": "relations",
        "searchPlaceholder": "Rechercher des modèles de données…",
        "statEntities": "Entités",
        "statLinkedKpis": "KPI liés",
        "statModels": "Modèles",
        "statPublished": "Publiés",
        "unableToLoad": "Impossible de charger le catalogue"
      },
      "erFlow": {
        "entityType": {
          "dimension": "dimension",
          "fact": "table de faits",
          "bridge": "pont",
          "aggregate": "agrégat"
        },
        "columnsCount": "{{count}} colonnes",
        "loadingEllipsis": "Chargement…",
        "showMore": "Afficher plus",
        "showLess": "Afficher moins",
        "resetViewTitle": "Réinitialiser la vue et les surbrillances",
        "resetView": "Réinitialiser la vue",
        "hintReadOnly": "Aperçu en lecture seule · Défiler pour naviguer · utiliser les boutons de zoom",
        "hintModify": "Modifier : faites glisser depuis le point droit d'une colonne (côté FK) vers le point gauche d'une colonne d'une autre table · ",
        "hintClickTable": "Cliquez sur une table pour voir les détails · ",
        "hintPanZoom": "Défiler pour naviguer · utiliser les boutons de zoom · glisser pour déplacer les tables"
      }
    },
    "optional": "Facultatif",
    "type": "Type",
    "kpiAllListView": "Tous les KPI",
    "kpiLibrary": {
      "all": "Tous",
      "allCollections": "Toutes les collections",
      "allDataTypes": "Tous les types de données",
      "allIndustries": "Tous les secteurs",
      "andMoreErrors": "... et {{count}} de plus",
      "askAboutKpis": "Poser une question sur les KPI",
      "backToFamilies": "Retour aux familles",
      "browseMode": "Mode de navigation",
      "cardActions": "Actions de la carte",
      "chatGreeting": "Posez des questions sur les noms de KPI, les définitions, les familles, les types de données ou les liens vers les modèles de données.",
      "chatSubtitleCollection": "Définitions et familles de cette collection.",
      "chatSubtitleFamily": "Définitions de cette famille.",
      "clearFiltersAndSearch": "Effacer les filtres et la recherche",
      "closeAria": "Fermer",
      "collection": "Collection",
      "collectionCardMenu": "Menu de la carte de collection",
      "collectionsView": "Vue des collections",
      "couldNotLoadCatalog": "Impossible de charger le catalogue",
      "createCollection": "Créer une collection",
      "createFamily": "Créer une famille",
      "createKpi": "Créer un KPI",
      "dataType": "Type de données",
      "delete": "Supprimer",
      "dismiss": "Ignorer",
      "editDetails": "Modifier les détails",
      "editLinkedDataModel": "Modifier le modèle de données lié",
      "enterpriseOntology": "Ontologie d’entreprise",
      "family": "Famille",
      "familiesCount": "{{count}} familles",
      "filters": "Filtres",
      "importCompleteLabel": "Importation terminée :",
      "importCreatedSkipped": "{{created}} créé(s), {{skipped}} ignoré(s)",
      "importCsv": "Importer un CSV",
      "industry": "Secteur",
      "industryTags": "Étiquettes de secteur",
      "internalIdNotePrefix": "ID interne",
      "internalIdNoteSuffix": "reste inchangé — les imports CSV et les liens ne seront pas rompus.",
      "kpiType": "Type de KPI",
      "kpisCount": "{{count}} KPI",
      "legacySuffix": "{{domain}} (ancien)",
      "linkDataModel": "Lier un modèle de données",
      "linkFamilyToModel": "Lier cette famille de KPI à un modèle de données de référence",
      "linkedDataModel": "Modèle de données lié",
      "linkedDataModelTooltip": "Modèle de données lié : {{name}}",
      "linkedModelFallback": "Modèle lié",
      "loadingLibrary": "Chargement de la bibliothèque de KPI...",
      "noCollectionsDesc": "Créez une collection ou importez un fichier CSV pour commencer.",
      "noCollectionsMatchTitle": "Aucune collection ne correspond à votre recherche",
      "noCollectionsTitle": "Aucune collection de KPI pour le moment",
      "noDataFound": "Aucune donnée trouvée",
      "noFamiliesDesc": "Créez une famille ou importez un fichier CSV pour commencer.",
      "noFamiliesMatchTitle": "Aucune famille ne correspond à votre recherche",
      "noFamiliesTitle": "Aucune famille de KPI dans cette collection",
      "noKpisMatch": "Aucun KPI ne correspond aux filtres. Essayez d’ajuster la recherche ou les filtres, ou importez des définitions.",
      "noMatchDesc": "Essayez un autre terme de recherche ou effacez les filtres.",
      "none": "Aucun",
      "precisionYes": "Précision (Oui)",
      "rename": "Renommer",
      "rowActions": "Actions de la ligne",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "searchPlaceholder": "Rechercher des collections, des familles, ou un nom, une définition, une description de KPI...",
      "selectCollection": "Sélectionner une collection...",
      "selectFamily": "Sélectionner une famille...",
      "selectIndustry": "Sélectionner un secteur…",
      "selectType": "Sélectionner un type...",
      "totalCollections": "Total des collections",
      "viewDetails": "Voir les détails",
      "viewKpiDetails": "Voir les détails du KPI",
      "columns": {
        "actions": "Actions",
        "costPositive": "Coût +",
        "dataType": "Type de données",
        "definition": "Définition",
        "description": "Description",
        "family": "Famille",
        "kpiName": "Nom du KPI",
        "kpiType": "Type de KPI",
        "precision": "Précision"
      },
      "createCollectionDialog": {
        "descriptionAlnumError": "La description doit contenir du texte valide et ne peut pas être composée uniquement de caractères spéciaux ou d’émojis",
        "descriptionPlaceholder": "Brève description de cette collection de KPI",
        "displayNameAlnumError": "Le nom d’affichage doit contenir au moins une lettre ou un chiffre",
        "displayNameCharsError": "Le nom d’affichage ne peut contenir que des lettres, des chiffres, des espaces, des tirets et des traits de soulignement",
        "displayNamePlaceholder": "p. ex. KPI de vente au détail",
        "displayNameRequired": "Nom d’affichage *",
        "nameAlnumError": "Le nom doit contenir au moins une lettre ou un chiffre",
        "nameCharsError": "Le nom ne peut contenir que des lettres, des chiffres et des traits de soulignement",
        "namePlaceholder": "p. ex. retail_kpis",
        "nameRequired": "Nom *",
        "title": "Créer une nouvelle collection"
      },
      "createFamilyDialog": {
        "collectionRequired": "Collection de KPI *",
        "displayNamePlaceholder": "KPI au niveau client",
        "displayNameRequired": "Nom d’affichage *",
        "namePlaceholder": "p. ex. COSMOS_CUSTOMER_LEVEL_KPIS",
        "nameRequired": "Nom *",
        "title": "Créer une nouvelle famille de KPI"
      },
      "createKpiDialog": {
        "collectionRequired": "Collection *",
        "costPositiveCheckbox": "Coût + (Oui/Non)",
        "create": "Créer un KPI",
        "dataTypePlaceholder": "string",
        "definitionPlaceholder": "Définition technique ou notes de calcul",
        "descriptionPlaceholder": "Résumé court",
        "familyRequired": "Famille *",
        "kpiNamePlaceholder": "p. ex. CUSTOMER_ATC_RATE",
        "kpiNameRequired": "Nom du KPI *",
        "precisionCheckbox": "Précision (Oui/Non)",
        "title": "Créer un nouveau KPI"
      },
      "collectionIndustryDialog": {
        "subtitle": "S’applique à « {{name}} » et à son apparence dans le catalogue de KPI.",
        "title": "Étiquettes de secteur de la collection"
      },
      "deleteCollectionDialog": {
        "message": "Cela supprime la collection ainsi que toutes les familles et définitions de KPI qu’elle contient. Tout projet de migration pointant vers cette collection verra sa cible de collection de KPI automatiquement réinitialisée.",
        "title": "Supprimer la collection de KPI"
      },
      "deleteFamilyDialog": {
        "message": "Voulez-vous vraiment supprimer « {{name}} » ? Cela supprimera également tous les KPI de cette famille et cette action est irréversible.",
        "title": "Supprimer la famille"
      },
      "deleteKpiDialog": {
        "message": "Voulez-vous vraiment supprimer « {{name}} » ? Cette action est irréversible.",
        "title": "Supprimer le KPI"
      },
      "detailPopup": {
        "closeAria": "Fermer",
        "costPositive": "Coût +",
        "dataType": "Type de données",
        "definition": "Définition",
        "description": "Description",
        "linkedModel": "Modèle lié",
        "no": "Non",
        "precision": "Précision",
        "tags": "Étiquettes",
        "yes": "Oui"
      },
      "domainDialog": {
        "missingIndustry": "Secteur manquant",
        "updateFailed": "Impossible de mettre à jour les étiquettes de secteur"
      },
      "editFamilyDialog": {
        "descriptionPlaceholder": "Décrivez ce que couvre cette famille de KPI…",
        "title": "Modifier la famille de KPI",
        "titleLabel": "Titre",
        "titlePlaceholder": "p. ex. KPI de revenus",
        "updateFailed": "Impossible de mettre à jour la famille"
      },
      "errors": {
        "createCollectionFailed": "Échec de la création de la collection",
        "createFamilyFailed": "Échec de la création de la famille",
        "createKpiFailed": "Échec de la création du KPI",
        "csvImportFailed": "Échec de l’importation du CSV",
        "deleteCollectionFailed": "Impossible de supprimer la collection de KPI",
        "deleteFamilyFailed": "Échec de la suppression de la famille",
        "deleteKpiFailed": "Échec de la suppression du KPI",
        "exportFailed": "Impossible d’exporter les KPI",
        "loadFailed": "Impossible de charger la bibliothèque de KPI."
      },
      "familyIndustryDialog": {
        "subtitle": "S’applique à « {{name}} ».",
        "title": "Étiquettes de secteur de la famille de KPI"
      },
      "importDialog": {
        "appliedToFamiliesNote": "Appliqué aux familles de KPI créées ou modifiées par cette importation.",
        "chooseCsvFile": "Choisir un fichier CSV",
        "close": "Fermer",
        "dataTypeHelp": "— par ex. string, decimal ; les valeurs omises sont déduites du nom et de la définition.",
        "definitionHelp": "— définition technique ;",
        "descriptionHelp": "— résumé court.",
        "domainHelp": "— domaine facultatif au niveau de la ligne (par défaut, le domaine d’importation).",
        "familyCreatedNote": "Les familles créées pendant l’importation seront placées dans cette collection. Par défaut « Default » si vide.",
        "familyDisplayHelp": "— affiché dans l’interface lors de la création ou de la mise à jour des familles.",
        "familyKpiHelp": "— identifiants stables pour le groupe de famille et le symbole de KPI.",
        "industryOptional": "Secteur (facultatif)",
        "kpiCollection": "Collection de KPI",
        "kpiTypeDefault": "(par défaut : indispensable).",
        "linkDataModelOptional": "Lier un modèle de données (facultatif)",
        "or": "ou",
        "or2": "(ou",
        "overridesDomainNote": "Remplace la colonne de domaine dans les lignes CSV individuelles.",
        "precisionCostHelp": ") — Oui/Non ; si omis, les deux valeurs par défaut sont Oui.",
        "requiredColumns": "Colonnes requises :",
        "title": "Importer des KPI depuis un CSV"
      },
      "linkDialog": {
        "noneHint": "Choisissez « Aucun » pour détacher cette famille de tout modèle ER. Agent Studio et les blueprints utilisent ce lien pour aligner les KPI avec les entités.",
        "referenceDataModel": "Modèle de données de référence",
        "subtitle": "Choisissez le modèle de données de référence pour « {{name}} ».",
        "title": "Lier la famille de KPI à un modèle de données",
        "updateFailed": "Impossible de mettre à jour le lien du modèle de données"
      },
      "renameCollectionDialog": {
        "displayName": "Nom d’affichage",
        "placeholder": "p. ex. KPI de vente au détail",
        "renameFailed": "Impossible de renommer la collection",
        "title": "Renommer la collection"
      },
      "toasts": {
        "collectionDeleted": "Collection de KPI supprimée",
        "collectionRenamed": "Collection renommée",
        "dataModelLinkRemoved": "Lien du modèle de données supprimé",
        "dataModelLinked": "Modèle de données lié",
        "familyUpdated": "Famille mise à jour",
        "industryTagsUpdated": "Étiquettes de secteur mises à jour"
      },
      "createCollectionButton": "Créer une collection",
      "importCsvButton": "Importer un CSV"
    },
    "dataStudio": {
      "list": {
        "newPipeline": "Nouveau pipeline",
        "typeLabel": "Type",
        "statusLabel": "Statut",
        "allTypes": "Tous les types",
        "allStatus": "Tous les statuts",
        "columnPipeline": "Pipeline",
        "columnType": "Type",
        "columnStatus": "Statut",
        "columnRoute": "Source → cible",
        "columnSchedule": "Planification",
        "columnUpdated": "Mis à jour",
        "columnActions": "Actions",
        "actionOpen": "Ouvrir",
        "actionDelete": "Supprimer",
        "deleteDialogTitle": "Supprimer le pipeline",
        "deleteDialogMessage": "Le pipeline sera retiré de Data Studio. Cette action est irréversible.",
        "deleted": "Pipeline \"{{name}}\" supprimé",
        "deleteFailed": "Impossible de supprimer le pipeline",
        "migrationLinkTitle": "Depuis la migration : {{id}}",
        "migrationLinkText": "Migration",
        "statsPipelines": "Pipelines",
        "emptyNoPipelines": "Rien dans Data Studio pour l'instant. Les pipelines sont généralement promus depuis des projets de migration terminés ou créés via « Nouveau pipeline » ci-dessus.",
        "emptyNoMatches": "Aucune entrée ne correspond aux filtres. Ajustez vos critères de recherche ou de filtrage.",
        "filtersTitle": "Filtres",
        "searchPlaceholder": "Rechercher dans le catalogue...",
        "loadErrorTitle": "Échec du chargement du catalogue Data Studio",
        "retry": "Réessayer"
      },
      "status": {
        "pending": "En attente",
        "terminating": "En cours d'arrêt"
      },
      "createDialog": {
        "title": "Créer un pipeline",
        "subtitleChoose": "Choisissez un type de pipeline pour commencer",
        "subtitleMode": "Pipeline {{mode}}",
        "steps": {
          "type": {
            "label": "Type de pipeline",
            "description": "Choisir le mode du pipeline"
          },
          "sourceTarget": {
            "label": "Source et cible",
            "description": "Sélectionner les points de terminaison"
          },
          "configuration": {
            "label": "Configuration",
            "description": "Planification et options"
          },
          "review": {
            "label": "Vérification",
            "description": "Confirmer et créer"
          }
        },
        "modes": {
          "migrate": {
            "label": "Migrer",
            "description": "Migration assistée par IA — ouvre Migrations Studio"
          },
          "orchestrator": {
            "label": "Workflow d'orchestrateur",
            "description": "Concepteur DAG visuel — déploiement vers Databricks, Vertex AI ou Airflow"
          },
          "map": {
            "label": "Mapper",
            "description": "Mappage au niveau des champs entre les schémas source et cible"
          },
          "transform": {
            "label": "Transformer",
            "description": "Appliquer des transformations SQL ou Python pendant le transfert"
          },
          "custom": {
            "label": "Personnalisé",
            "description": "Pipeline entièrement configurable avec éditeur de code"
          }
        },
        "createdTitle": "Pipeline créé",
        "createdDesc": "{{name}} ({{mode}}) enregistré comme brouillon.",
        "pipelineNameLabel": "Nom du pipeline",
        "pipelineNamePlaceholder": "ex. {{source}} → {{target}} {{mode}}",
        "sourceSystemLabel": "Système source",
        "sourceSystemPlaceholder": "ex. Postgres prod, Snowflake DWH",
        "targetDestinationLabel": "Destination cible",
        "targetDestinationPlaceholder": "ex. BigQuery curated, S3 lake",
        "modeSuffix": "Mode {{mode}}",
        "change": "Modifier",
        "scheduleLabel": "Planification",
        "scheduleSelectPlaceholder": "Sélectionner une planification",
        "batchSizeLabel": "Taille du lot",
        "retryOnFailureLabel": "Réessayer en cas d'échec",
        "retryEnabled": "Activé (3 tentatives)",
        "retryDisabled": "Désactivé",
        "transformationSqlLabel": "SQL de transformation",
        "customPipelineCodeLabel": "Code de pipeline personnalisé",
        "transformSqlPlaceholder": "SELECT\n  customer_id,\n  SUM(amount) as total_spend,\n  COUNT(*) as txn_count\nFROM source_table\nGROUP BY customer_id",
        "customCodePlaceholder": "# Logique de pipeline personnalisée\nimport pandas as pd\n\ndef transform(df):\n    return df",
        "summaryTitle": "Résumé du pipeline",
        "summaryName": "Nom :",
        "summaryType": "Type :",
        "summarySchedule": "Planification :",
        "summaryBatchSize": "Taille du lot :",
        "summaryRetry": "Nouvelle tentative :",
        "retryAttempts": "3 tentatives",
        "back": "Retour",
        "done": "Terminé",
        "continue": "Continuer",
        "creating": "Création…",
        "createPipeline": "Créer le pipeline"
      },
      "detail": {
        "configured": "Configuré",
        "error": "Erreur",
        "start": "DÉBUT",
        "end": "FIN",
        "sourceNodeType": "Source",
        "targetNodeType": "Cible",
        "extractNodeLabel": "Extraction et validation",
        "parserNodeType": "Analyseur",
        "notFoundTitle": "Pipeline introuvable",
        "backToPipelines": "Retour aux pipelines",
        "typeLabel": "Type",
        "batchSizeLabel": "Taille du lot",
        "retryOnFailureLabel": "Réessayer en cas d'échec",
        "updatedLabel": "Mis à jour",
        "yes": "Oui",
        "no": "Non",
        "transformationSqlLabel": "SQL de transformation",
        "customCodeLabel": "Code personnalisé"
      }
    }
  },
  "pipelineDesigner": {
    "list": {
      "searchPlaceholder": "Rechercher des designs...",
      "emptyMessage": "Aucun workflow d'orchestrateur pour le moment",
      "newWorkflow": "Nouveau workflow d'orchestrateur",
      "columnName": "Nom",
      "columnDescription": "Description",
      "columnStatus": "Statut",
      "columnUpdatedAt": "Mis à jour le",
      "columnCreatedAt": "Créé le",
      "columnActions": "Actions",
      "actionEdit": "Modifier",
      "actionDelete": "Supprimer",
      "createFailed": "Échec de la création du design",
      "deleteFailed": "Échec de la suppression du design",
      "deletedToast": "Design « {{name}} » supprimé",
      "filterStatusLabel": "Statut",
      "deleteDialogTitle": "Supprimer le design",
      "deleteDialogMessage": "Voulez-vous vraiment supprimer « {{name}} » ? Cette action est irréversible.",
      "deleteDialogConfirm": "Supprimer le design",
      "cancel": "Annuler"
    },
    "status": {
      "draft": "Brouillon",
      "published": "Publié",
      "pending": "En attente",
      "running": "En cours",
      "success": "Réussi",
      "failed": "Échoué",
      "cancelled": "Annulé",
      "terminating": "Arrêt en cours",
      "timed_out": "Délai dépassé",
      "unknown": "Inconnu"
    },
    "canvas": {
      "loading": "Chargement du design...",
      "tabCanvas": "Canevas",
      "tabRuns": "Exécutions",
      "tabSettings": "Paramètres",
      "publishButton": "Publier et exécuter",
      "publishDisabledTitle": "Choisissez une connexion d'orchestrateur dans l'onglet Paramètres pour publier.",
      "settingsTitle": "Paramètres du design",
      "orchestratorRuntimeTitle": "Environnement d'exécution de l'orchestrateur",
      "orchestratorRuntimeDesc": "La publication nécessite une connexion d'orchestrateur du locataire correspondant au type cible. Les identifiants sont résolus via le connecteur, pas stockés dans le graphe.",
      "targetOrchestratorLabel": "Orchestrateur cible",
      "saveFailed": "Échec de l'enregistrement du design",
      "validationFailed": "Échec de la validation du design",
      "publishFailed": "Échec de la publication"
    },
    "createDialog": {
      "title": "Nouveau workflow d'orchestrateur",
      "closeAria": "Fermer la boîte de dialogue",
      "nameLabel": "Nom du design",
      "namePlaceholder": "p. ex. nightly-feature-batch",
      "descriptionLabel": "Description (facultatif)",
      "descriptionPlaceholder": "Résumé court pour le catalogue",
      "orchestratorLabel": "Orchestrateur cible",
      "orchestratorHint": "Publier et exécuter utilise aujourd'hui le publisher Enterprise Ontology pour Databricks Workflows. Vertex AI et Airflow sont prévus.",
      "cancel": "Annuler",
      "create": "Créer",
      "creating": "Création…"
    },
    "publishDialog": {
      "title": "Publier et exécuter",
      "selectConnectionWarning": "Sélectionnez une <1>connexion d'orchestrateur</1> dans l'onglet Paramètres avant de publier. La couche d'exécution résout les identifiants via ce connecteur.",
      "translateJobText": "Cette action traduira <1>{{designName}}</1> en une tâche <2>{{orchestratorType}}</2>, la créera et déclenchera immédiatement une exécution.",
      "notebookParamsLabel": "Paramètres du notebook (JSON facultatif)",
      "cancel": "Annuler",
      "publish": "Publier et exécuter",
      "publishing": "Publication en cours...",
      "orchestratorFallback": "orchestrateur"
    },
    "nodeConfig": {
      "nodeTitle": "Nœud {{type}}",
      "noConfigurableProps": "Ce nœud n'a aucune propriété configurable.",
      "taskConfigTitle": "Configuration de la tâche",
      "labelLabel": "Libellé",
      "labelPlaceholder": "Nom de la tâche",
      "notebookPathLabel": "Chemin du notebook",
      "notebookPathPlaceholder": "/notebooks/my_notebook.py",
      "notebookPathHint": "Chemin relatif à la racine du dépôt Git.",
      "timeoutLabel": "Délai d'expiration (secondes)",
      "maxRetriesLabel": "Nombre maximal de tentatives",
      "retryOnTimeoutLabel": "Réessayer en cas d'expiration"
    },
    "canvasEditor": {
      "addTask": "Ajouter une tâche",
      "saveNow": "Enregistrer maintenant",
      "allChangesSaved": "Toutes les modifications sont enregistrées",
      "saving": "Enregistrement…",
      "saveFailedUseSaveNow": "Échec de l'enregistrement — utilisez Enregistrer maintenant",
      "unsavedWillAutoSave": "Non enregistré — sera enregistré automatiquement",
      "delete": "Supprimer",
      "newTaskLabel": "Nouvelle tâche"
    },
    "gitSource": {
      "title": "Source Git",
      "repoUrlLabel": "URL du dépôt",
      "repoUrlPlaceholder": "https://github.com/org/repo",
      "providerLabel": "Fournisseur",
      "branchLabel": "Branche",
      "branchPlaceholder": "main",
      "branchError": "Saisissez un nom de branche valide (lettres, chiffres, /, -, _, . uniquement)."
    },
    "runs": {
      "noRuns": "Aucune exécution pour le moment. Publiez le design pour créer une exécution.",
      "colStatus": "Statut",
      "colRunId": "ID d'exécution",
      "colStarted": "Démarré",
      "colDuration": "Durée",
      "colExternal": "Externe",
      "colActions": "Actions",
      "runningLabel": "En cours...",
      "view": "Voir",
      "cancel": "Annuler"
    },
    "runDetail": {
      "loading": "Chargement des détails de l'exécution...",
      "title": "Détail de l'exécution",
      "runId": "ID d'exécution",
      "externalRunId": "ID d'exécution externe",
      "started": "Démarré",
      "completed": "Terminé",
      "viewInOrchestrator": "Voir dans l'orchestrateur",
      "cancelling": "Annulation...",
      "cancelRun": "Annuler l'exécution",
      "taskStates": "États des tâches"
    },
    "orchestratorConnection": {
      "label": "Connexion de l'orchestrateur",
      "loadingConnections": "Chargement des connexions…",
      "optionalSelectToEnable": "Facultatif — sélectionner pour activer Publier et exécuter",
      "noConnections": "Aucune connexion pour ce type d'orchestrateur.",
      "addOneLink": "Ajoutez-en une sous Connexions → Orchestrateurs"
    },
    "nodes": {
      "start": "Début",
      "end": "Fin",
      "untitledTask": "Tâche sans titre"
    }
  },
  "agentStudio": {
    "selfHeal": {
      "llmModel": "Modèle LLM",
      "llmModelPlaceholder": "Sélectionner un modèle",
      "llmModelEmpty": "Aucun modèle LLM n'est configuré pour ce projet.",
      "llmModelSearch": "Rechercher des modèles",
      "analysis": {
        "engineLabel": "Moteur d'analyse",
        "engineModel": "{{model}}",
        "engineModelFallback": "Modèle sélectionné",
        "engineRules": "Basé sur des règles",
        "engineFallback": "Repli (basé sur des règles)",
        "fallbackTitle": "Modèle indisponible",
        "fallbackNotice": "Le modèle « {{model}} » a échoué ({{reason}}). Les résultats proviennent de l'analyse standard basée sur des règles.",
        "fallbackNoticeUnnamed": "Le modèle sélectionné a échoué ({{reason}}). Les résultats proviennent de l'analyse standard basée sur des règles.",
        "reasonAuthFailed": "clé API refusée",
        "reasonRateLimited": "limite de débit atteinte",
        "reasonTimeout": "la requête a expiré",
        "reasonMisconfigured": "le modèle n'est pas disponible pour ce projet",
        "reasonInvalidModel": "la sélection du modèle est invalide",
        "reasonInvalidJson": "la réponse n'a pas pu être lue",
        "reasonUnusable": "le modèle n'a renvoyé aucune recommandation exploitable",
        "reasonUnavailable": "le modèle est injoignable"
      }
    },
    "loading": "Chargement du studio d'agents...",
    "permissionDeniedMessage": "Vous n'êtes pas autorisé à consulter cette page. Veuillez contacter votre administrateur.",
    "untitledAgent": "Agent sans titre",
    "fallbackAgentName": "Agent",
    "ok": "OK",
    "closeDialogAriaLabel": "Fermer la boîte de dialogue",
    "list": {
      "columnAgentName": "Nom de l'agent",
      "columnProject": "Projet",
      "columnVersion": "Version",
      "columnStatus": "Statut",
      "columnCreator": "Créateur",
      "columnCreatedAt": "Créé le",
      "columnUpdatedAt": "Mis à jour le",
      "columnActions": "Actions",
      "registeredToRegistryTitle": "Enregistré dans le registre",
      "emptyFavorites": "Aucun agent favori — ajoutez des étoiles dans la liste pour les marquer",
      "emptyArchived": "Aucun agent archivé",
      "emptyDefault": "Aucun agent trouvé",
      "filterFavoritesTitle": "Filtrer par favoris",
      "allAgents": "Tous les agents",
      "favorites": "Favoris",
      "catalogTitle": "Catalogue d'agents",
      "activeAgentsTitle": "Agents actifs",
      "archivedAgentsTitle": "Agents archivés",
      "guidedTourTitle": "Visite guidée du studio d'agents",
      "autoTune": "Auto Tune",
      "createAgent": "Créer un agent",
      "exportSelected": "Exporter la sélection",
      "archiveSelected": "Archiver la sélection",
      "exportFileName": "Agent_Studio",
      "exportFileNameArchived": "Agent_Studio_Archive"
    },
    "filters": {
      "status": "Statut",
      "registryStatus": "Statut du registre",
      "draft": "Brouillon",
      "published": "Publié",
      "registered": "Enregistré",
      "unregistered": "Non enregistré",
      "project": "Projet",
      "creator": "Créateur"
    },
    "actions": {
      "restoreToDraft": "Restaurer en brouillon",
      "view": "Voir",
      "chat": "Chat",
      "traces": "Traces",
      "logs": "Journaux",
      "exportYaml": "Exporter (YAML)",
      "exportJson": "Exporter (JSON)",
      "evaluate": "Évaluer",
      "viewEvaluationRuns": "Voir les exécutions d'évaluation",
      "registerToRegistry": "Enregistrer dans le registre",
      "registrationPending": "Enregistrement en attente",
      "unregisterFromRegistry": "Retirer du registre",
      "clone": "Cloner",
      "archive": "Archiver"
    },
    "backLabels": {
      "traces": "Traces",
      "blueprint": "Blueprint"
    },
    "publishDialog": {
      "title": "Publier l'agent",
      "confirmHeading": "Voulez-vous vraiment publier ?",
      "confirmDescription": "La publication rend cet agent disponible à l'utilisation. Cette action peut être annulée en archivant l'agent.",
      "agentLabel": "Agent :",
      "frameworkLabel": "Framework :",
      "nodesLabel": "Nœuds :",
      "publishButton": "Publier l'agent"
    },
    "archiveDialog": {
      "title": "Archiver l'agent",
      "publishedHeading": "Cet agent est publié",
      "publishedDescription": "Pour archiver, retirez d'abord toute fiche Agent Store, archivez les déploiements dans Monitoring et désinscrivez l'agent du registre s'il est encore enregistré. L'agent sera déplacé dans la liste Archivés une fois ces étapes terminées.",
      "confirmMessage": "Voulez-vous vraiment archiver « {{name}} » ?",
      "checkingDependencies": "Vérification des dépendances…",
      "archiveButton": "Archiver l'agent",
      "draftConfirmMessage": "Archiver « {{name}} » ? Il apparaîtra sous Archivés ; vous pourrez le restaurer en brouillon ou le supprimer définitivement."
    },
    "deleteDialog": {
      "title": "Supprimer l'agent",
      "confirmMessage": "Supprimer définitivement « {{name}} » ? L'agent sera retiré du système et cette action est irréversible."
    },
    "bulkArchive": {
      "title_one": "Archiver l'agent",
      "title_other": "Archiver les agents",
      "confirmMessage": "Archiver {{count}} agent(s) ? Ils apparaîtront sous Archivés ; vous pourrez les restaurer en brouillons ou les supprimer définitivement.",
      "confirmButton": "Archiver",
      "failureMessage": "Échec de l'archivage des agents",
      "blockedMessage": "« {{name}} » a des dépendances à résoudre avant l'archivage."
    },
    "blockedDialogs": {
      "cannotArchiveTitle": "Impossible d'archiver l'agent pour le moment",
      "cannotUnregisterTitle": "Impossible de retirer du registre pour le moment",
      "unregisterDependenciesMessage": "Retirez les fiches Agent Store et archivez les déploiements avant de retirer cet agent du registre.",
      "dependenciesMustBeCleared": "Les dépendances doivent d'abord être résolues."
    },
    "registerDialog": {
      "title": "Enregistrer dans le registre",
      "submitHeading": "Soumettre pour approbation admin",
      "submitDescription": "Cela envoie une demande d'enregistrement aux administrateurs du tenant. L'agent n'apparaîtra dans le registre qu'après approbation sous Paramètres généraux → Approbations des demandes.",
      "confirmMessage": "Soumettre une demande d'enregistrement pour « {{name}} » ?",
      "metadata": "Métadonnées",
      "submitting": "Envoi en cours...",
      "submitRequest": "Soumettre la demande"
    },
    "deletePrerequisites": {
      "stillRegistered": "Cet agent est encore enregistré dans le registre.",
      "activeStoreListing": "Il existe une fiche Agent Store active pour cet agent.",
      "nonArchivedDeployments": "Des déploiements d'agent ne sont pas encore archivés.",
      "clearBeforeArchive": "{{details}} Résolvez ces éléments avant de pouvoir archiver."
    },
    "blockerMessages": {
      "registry": "Désinscrivez cet agent du registre avant de l'archiver.",
      "agent_store": "Retirez la fiche Agent Store active avant d'archiver cet agent.",
      "agent_deployments": "Archivez tous les déploiements de cet agent dans Monitoring avant de l'archiver.",
      "agent_store_unregister": "Retirez la fiche Agent Store active avant de retirer cet agent du registre.",
      "agent_deployments_unregister": "Archivez tous les déploiements dans Monitoring avant de retirer cet agent du registre."
    },
    "blockerNav": {
      "registry": "Ouvrir le registre d'agents",
      "workflow_registry": "Ouvrir le registre de workflows",
      "agent_store": "Ouvrir l'Agent Store (gérer)",
      "agent_deployments": "Ouvrir Monitoring — Déploiements",
      "workflow_store": "Ouvrir le Workflow Store (gérer)",
      "workflow_deployments": "Ouvrir Monitoring — Déploiements",
      "running_executions": "Ouvrir les exécutions"
    }
  },
  "projects": {
    "status": {
      "active": "Actif",
      "draft": "Brouillon",
      "archived": "Archivé",
      "error": "Erreur",
      "pending": "En attente"
    },
    "list": {
      "permissionDeniedMessage": "Vous n'êtes pas autorisé à consulter les projets. Veuillez contacter votre administrateur.",
      "loading": "Chargement des projets...",
      "columnName": "Nom du projet",
      "columnMembers": "Membres",
      "columnStatus": "Statut",
      "columnActions": "Actions",
      "filterCreatorLabel": "Créateur",
      "actionOpen": "Ouvrir",
      "actionConfigure": "Configurer",
      "actionEdit": "Modifier",
      "actionDelete": "Supprimer",
      "bulkDeleteSelected": "Supprimer la sélection",
      "emptyMessage": "Aucun projet trouvé",
      "createProject": "Créer un projet",
      "setupWizard": "Assistant de configuration",
      "setupWizardTooltip": "Assistant de configuration – Importer des fichiers YAML pour créer un projet",
      "deleteDialogTitle": "Supprimer le projet",
      "deleteDialogMessage": "Voulez-vous vraiment supprimer « {{name}} » ? Cette action est irréversible.",
      "fetchingDependenciesMessage": "Récupération des dépendances du projet…",
      "forceDeleteDialogTitle": "Confirmer la suppression forcée",
      "forceDeleteDialogMessage": "La suppression forcée supprimera définitivement « {{name}} » ainsi que tous les agents, déploiements, fiches Agent Store, simulations, prompts, compétences, outils et autres données du projet. Cette action est irréversible.",
      "forceDeleteConfirmLabel": "Forcer la suppression du projet",
      "bulkDeleteDialogTitle": "Supprimer les projets sélectionnés",
      "bulkDeleteConfirmMessage_one": "Voulez-vous vraiment supprimer {{count}} projet ? Cette action est irréversible.",
      "bulkDeleteConfirmMessage_other": "Voulez-vous vraiment supprimer {{count}} projets ? Cette action est irréversible.",
      "bulkDeleteConfirmLabel_one": "Supprimer {{count}} projet",
      "bulkDeleteConfirmLabel_other": "Supprimer {{count}} projets",
      "forceDeleteSuccessToast": "Le projet « {{name}} » a été supprimé de force",
      "forceDeleteErrorToast": "Échec de la suppression forcée. Supprimez les dépendances restantes ou réessayez.",
      "noProjectsSelectedWarning": "Aucun projet sélectionné",
      "bulkDeletePartialWarning": "{{deleted}} projet(s) supprimé(s), {{skipped}} échoué(s) : {{errors}}",
      "bulkDeleteSuccessToast": "{{deleted}} projet(s) supprimé(s) avec succès",
      "bulkDeleteErrorToast": "Échec de la suppression des projets",
      "andOthers": "et {{count}} autres"
    },
    "createDialog": {
      "title": "Créer un nouveau projet",
      "closeAriaLabel": "Fermer la boîte de dialogue",
      "loadingQuota": "Chargement du quota...",
      "quotaLabel": "Projets",
      "nameLabel": "Nom du projet *",
      "namePlaceholder": "Saisir le nom du projet",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Brève description du projet",
      "descriptionEmojiError": "La description ne peut pas contenir d'emoji. Utilisez uniquement du texte brut.",
      "quotaExceededTitle": "Quota de projets dépassé",
      "creating": "Création en cours..."
    },
    "editDialog": {
      "title": "Modifier le projet",
      "closeAriaLabel": "Fermer la boîte de dialogue",
      "nameLabel": "Nom du projet *",
      "descriptionLabel": "Description",
      "saving": "Enregistrement...",
      "saveChanges": "Enregistrer les modifications"
    },
    "actions": {
      "view": "Afficher",
      "edit": "Modifier",
      "chat": "Discussion",
      "traces": "Traces",
      "logs": "Journaux",
      "evaluate": "Évaluer",
      "viewEvaluationRuns": "Voir les exécutions d'évaluation",
      "cloneInAgentStudio": "Cloner dans Agent Studio",
      "openInAgentStudio": "Ouvrir dans Agent Studio",
      "manageArchiveInStudio": "Gérer les archives dans Studio",
      "open": "Ouvrir",
      "runs": "Exécutions",
      "editCanvas": "Modifier le canevas",
      "viewInStudio": "Afficher dans Studio",
      "testChat": "Tester / Discussion",
      "deployInRegistry": "Déployer dans Registry",
      "guardrails": "Garde-fous",
      "chatDetail": "Discussion / détail",
      "runtimeSettings": "Paramètres d'exécution",
      "openInMonitoring": "Ouvrir dans Monitoring"
    },
    "detail": {
      "notFound": "Projet introuvable",
      "backToProjectsButton": "Retour aux projets",
      "backToProjectsAriaLabel": "Retour aux projets",
      "viewOnlyBadge": "Lecture seule",
      "tabsAriaLabel": "Onglets des détails du projet",
      "tabs": {
        "overview": "Aperçu",
        "agents": "Agents",
        "workflows": "Workflows",
        "registry": "Registre",
        "evals": "Évaluations",
        "deployments": "Déploiements"
      }
    },
    "overview": {
      "hubSubtitle": "Centre du projet",
      "noTabsAvailable": "Aucun onglet de détails n'est disponible pour votre rôle.",
      "openInBrand": "Ouvrir {{label}} dans {{brand}}",
      "cards": {
        "agents": "Agents",
        "workflows": "Workflows",
        "registry": "Enregistrés",
        "evals": "Agents d'évaluation",
        "deployments": "Déploiements actifs"
      }
    },
    "members": {
      "title": "Membres",
      "refreshTooltip": "Actualiser la liste des membres",
      "addMemberButton": "Ajouter un membre",
      "selectedCount": "{{count}} sélectionné(s)",
      "changeRoleButton": "Changer le rôle",
      "remove": "Retirer",
      "clearButton": "Effacer",
      "selectAllButton": "Tout sélectionner",
      "noMembersYet": "Aucun membre pour le moment",
      "selectAll": "Tout sélectionner",
      "deselectAll": "Tout désélectionner",
      "unknown": "Inconnu",
      "creatorBadge": "Créateur",
      "role": {
        "member": "Membre",
        "admin": "Admin",
        "viewer": "Lecteur",
        "creator": "Créateur"
      },
      "memberSince": "Membre depuis {{date}}",
      "changeRoleTitle": "Changer le rôle",
      "memberFallbackName": "membre",
      "select": "Sélectionner",
      "deselect": "Désélectionner",
      "removeMembersTitle": "Retirer des membres",
      "removeMemberTitle": "Retirer le membre",
      "removeMembersMessage": "Voulez-vous vraiment retirer {{count}} membre(s) de ce projet ? Cette action est irréversible.",
      "removeMemberMessage": "Voulez-vous vraiment retirer « {{name}} » de ce projet ? Cette action est irréversible.",
      "changeRoleForCount_one": "Changer le rôle de {{count}} membre",
      "changeRoleForCount_other": "Changer le rôle de {{count}} membres",
      "selectNewRoleLabel": "Sélectionner le nouveau rôle",
      "updating": "Mise à jour...",
      "updateRole": "Mettre à jour le rôle",
      "loadErrorFallback": "Impossible de charger les membres. Veuillez actualiser la page.",
      "selectAtLeastOneUserError": "Veuillez sélectionner au moins un utilisateur",
      "addedSuccessToast_one": "{{count}} membre ajouté avec succès",
      "addedSuccessToast_other": "{{count}} membres ajoutés avec succès",
      "removedSuccessToast": "Membre retiré avec succès",
      "roleUpdatedSuccessToast": "Rôle du membre mis à jour avec succès",
      "bulkRoleUpdatedWithErrorsToast": "{{updated}} membres mis à jour. {{errorCount}} erreurs se sont produites.",
      "bulkRoleUpdatedSuccessToast": "{{updated}} rôle(s) de membre mis à jour avec succès",
      "bulkRemovedWithErrorsToast": "{{removed}} membres retirés. {{errorCount}} erreurs se sont produites.",
      "bulkRemovedSuccessToast": "{{removed}} membre(s) retiré(s) avec succès"
    },
    "configure": {
      "tabsAriaLabel": "Onglets de configuration du projet",
      "tabs": {
        "members": "Membres",
        "orchestrators": "Orchestrateurs",
        "prompts": "Prompts",
        "models": "Modèles",
        "tools": "Outils",
        "skills": "Compétences",
        "knowledge": "Connaissances",
        "graph": "Graphe",
        "vector": "Vecteur",
        "storage": "Stockage"
      }
    },
    "setupWizard": {
      "title": "Assistant de configuration du projet",
      "projectFieldLabel": "Projet",
      "projectFieldPlaceholder": "Sélectionner un projet...",
      "projectFieldRequiredLabel": "Projet *",
      "projectNameFieldName": "Nom du projet",
      "projectNameFieldRequiredLabel": "Nom du projet *",
      "projectNamePlaceholder": "Mon super projet",
      "orDivider": "ou",
      "createNewProject": "Créer un nouveau projet",
      "descriptionFieldLabel": "Description",
      "descriptionPlaceholder": "Brève description...",
      "filesImportedIntoSelectedProject": "Les fichiers seront importés dans le projet sélectionné",
      "dropzoneAriaLabel": "Importer des fichiers YAML. Glissez-déposez des fichiers ici, ou cliquez ou appuyez sur Entrée ou Espace pour parcourir.",
      "dropzoneText": "Déposez les fichiers ici ou cliquez pour parcourir",
      "dropzoneHint": ".yaml, .yml — agents, modèles, outils, invites, compétences, connaissances, connecteurs, IAM",
      "validFilesCount": "{{count}} fichier(s) valide(s)",
      "filesWithErrorsCount": "{{count}} avec des erreurs",
      "noAgentYamlWarning": "Aucun YAML d'agent détecté. Envisagez d'ajouter une configuration d'agent.",
      "reviewStepTitle": "Vérifier l'ordre d'importation",
      "reviewStepDescription": "Les fichiers seront importés dans l'ordre suivant en fonction des dépendances :",
      "filesWithErrorsSkipped": "{{count}} fichier(s) avec des erreurs seront ignorés",
      "importingStepTitle": "Importation en cours...",
      "importingProgress": "Importation de {{current}} sur {{total}} : {{fileName}}",
      "importActions": {
        "created": "créé",
        "matched": "correspondance trouvée",
        "failed": "échec"
      },
      "completeStepTitleSuccess": "Configuration terminée !",
      "completeStepTitleWithErrors": "Configuration terminée avec des erreurs",
      "completeStepDescription": "Votre projet a été configuré avec les entités suivantes :",
      "summaryBadges": {
        "created": "+{{count}} créé(s)",
        "matched": "{{count}} correspondance(s)",
        "failed": "{{count}} échec(s)"
      },
      "errorsHeading": "Erreurs :",
      "steps": {
        "selectProject": "Sélectionner le projet",
        "addFiles": "Ajouter des fichiers",
        "review": "Vérifier",
        "import": "Importer"
      },
      "creatingLabel": "Création en cours...",
      "createAndContinue": "Créer et continuer",
      "continueLabel": "Continuer",
      "reviewImport": "Vérifier l'importation",
      "startImport": "Démarrer l'importation",
      "importingLabel": "Importation en cours...",
      "goToProject": "Aller au projet",
      "entityTypes": {
        "agent": "Agent",
        "model": "Modèle",
        "tool": "Outil",
        "prompt": "Invite",
        "skill": "Compétence",
        "knowledge": "Connaissance",
        "connector": "Connecteur",
        "iam": "IAM",
        "bundle": "Ensemble",
        "unknown": "Inconnu"
      },
      "toasts": {
        "dropYamlFiles": "Veuillez déposer des fichiers YAML",
        "enterProjectName": "Veuillez saisir un nom de projet",
        "projectCreated": "Projet « {{name}} » créé",
        "selectProject": "Veuillez sélectionner un projet",
        "projectSelected": "Projet « {{name}} » sélectionné",
        "addAtLeastOneFile": "Veuillez ajouter au moins un fichier YAML",
        "noValidYamlFiles": "Aucun fichier YAML valide trouvé",
        "projectNotCreated": "Projet non créé",
        "noValidFilesToImport": "Aucun fichier valide à importer",
        "importReportedFailure": "L'importation de {{name}} a signalé un échec",
        "allImportedSuccessfully": "Toutes les entités ont été importées avec succès !",
        "importPermissionError": "L'importation a échoué en raison de permissions insuffisantes. Veuillez contacter votre administrateur.",
        "importCompletedWithErrors": "Importation terminée avec {{count}} erreur(s)"
      },
      "unknownProject": "Inconnu"
    },
    "agentsTab": {
      "agentStatusTitle": "Statut de l'agent",
      "activeAgentsTitle": "Agents actifs",
      "archivedAgentsTitle": "Agents archivés",
      "openInAgentStudio": "Ouvrir dans Agent Studio",
      "noArchivedAgents": "Aucun agent archivé dans ce projet.",
      "noAgents": "Aucun agent dans ce projet.",
      "goToAgentStudio": "Aller à Agent Studio",
      "archiveDialogTitle": "Archiver {{count}} agent(s)",
      "archiveDialogMessage": "Archiver {{count}} agent(s) ? Ils apparaîtront sous Archivés ; vous pourrez les restaurer en brouillons ou les supprimer définitivement depuis là.",
      "archiveButtonLabel": "Archiver",
      "archivedWithSkippedToast": "{{deleted}} agent(s) archivé(s), {{skipped}} ignoré(s) en raison de dépendances actives.",
      "archivedToast": "{{count}} agent(s) archivé(s)",
      "exportSelected": "Exporter la sélection",
      "archiveSelected": "Archiver la sélection",
      "columns": {
        "name": "Nom",
        "status": "Statut",
        "framework": "Framework",
        "creator": "Créateur",
        "createdAt": "Créé le",
        "updatedAt": "Mis à jour le",
        "actions": "Actions"
      },
      "searchPlaceholder": "Rechercher des agents…"
    },
    "workflowsTab": {
      "statusPublished": "Publié",
      "columns": {
        "workflow": "Flux de travail",
        "status": "Statut",
        "schedule": "Planification",
        "controls": "Contrôles",
        "creator": "Créateur",
        "runs": "Exécutions",
        "createdAt": "Créé le",
        "tags": "Étiquettes",
        "actions": "Actions"
      },
      "registeredToRegistryAtVersion": "Enregistré dans le registre à la version v{{version}}",
      "registeredToRegistry": "Enregistré dans le registre",
      "scheduleActive": "Planification active",
      "schedulePaused": "Planification en pause",
      "notScheduled": "Non planifié",
      "draftCadenceTooltip": "Cadence enregistrée sur le brouillon — publiez pour démarrer la planification ({{cadence}}).",
      "neverRun": "jamais exécuté",
      "lastRunTitle": "Dernière exécution",
      "searchPlaceholder": "Rechercher des flux de travail…",
      "clearSearch": "Effacer la recherche",
      "totalWorkflows": "Total des flux de travail {{count}}",
      "catalogTitle": "Catalogue",
      "activeWorkflowsTitle": "Flux de travail actifs",
      "archivedWorkflowsTitle": "Flux de travail archivés",
      "gridViewTitle": "Vue en grille",
      "listViewTitle": "Vue en liste",
      "openInAgentWorkflows": "Ouvrir dans Agent Workflows",
      "noSearchResults": "Aucun flux de travail ne correspond à votre recherche.",
      "noArchivedWorkflows": "Aucun flux de travail archivé dans ce projet.",
      "noWorkflows": "Aucun flux de travail dans ce projet.",
      "goToAgentWorkflows": "Aller à Agent Workflows",
      "lastRunStatusTooltip": "Statut de la dernière exécution : {{status}}",
      "lastRunTooltip": "Dernière exécution : {{time}}",
      "updatedTooltip": "Mis à jour : {{time}}",
      "noDescriptionProvided": "Aucune description fournie",
      "runsCount": "{{count}} exécutions",
      "lastRunLabel": "Dernière exécution {{time}}",
      "pageOfTotal": "Page {{page}} sur {{totalPages}}",
      "versionTitle": "Version"
    },
    "skillsTab": {
      "loadError": "Échec du chargement des compétences",
      "requestedAccessToast": "Accès demandé pour {{count}} compétence(s) (en attente d'approbation)",
      "addedToast": "{{count}} compétence(s) ajoutée(s) au projet",
      "alreadyInProjectToast": "{{count}} compétence(s) déjà présente(s) dans le projet",
      "addFailedToast": "Échec de l'ajout de {{count}} compétence(s)",
      "removedToast": "Compétence supprimée du projet",
      "bulkRemovedToast": "{{count}} compétence(s) supprimée(s) avec succès du projet",
      "bulkRemoveFailedToast": "Échec de la suppression de {{count}} compétence(s)",
      "removeFromProject": "Supprimer du projet",
      "pending": "En attente",
      "platform": "Plateforme",
      "allModels": "Tous les modèles",
      "columns": {
        "name": "Nom de la compétence",
        "category": "Catégorie",
        "type": "Type",
        "model": "Modèle",
        "version": "Version",
        "added": "Ajouté",
        "lastUpdated": "Dernière mise à jour",
        "actions": "Actions"
      },
      "errorBoundaryMessage": "Impossible de charger les compétences. Veuillez actualiser la page.",
      "emptyMessage": "Aucune compétence configurée pour ce projet",
      "addSkill": "Ajouter une compétence",
      "addSkillsToProjectTitle": "Ajouter des compétences au projet",
      "showApprovedSkills": "Afficher les compétences approuvées",
      "removeDialogTitle": "Supprimer la compétence",
      "removeDialogMessage": "Supprimer « {{name}} » de ce projet ?",
      "remove": "Supprimer",
      "bulkRemoveDialogTitle": "Supprimer les compétences",
      "bulkRemoveDialogMessage": "Voulez-vous vraiment supprimer les {{count}} compétence(s) sélectionnée(s) de ce projet ?"
    },
    "toolsTab": {
      "requestedAccessToast": "Accès demandé pour {{count}} outil(s) (en attente d'approbation)",
      "alreadyInProjectToast": "{{count}} outil(s) déjà présent(s) dans le projet",
      "addFailedToast": "Échec de l'ajout de {{count}} outil(s)",
      "removedToast": "Outil supprimé du projet",
      "bulkRemovedToast": "{{count}} outil(s) supprimé(s) avec succès du projet",
      "bulkRemoveFailedToast": "Échec de la suppression de {{count}} outil(s) : {{errors}}",
      "removeFromProject": "Supprimer du projet",
      "exportSelected": "Exporter la sélection",
      "pending": "En attente",
      "columns": {
        "name": "Nom de l'outil",
        "type": "Type",
        "endpoint": "Point de terminaison",
        "created": "Créé",
        "lastUpdated": "Dernière mise à jour",
        "actions": "Actions"
      },
      "errorBoundaryMessage": "Impossible de charger les outils. Veuillez actualiser la page.",
      "emptyMessage": "Aucun outil configuré pour ce projet",
      "addTool": "Ajouter un outil",
      "addToolsToProjectTitle": "Ajouter des outils au projet",
      "showApprovedTools": "Afficher les outils approuvés",
      "removeDialogTitle": "Supprimer l'outil",
      "removeDialogMessage": "Supprimer « {{name}} » de ce projet ?",
      "remove": "Supprimer",
      "bulkRemoveDialogTitle": "Supprimer les outils",
      "bulkRemoveDialogMessage": "Voulez-vous vraiment supprimer les {{count}} outil(s) sélectionné(s) de ce projet ?"
    },
    "modelsTab": {
      "requestedAccessToast": "Accès demandé pour {{count}} modèle(s) (en attente d'approbation)",
      "alreadyInProjectToast": "{{count}} modèle(s) déjà présent(s) dans le projet",
      "addFailedToast": "{{count}} modèle(s) n'ont pas pu être ajoutés",
      "removedToast": "Modèle supprimé avec succès",
      "bulkRemovedToast": "{{count}} modèle(s) supprimé(s) avec succès du projet",
      "bulkRemoveFailedToast": "Échec de la suppression de {{count}} modèle(s) : {{errors}}",
      "removeFromProject": "Supprimer du projet",
      "pending": "En attente",
      "columns": {
        "name": "Nom du modèle",
        "provider": "Fournisseur",
        "modelId": "ID du modèle",
        "created": "Créé",
        "lastUpdated": "Dernière mise à jour",
        "actions": "Actions"
      },
      "errorBoundaryMessage": "Impossible de charger les modèles. Veuillez actualiser la page.",
      "emptyMessage": "Aucun modèle configuré pour ce projet",
      "addModel": "Ajouter un modèle",
      "addModelsToProjectTitle": "Ajouter des modèles au projet",
      "showApprovedModels": "Afficher les modèles approuvés",
      "removeDialogTitle": "Supprimer le modèle",
      "removeDialogMessage": "Supprimer « {{name}} » de ce projet ?",
      "remove": "Supprimer",
      "bulkRemoveDialogTitle": "Supprimer les modèles",
      "bulkRemoveDialogMessage": "Voulez-vous vraiment supprimer les {{count}} modèle(s) sélectionné(s) de ce projet ?"
    },
    "orchestratorsTab": {
      "selectAtLeastOne": "Veuillez sélectionner au moins un orchestrateur",
      "requestedAccessToast": "Accès demandé pour {{count}} orchestrateur(s) (en attente d'approbation)",
      "removedToast": "« {{name}} » supprimé du projet",
      "bulkRemovedToast": "{{count}} orchestrateur(s) supprimé(s) avec succès du projet",
      "bulkRemoveFailedToast": "Échec de la suppression de {{count}} orchestrateur(s) : {{errors}}",
      "removeFromProject": "Supprimer du projet",
      "testConnection": "Tester la connexion",
      "testConnectionSuccess": "Test de connexion réussi pour « {{name}} »",
      "testConnectionFailure": "Échec du test de connexion pour « {{name}} » : {{message}}",
      "columns": {
        "name": "Nom",
        "type": "Type",
        "host": "Hôte",
        "status": "Statut",
        "addedBy": "Ajouté par",
        "addedAt": "Ajouté le",
        "actions": "Actions"
      },
      "errorBoundaryMessage": "Impossible de charger les orchestrateurs. Veuillez actualiser la page.",
      "emptyMessage": "Aucun orchestrateur configuré pour ce projet",
      "addOrchestrator": "Ajouter un orchestrateur",
      "addOrchestratorsToProjectTitle": "Ajouter des orchestrateurs au projet",
      "removeDialogTitle": "Supprimer l'orchestrateur",
      "removeDialogMessage": "Supprimer « {{name}} » de ce projet ?",
      "remove": "Supprimer",
      "bulkRemoveDialogTitle": "Supprimer les orchestrateurs",
      "bulkRemoveDialogMessage": "Voulez-vous vraiment supprimer les {{count}} orchestrateur(s) sélectionné(s) de ce projet ?"
    },
    "knowledgeTab": {
      "unknown": "Inconnu",
      "vectorDatabase": "Base de données vectorielle",
      "vectorDbBadge": "BD vectorielle",
      "schemaTitle": "Schéma : {{schema}}",
      "searchPlaceholder": "Rechercher des tables...",
      "clearSearch": "Effacer la recherche",
      "columns": {
        "name": "Nom",
        "database": "Base de données",
        "rows": "Lignes",
        "status": "Statut",
        "creator": "Créateur",
        "actions": "Actions"
      },
      "status": {
        "error": "Erreur",
        "active": "Actif",
        "syncing": "Synchronisation",
        "pending": "En attente"
      },
      "actions": {
        "previewData": "Aperçu des données",
        "removeFromProject": "Retirer du projet",
        "remove": "Retirer"
      },
      "toasts": {
        "requestedAccess": "Accès demandé pour {{count}} {{tableLabel}}{{plural}} (approbation en attente)",
        "alreadyInProject": "{{count}} {{tableLabel}}{{plural}} déjà dans le projet",
        "requestAccessFailed": "Échec de la demande d'accès pour {{count}} {{tableLabel}}{{plural}}",
        "removed": "Table de connaissances retirée du projet",
        "bulkRemoved": "{{count}} table{{plural}} {{typeLabel}} retirée(s) du projet avec succès",
        "bulkRemoveFailed": "Échec du retrait de {{count}} table{{plural}} {{typeLabel}} : {{errors}}"
      },
      "removeDialogMessage": "Retirer \"{{name}}\" de ce projet ?",
      "bulkRemoveDialogMessage": "Voulez-vous vraiment retirer la ou les {{count}} table(s) sélectionnée(s) de ce projet ?",
      "viewToggle": {
        "database": "Vue base de données",
        "collection": "Vue collection"
      },
      "variant": {
        "knowledge": {
          "tableLabel": "table de connaissances",
          "typeLabel": "connaissances",
          "addButton": "Ajouter des connaissances",
          "emptyMessage": "Aucune table de connaissances configurée pour ce projet",
          "addModalTitle": "Ajouter des connaissances au projet",
          "membershipToggleLabel": "Afficher les tables approuvées",
          "removeDialogTitle": "Retirer la table de connaissances",
          "removeDialogTitlePlural": "Retirer les tables de connaissances",
          "errorBoundaryMessage": "Impossible de charger les tables de connaissances. Veuillez rafraîchir la page."
        },
        "graph": {
          "tableLabel": "table de graphe",
          "typeLabel": "graphe",
          "addButton": "Ajouter un graphe",
          "emptyMessage": "Aucune table de graphe configurée pour ce projet",
          "addModalTitle": "Ajouter des tables de graphe au projet",
          "membershipToggleLabel": "Afficher les tables de graphe approuvées",
          "removeDialogTitle": "Retirer la table de graphe",
          "removeDialogTitlePlural": "Retirer les tables de graphe",
          "errorBoundaryMessage": "Impossible de charger les tables de graphe. Veuillez rafraîchir la page."
        },
        "vector": {
          "tableLabel": "table vectorielle",
          "typeLabel": "vectorielle",
          "addButton": "Ajouter un vecteur",
          "emptyMessage": "Aucune table vectorielle configurée pour ce projet",
          "addModalTitle": "Ajouter des tables vectorielles au projet",
          "membershipToggleLabel": "Afficher les tables vectorielles approuvées",
          "removeDialogTitle": "Retirer la table vectorielle",
          "removeDialogTitlePlural": "Retirer les tables vectorielles",
          "errorBoundaryMessage": "Impossible de charger les tables vectorielles. Veuillez rafraîchir la page."
        }
      }
    },
    "storageTab": {
      "unknown": "Inconnu",
      "addButton": "Ajouter un stockage",
      "addModalTitle": "Ajouter un stockage au projet",
      "emptyMessage": "Aucun dossier de stockage configuré pour ce projet",
      "errorBoundaryMessage": "Impossible de charger les dossiers de stockage. Veuillez rafraîchir la page.",
      "membershipToggleLabel": "Afficher le stockage approuvé",
      "removeDialogTitle": "Retirer le dossier de stockage",
      "removeDialogTitlePlural": "Retirer les dossiers de stockage",
      "removeDialogMessage": "Retirer \"{{name}}\" de ce projet ?",
      "bulkRemoveDialogMessage": "Voulez-vous vraiment retirer le ou les {{count}} dossier(s) de stockage sélectionné(s) de ce projet ?",
      "columns": {
        "folder": "Dossier",
        "connector": "Connecteur",
        "files": "Fichiers",
        "size": "Taille",
        "status": "Statut",
        "creator": "Créateur",
        "actions": "Actions"
      },
      "status": {
        "active": "Actif",
        "error": "Erreur",
        "pending": "En attente"
      },
      "actions": {
        "previewFiles": "Aperçu des fichiers",
        "sync": "Synchroniser",
        "syncing": "Synchronisation...",
        "removeFromProject": "Retirer du projet",
        "remove": "Retirer"
      },
      "toasts": {
        "requestedAccess": "Accès demandé pour {{count}} dossier{{plural}} de stockage (approbation en attente)",
        "alreadyInProject": "{{count}} dossier{{plural}} de stockage déjà dans le projet",
        "addFailed": "Échec de l'ajout de {{count}} dossier{{plural}} de stockage",
        "synced": "Métadonnées de « {{name}} » synchronisées.",
        "removed": "Dossier de stockage retiré du projet",
        "bulkRemoved": "{{count}} dossier{{plural}} de stockage retiré(s) du projet avec succès",
        "bulkRemoveFailed": "Échec du retrait de {{count}} dossier{{plural}} de stockage"
      }
    },
    "registryTab": {
      "columnAgent": "Agent",
      "columnFramework": "Framework",
      "columnStatus": "Statut",
      "columnEnv": "ENV",
      "columnOrchestrator": "Orchestrateur",
      "columnRegisteredBy": "Enregistré par",
      "columnRegisteredAt": "Enregistré le",
      "columnActions": "Actions",
      "columnWorkflow": "Workflow",
      "actionOpenCanvas": "Ouvrir le canevas",
      "actionRuns": "Exécutions",
      "registryViewsAriaLabel": "Vues du registre",
      "agentRegistryTitle": "Registre des agents",
      "agentsLabel": "Agents",
      "workflowRegistryTitle": "Registre des workflows",
      "workflowsLabel": "Workflows",
      "registryStatusTitle": "Statut du registre",
      "activeItemsTitle": "Éléments actifs du registre",
      "archivedItemsTitle": "Éléments archivés du registre",
      "openInRegistryTitle": "Ouvrir dans le registre",
      "emptyActiveAgents": "Aucun agent enregistré dans ce projet.",
      "emptyArchivedAgents": "Aucun agent enregistré archivé dans ce projet.",
      "emptyActiveWorkflows": "Aucun workflow enregistré dans ce projet.",
      "emptyArchivedWorkflows": "Aucun workflow enregistré archivé dans ce projet.",
      "goToRegistry": "Aller au registre des agents",
      "searchRegistryPlaceholder": "Rechercher dans le registre…",
      "searchWorkflowsPlaceholder": "Rechercher des workflows…"
    },
    "promptsTab": {
      "columnName": "Nom du prompt",
      "columnCategory": "Catégorie",
      "columnDescription": "Description",
      "columnCreated": "Créé",
      "columnLastUpdated": "Dernière mise à jour",
      "columnActions": "Actions",
      "noDescription": "Aucune description",
      "viewVersionsTitle": "Voir les versions du prompt",
      "errorBoundaryMessage": "Impossible de charger les prompts. Veuillez actualiser la page.",
      "emptyMessage": "Aucun prompt dans ce projet. Les prompts sont gérés via la page Prompts.",
      "dialogCloseAriaLabel": "Fermer la boîte de dialogue",
      "categoryLabel": "Catégorie :",
      "versionsHeading": "VERSIONS ({{count}})",
      "loadingVersions": "Chargement des versions...",
      "noVersionsFound": "Aucune version trouvée",
      "versionLabel": "Version {{version}}",
      "latestBadge": "DERNIÈRE",
      "selectVersionPrompt": "Sélectionnez une version pour afficher le contenu"
    },
    "deploymentsTab": {
      "columnAgent": "Agent",
      "columnEnv": "Env",
      "columnStatus": "Statut",
      "columnDeployedBy": "Déployé par",
      "columnDeployedAt": "Déployé le",
      "columnActions": "Actions",
      "columnWorkflow": "Workflow",
      "actionOpen": "Ouvrir",
      "actionChat": "Chat",
      "actionRuntimeSettings": "Paramètres d'exécution",
      "actionOpenInMonitoring": "Ouvrir dans Monitoring",
      "actionManageArchive": "Gérer l'archive dans Monitoring",
      "actionGuardrails": "Garde-fous",
      "deploymentViewsAriaLabel": "Vues de déploiement",
      "agentDeploymentsTitle": "Déploiements d'agents",
      "agentsLabel": "Agents",
      "workflowDeploymentsTitle": "Déploiements de workflows",
      "workflowsLabel": "Workflows",
      "deploymentStatusTitle": "Statut de déploiement",
      "activeDeploymentsTitle": "Déploiements actifs",
      "archivedDeploymentsTitle": "Déploiements archivés",
      "openInMonitoringTitle": "Ouvrir dans Monitoring",
      "emptyActiveAgents": "Aucun déploiement d'agent actif pour ce projet.",
      "emptyArchivedAgents": "Aucun déploiement d'agent archivé pour ce projet.",
      "emptyActiveWorkflows": "Aucun déploiement de workflow actif pour ce projet.",
      "emptyArchivedWorkflows": "Aucun déploiement de workflow archivé pour ce projet.",
      "goToMonitoring": "Aller à Monitoring",
      "searchDeploymentsPlaceholder": "Rechercher des déploiements…",
      "searchWorkflowDeploymentsPlaceholder": "Rechercher des déploiements de workflows…"
    },
    "evalsTab": {
      "columnAgent": "Agent",
      "columnLatestSession": "Dernière session",
      "columnActions": "Actions",
      "actionOpenEvals": "Ouvrir les évaluations",
      "actionManageInEvals": "Gérer dans Évaluations",
      "portfolioSubtitle": "Portefeuille d'évaluation pour ce projet",
      "openInEvalsTitle": "Ouvrir dans Évaluations",
      "emptyMessage": "Aucune donnée d'évaluation pour ce projet.",
      "goToEvals": "Aller à Évaluations et simulations",
      "searchAgentsPlaceholder": "Rechercher des agents…"
    }
  },
  "prompts": {
    "exportFileName": "Prompts",
    "searchPlaceholder": "Rechercher des prompts...",
    "columns": {
      "name": "Nom du prompt",
      "description": "Description",
      "category": "Catégorie",
      "model": "Modèle",
      "project": "Projet",
      "visibility": "Visibilité",
      "createdBy": "Créé par",
      "updatedAt": "Mis à jour le",
      "actions": "Actions"
    },
    "filters": {
      "title": "Filtres",
      "visibility": "Visibilité",
      "category": "Catégorie",
      "project": "Projet",
      "creator": "Créateur",
      "all": "Tous",
      "favorites": "Favoris"
    },
    "visibility": {
      "project": "Projet",
      "public": "Plateforme"
    },
    "list": {
      "uncategorized": "Non catégorisé",
      "allModels": "Tous les modèles",
      "platformBadge": "Plateforme",
      "platformBadgeTooltip": "Prompt système basé sur le code — lecture seule",
      "versionCount": "{{count}} version",
      "versionCount_other": "{{count}} versions",
      "unknownProject": "Inconnu",
      "emptyState": {
        "permissionDenied": "Vous n'avez pas la permission d'afficher les prompts. Contactez votre administrateur pour obtenir l'accès.",
        "noResultsSearch": "Aucun prompt ne correspond à votre recherche.",
        "default": "Aucun prompt trouvé. Créez votre premier prompt pour commencer."
      }
    },
    "actions": {
      "view": "Afficher",
      "chat": "Discussion",
      "exportYaml": "Exporter en YAML",
      "optimize": "Optimiser",
      "cloneForModel": "Cloner pour un modèle",
      "edit": "Modifier",
      "delete": "Supprimer",
      "exportSelected": "Exporter la sélection",
      "deleteSelected": "Supprimer la sélection",
      "createPrompt": "Créer un prompt",
      "newPrompt": "Nouveau prompt",
      "creating": "Création..."
    },
    "quota": {
      "loading": "Chargement du quota...",
      "label": "Prompts"
    },
    "toast": {
      "projectFilterReset": "Le projet précédemment sélectionné n'existe plus. Le filtre a été réinitialisé.",
      "draftInserted": "Brouillon de prompt inséré. Modifiez-le si nécessaire, puis créez-le — vous pourrez lancer l'optimisation depuis l'éditeur de prompt après l'enregistrement.",
      "clonedForModel": "Prompt cloné pour le modèle « {{model}} »",
      "bulkDeletePartial": "{{deleted}} prompt(s) supprimé(s), {{skipped}} en échec : {{errors}}",
      "bulkDeleteSuccess": "{{count}} prompt(s) supprimé(s) avec succès",
      "platformDeleteBlocked": "Les prompts de la plateforme ne peuvent pas être supprimés"
    },
    "form": {
      "modelAgnostic": "Indépendant du modèle (tous les modèles)",
      "selectProjectFirst": "Sélectionnez d'abord un projet.",
      "selectProjectModel": "Sélectionnez un modèle LLM assigné à ce projet.",
      "selectModel": "Sélectionnez un modèle LLM.",
      "minBusinessContext": "Saisissez au moins 10 caractères de contexte métier.",
      "selectProjectAndModelFirst": "Sélectionnez d'abord le projet et le modèle",
      "selectModelFirst": "Sélectionnez d'abord un modèle",
      "minCharsRequired": "Minimum 10 caractères requis",
      "selectProjectFirstPlaceholder": "Sélectionnez d'abord un projet",
      "loadingModels": "Chargement des modèles…",
      "noLlmForProject": "Aucun LLM assigné à ce projet",
      "noLlmAvailable": "Aucun LLM disponible",
      "nameAlreadyExists": "Un prompt portant ce nom existe déjà",
      "promptNameLabel": "Nom du prompt *",
      "promptNamePlaceholder": "ex. : Assistant support client",
      "categoryLabel": "Catégorie",
      "categoryPlaceholder": "ex. : Support, Ventes",
      "targetModelLabel": "Modèle cible",
      "targetModelRequiredLabel": "Modèle cible *",
      "selectModelPlaceholder": "Sélectionner un modèle...",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Brève description de ce que fait ce prompt",
      "charCount": "{{count}}/{{max}} caractères",
      "modelLabel": "Modèle",
      "selectAiModelPlaceholder": "Sélectionner un modèle IA",
      "generating": "Génération…",
      "generate": "Générer",
      "businessContextPlaceholder": "Audience, ton, tâches, contraintes — le modèle rédigera votre prompt à partir de ces éléments. Minimum 10 caractères pour générer.",
      "aiGenerateHint": "Après la génération, vous passerez en mode manuel pour relire et modifier le prompt, puis le créer.",
      "contentPlaceholderPrefix": "Vous êtes un assistant utile qui...\n\nRédigez votre prompt système ici. Utilisez ",
      "contentPlaceholderSuffix": " pour référencer des variables d'état résolues à l'exécution.",
      "variableNamePlaceholder": "nom_variable",
      "addVariable": "Ajouter une variable",
      "nameLabel": "Nom *",
      "fixValidationErrors": "Veuillez corriger les erreurs de validation avant d'enregistrer",
      "saving": "Enregistrement...",
      "saveChanges": "Enregistrer les modifications",
      "quotaExceeded": "Quota de prompts dépassé",
      "fillRequiredFields": "Veuillez renseigner tous les champs obligatoires",
      "cloning": "Clonage..."
    },
    "modal": {
      "detailsHeader": "Détails",
      "describePromptHeader": "Décrivez ce que le prompt doit faire",
      "promptDetailsHeader": "Détails du prompt",
      "createTitle": "Créer un nouveau prompt",
      "creationModeAriaLabel": "Mode de création du prompt",
      "modeManual": "Manuel",
      "modeAi": "IA",
      "editorSectionsAriaLabel": "Sections de l'éditeur de prompt",
      "tabPrompt": "Prompt",
      "tabState": "État",
      "editorHintPrefix": "Utilisez",
      "editorHintSuffix": "pour les variables d'état",
      "aiGeneratedNote": "Généré par IA — modifiez si nécessaire. Utilisez l'optimisation pour affiner davantage.",
      "loadingEditor": "Chargement de l'éditeur de prompt...",
      "stateVariablesHintPrefix": "Définissez les variables d'état à utiliser avec",
      "stateVariablesHintSuffix": "dans votre prompt. Chaque variable référencée dans le prompt doit être listée ici.",
      "noStateVariables": "Aucune variable d'état définie pour le moment.",
      "stateVariableNameAriaLabel": "Nom de la variable d'état {{name}}",
      "removeStateVariableAriaLabel": "Supprimer la variable d'état {{name}}",
      "newVariableFallback": "nouvelle",
      "editTitle": "Modifier les métadonnées du prompt",
      "deleteTitle": "Supprimer le prompt",
      "deleteMessage": "Voulez-vous vraiment supprimer « {{name}} » ? Cette action est irréversible.",
      "bulkDeleteTitle": "Supprimer les prompts sélectionnés",
      "bulkDeleteMessage": "Voulez-vous vraiment supprimer {{count}} prompt ? Cette action est irréversible.",
      "bulkDeleteMessage_other": "Voulez-vous vraiment supprimer {{count}} prompts ? Cette action est irréversible.",
      "bulkDeleteConfirm": "Supprimer {{count}} prompt",
      "bulkDeleteConfirm_other": "Supprimer {{count}} prompts",
      "cloneTitle": "Cloner pour un modèle",
      "cloneMessage": "Cloner « {{name}} » avec toutes les versions pour un autre modèle.",
      "cloneSubmit": "Cloner le prompt"
    },
    "optimizeModal": {
      "header": {
        "title": "Optimiser le prompt",
        "subtitlePlaceholder": "Sélectionnez un prompt"
      },
      "stepper": {
        "configure": "Configurer",
        "running": "En cours",
        "result": "Résultat"
      },
      "framework": {
        "sectionTitle": "Sélectionner un framework",
        "bestFor": "Idéal pour : {{value}}",
        "catalog": {
          "dspy": {
            "label": "DSPy",
            "tier": "Niveau 1",
            "desc": "Optimisation déclarative (MIPROv2, COPRO ou bootstrap few-shot). Idéal avec des exemples étiquetés.",
            "tooltip": "Compile un programme déclaratif en prompts optimisés. Choisissez un type de compilateur ci-dessous (MIPROv2 par défaut).",
            "bestFor": "Classification, questions-réponses, extraction"
          },
          "cot": {
            "label": "Chain-of-Thought",
            "tier": "Niveau 2",
            "desc": "Optimisation du raisonnement : étape par étape, qualité de la trace, décomposition des étapes.",
            "tooltip": "Teste plusieurs stratégies CoT (ex. « Réfléchis étape par étape »), optimise la qualité de la trace de raisonnement et la décomposition des étapes. Utilisez le type de prompt « Chain-of-Thought » pour toutes les stratégies.",
            "bestFor": "Raisonnement, mathématiques, tâches à plusieurs étapes"
          },
          "opro": {
            "label": "OPRO",
            "tier": "Niveau 2",
            "desc": "LLM en tant qu'optimiseur. Fournit un historique (prompt, score) et demande une amélioration.",
            "tooltip": "Utilise le LLM lui-même comme optimiseur — propose itérativement de meilleurs prompts en analysant les trajectoires de score. Simple à déployer, sans calcul de gradient.",
            "bestFor": "Itération rapide sur toute tâche"
          },
          "reflexion": {
            "label": "Reflexion",
            "tier": "Niveau 2",
            "desc": "RL verbal auto-réflexif. Génère une boucle critique → réécriture.",
            "tooltip": "Génère une auto-critique après chaque essai, puis réécrit le prompt pour corriger les échecs identifiés. Combine réflexion et mémoire épisodique pour une amélioration durable.",
            "bestFor": "Raisonnement complexe, tâches à plusieurs étapes"
          },
          "gepa": {
            "label": "GEPA",
            "tier": "Niveau 3",
            "desc": "Moteur Genetic-Pareto amont avec sélection de Pareto par exemple et fusion de candidats.",
            "tooltip": "Exécute le moteur GEPA de référence. Conserve un front de Pareto par exemple de validation au lieu d'un score global unique, afin que les prompts n'aidant que sur un sous-ensemble survivent pour être combinés.",
            "bestFor": "Graphes d'agents multi-nœuds, exécutions stagnantes"
          },
          "gepa_legacy": {
            "label": "GEPA (héritée)",
            "tier": "Niveau 3",
            "desc": "Approche évolutive réflexive maison avec diagnostic d'échec piloté par LLM.",
            "tooltip": "L'ancienne approximation GEPA intégrée. Conservée comme solution de repli lorsque le package amont est indisponible, et pour comparaison A/B.",
            "bestFor": "Installations hors ligne sans le package gepa"
          },
          "optimize_anything": {
            "label": "optimize_anything",
            "tier": "Niveau 3",
            "desc": "Lanceur GEPA amont pour des artefacts autres que des prompts (graphe d'agent, configuration de nœud).",
            "tooltip": "Optimise le JSON du graphe ou les paramètres de configuration de nœud via le même moteur Genetic-Pareto. Les candidats invalides obtiennent un score de 0 avec l'erreur de validation comme retour. La persistance nécessite une étape d'application explicite.",
            "bestFor": "Recherche de topologie et de configuration au-delà des prompts"
          },
          "evoprompt": {
            "label": "EvoPrompt",
            "tier": "Niveau 3",
            "desc": "Évolution basée sur une population avec opérateurs de croisement et de mutation.",
            "tooltip": "Maintient une population de candidats prompts et applique des opérateurs de croisement/mutation inspirés des algorithmes génétiques. Idéal pour explorer des formulations de prompts variées.",
            "bestFor": "Exploration diversifiée de prompts"
          },
          "ape": {
            "label": "APE",
            "tier": "Niveau 3",
            "desc": "Automatic Prompt Engineer. Générer → évaluer → rééchantillonner.",
            "tooltip": "Génère de nombreuses instructions candidates à partir de démonstrations E/S, les évalue, puis rééchantillonne autour des meilleures. Rapide et efficace pour la découverte d'instructions.",
            "bestFor": "Découverte d'instructions à partir d'exemples"
          },
          "textgrad": {
            "label": "TextGrad",
            "tier": "Niveau 4",
            "desc": "Rétropropagation textuelle. Calcule des gradients textuels pour des corrections ciblées.",
            "tooltip": "Propage des « gradients » textuels — un retour en langage naturel — en arrière dans le prompt pour identifier précisément les parties à modifier. Raffinement précis et chirurgical.",
            "bestFor": "Édition précise de longs prompts"
          },
          "rl_tuning": {
            "label": "RL-PPO",
            "tier": "Niveau 5",
            "desc": "Optimisation de politique de type PPO avec fonctions de récompense personnalisées.",
            "tooltip": "Traite la sélection de prompt comme une politique et l'optimise via Proximal Policy Optimization. Définissez votre propre fonction de récompense pour un contrôle total de l'objectif d'optimisation.",
            "bestFor": "Objectifs de récompense personnalisés"
          },
          "rag_aware": {
            "label": "RAG-Aware",
            "tier": "Niveau 6",
            "desc": "Co-optimisation conjointe du prompt et du pipeline de récupération.",
            "tooltip": "Co-optimise le prompt et la configuration de récupération ensemble. Ajuste le formatage des requêtes, le placement du contexte et la formulation des instructions pour les workflows à forte composante RAG.",
            "bestFor": "Génération augmentée par récupération"
          },
          "multi_obj": {
            "label": "Multi-objectif",
            "tier": "Transversal",
            "desc": "Optimisation du front de Pareto sur la précision, la latence et le coût.",
            "tooltip": "Explore le front de Pareto sur plusieurs objectifs concurrents (précision, latence, coût en tokens). Retourne un ensemble de prompts optimaux en compromis plutôt qu'un seul vainqueur.",
            "bestFor": "Équilibrer précision et coût"
          },
          "ensemble": {
            "label": "Ensemble",
            "tier": "Transversal",
            "desc": "Exécute plusieurs optimiseurs en parallèle, puis fusionne les résultats (tournoi, fusion ou vote).",
            "tooltip": "Exécute simultanément 2+ frameworks complémentaires (ex. Reflexion + OPRO + TextGrad), puis combine leurs meilleurs candidats. Coût plus élevé qu'un seul framework ; idéal pour une amélioration de prompt robuste et multi-perspective.",
            "bestFor": "Couverture et robustesse maximales"
          }
        }
      },
      "promptVersion": {
        "sectionTitle": "Prompt et version",
        "projectLabel": "Projet",
        "promptLabel": "Prompt",
        "promptPlaceholder": "Sélectionnez un prompt...",
        "promptSearchPlaceholder": "Rechercher par nom...",
        "promptRequiredError": "La sélection d'un prompt est requise.",
        "versionLabel": "Version",
        "versionPlaceholder": "Sélectionnez une version...",
        "versionRequiredError": "La sélection d'une version de prompt est requise.",
        "versionCurrentSuffix": " (actuelle)",
        "compilerTypeLabel": "Type de compilateur",
        "compilerTypeTitle": "Quel téléprompteur DSPy s'exécute (MIPROv2 est l'optimiseur multiplexeur par défaut).",
        "compilerOptions": {
          "miprov2": "MIPROv2",
          "copro": "COPRO",
          "bootstrapFewShot": "Bootstrap few-shot"
        },
        "promptTypeLabel": "Type de prompt",
        "promptTypeTitle": "Stratégies d'optimisation Chain-of-Thought.",
        "promptTypeOptions": {
          "standard": "Standard",
          "cot": "Chain-of-Thought",
          "fewShot": "Few-shot",
          "structuredOutput": "Sortie structurée (JSON/XML)"
        },
        "allProjectsLabel": "Tous les projets"
      },
      "model": {
        "sectionTitle": "Configuration du modèle",
        "responseModelLabel": "Modèle de réponse",
        "responseModelPlaceholder": "Sélectionnez un modèle LLM...",
        "responseModelRequiredError": "Un modèle de réponse est requis (ou activez le multi-modèle avec 2+ cibles).",
        "judgeModelLabel": "Modèle juge",
        "judgeModelPlaceholder": "Sélectionnez un modèle juge",
        "gepaMutationModelLabel": "Modèle de mutation GEPA",
        "gepaMutationModelTitle": "LLM utilisé pour la réflexion et la mutation GEPA (ID de modèle LiteLLM ou UUID de modèle de la plateforme).",
        "gepaMutationModelPlaceholder": "Sélectionnez le modèle de mutation",
        "gepaMutationModelHint": "Réflexion et génération de mutants ; l'évaluation utilise toujours vos modèles juge/réponse ci-dessus.",
        "multiModelLabel": "Optimiser sur plusieurs modèles",
        "multiModelHint": "Évaluer le prompt sur 2+ modèles et agréger (prompt agnostique du modèle)",
        "targetModelsLabel": "Modèles cibles (sélectionnez-en 2+)",
        "selectAtLeast2Hint": "Sélectionnez au moins 2 modèles.",
        "modelsSelectedCount": "{{count}} modèles sélectionnés.",
        "aggregationStrategyLabel": "Stratégie d'agrégation",
        "aggregationOptions": {
          "mean": "Moyenne — moyenne sur tous les modèles",
          "min": "Min — pire cas (aucun modèle laissé de côté)",
          "pareto": "Pareto — équilibre entre min et moyenne"
        },
        "aggregationHint": "Min = optimiser pour le modèle le plus faible ; Moyenne = moyenne ; Pareto = équilibre.",
        "noModelsHint": "Aucun modèle LLM n'est associé à ce projet. Ajoutez des modèles dans Projet → Modèles, sinon l'optimisation pourrait utiliser les valeurs par défaut du backend.",
        "selectPromptHint": "Sélectionnez un prompt pour charger les modèles de réponse et de jugement du projet correspondant."
      },
      "ensemble": {
        "sectionTitle": "Configuration de l'ensemble",
        "subFrameworksLabel": "Sous-frameworks (sélectionnez-en 2+)",
        "subFrameworksHint": "Chaque optimiseur sélectionné s'exécute en parallèle ; les résultats sont fusionnés selon la stratégie ci-dessous.",
        "fusionLabel": "Stratégie de fusion",
        "fusionOptions": {
          "tournament": "Tournoi — évaluer les candidats sur le jeu de données complet, choisir le meilleur",
          "merge": "Fusion — le LLM synthétise les meilleurs candidats en un seul prompt",
          "voting": "Vote — évaluer les candidats sur un jeu de test, combinaison pondérée"
        },
        "minTwoToast": "Sélectionnez au moins deux sous-frameworks pour l'ensemble"
      },
      "metrics": {
        "sectionTitle": "Métrique d'évaluation",
        "autoDiscoverLabel": "Détecter automatiquement les métriques à partir du jeu de données et du prompt (recommande fidélité, pertinence, etc. lorsqu'un contexte est présent)",
        "selectPromptHint": "Sélectionnez un prompt pour charger le catalogue de métriques de son projet.",
        "weightsTitle": "Pondération des métriques (optionnel — score composite)",
        "weightsHint": "Laissez vide pour une pondération égale. Les poids sont normalisés pour totaliser 1.",
        "weightPlaceholder": "égal",
        "noMetricsWarning": "Aucune métrique sélectionnée — utilisera par défaut Answer Correctness.",
        "embeddingLabel": "Modèle d'embedding (requis pour les métriques choisies)",
        "embeddingPlaceholder": "Sélectionnez un modèle d'embedding…",
        "embeddingNoModelsHint": "Aucun modèle d'embedding actif dans ce projet. Enregistrez-en un sous Projet → Modèles.",
        "sqlLabel": "Base de données d'exécution (requise pour Text2SQL EX/VES)",
        "sqlPlaceholder": "Sélectionnez un connecteur de base de données…",
        "sqlNoConnectorsHint": "Aucun connecteur de base de données enregistré. Ajoutez-en un sous Knowledge → Connecteurs.",
        "schemaLabel": "Définition de schéma (JSON, requise pour la conformité de schéma)",
        "schemaPlaceholder": "{\"tables\": [{\"name\": \"orders\", \"columns\": [\"id\", \"amount\"]}]}"
      },
      "dataset": {
        "sectionTitle": "Jeu de données de référence",
        "optionalGepaSuffix": "(optionnel pour GEPA)",
        "selectPromptHint": "Sélectionnez un prompt pour lister les jeux de données de référence liés à la connaissance de ce projet.",
        "datasetPlaceholder": "Sélectionnez une table enregistrée...",
        "datasetSearchPlaceholder": "Rechercher des jeux de données par nom ou table...",
        "datasetRowsSuffix": "({{count}} lignes)",
        "datasetRequiredError": "La sélection d'un jeu de données de référence est requise.",
        "noDatasetsHint": "Aucune table de connaissance associée à ce projet. Associez des tables sous Projet → Connaissance.",
        "inputColumnLabel": "Colonne d'entrée",
        "columnPlaceholder": "Sélectionnez une colonne...",
        "expectedOutputColumnLabel": "Colonne de sortie attendue",
        "expectedOutputRequiredError": "La colonne de sortie attendue est requise pour DSPy.",
        "contextColumnsLabel": "Colonnes de contexte (optionnel)",
        "selectDatasetFirst": "Sélectionnez d'abord un jeu de données",
        "contextColumnsHint": "Plusieurs colonnes sont jointes pour le contexte d'évaluation (RAGAS / DeepEval).",
        "samplingStrategyLabel": "Stratégie d'échantillonnage",
        "samplingOptions": {
          "random": "Aléatoire",
          "stratified": "Stratifié (par sortie attendue)",
          "difficultyWeighted": "Pondéré par difficulté (accent sur les cas difficiles)",
          "progressive": "Progressif (le sous-ensemble s'élargit à mesure que l'optimisation converge)"
        },
        "samplingHint": "Stratifié et pondéré par difficulté peuvent améliorer le signal avec moins de lignes."
      },
      "dspyContext": {
        "title": "Intégration du contexte DSPy",
        "modeLabel": "Mode de transmission du contexte",
        "modeOptions": {
          "auto": "Auto — injecter le contexte comme entrée DSPy lorsqu'il est détecté",
          "injectField": "Injecter un champ — toujours ajouter le contexte comme entrée DSPy",
          "ragModule": "Module RAG — récupération depuis le corpus de contexte avant la prédiction"
        },
        "modeHints": {
          "auto": "Injecte automatiquement le contexte du jeu de données dans la signature DSPy, même si le modèle de prompt n'y fait pas référence.",
          "injectField": "Force l'injection du contexte comme champ d'entrée DSPy. DSPy apprend à utiliser le contexte pendant la compilation.",
          "ragModule": "Construit un module DSPy composé Retrieve + Predict. MIPROv2 peut optimiser conjointement la récupération et la prédiction."
        },
        "demoStrategyLabel": "Stratégie de sélection des démonstrations",
        "demoOptions": {
          "default": "Défaut — laisser le compilateur DSPy choisir",
          "diverseContext": "Contexte diversifié — maximiser la diversité de contexte entre les démonstrations",
          "maxCoverage": "Couverture maximale — couvrir la plus large gamme de sujets de contexte"
        },
        "demoHint": "Contexte diversifié et couverture maximale sélectionnent des démonstrations avec une plus grande variété de contexte pour une meilleure qualité few-shot.",
        "topKLabel": "Top-K de récupération",
        "topKHint": "Nombre de passages de contexte récupérés par requête depuis le jeu de données de référence.",
        "truncateLabel": "Tronquer les longs contextes",
        "truncateHint": "Limiter les passages de contexte pour respecter le budget de tokens",
        "maxTokensLabel": "Tokens de contexte maximum",
        "maxTokensHint": "Troncature approximative au niveau des mots par passage."
      },
      "advanced": {
        "sectionTitle": "Options avancées",
        "warmStartLabel": "Démarrage à chaud par méta-apprentissage",
        "warmStartHint": "Amorcer à partir d'exécutions passées similaires",
        "adversarialLabel": "Test de robustesse adversariale",
        "adversarialHint": "Tester sur des entrées perturbées ; combiner avec le score propre",
        "adversarialWeightLabel": "Poids adversarial (0–1)",
        "adversarialWeightHint": "robust_score = (1 − α)×propre + α×adversarial ; un α plus élevé pondère davantage l'adversarial.",
        "requireApprovalLabel": "Approbation requise avant l'enregistrement",
        "requireApprovalHint": "Vérifier le prompt optimisé avant qu'il ne devienne une nouvelle version",
        "driftGuardLabel": "Garde de dérive sémantique",
        "driftGuardHint": "Rejeter les candidats qui s'écartent trop de l'intention d'origine",
        "maxDriftLabel": "Dérive maximale (0–1)",
        "maxDriftHint": "Les candidats avec une dérive > à cette valeur sont rejetés. Plus bas = plus strict (ex. 0,3).",
        "driftMethodLabel": "Méthode de dérive",
        "driftMethodOptions": {
          "jaccard": "Jaccard (basé sur les tokens)",
          "vector": "Vecteur (cosinus d'embedding)"
        },
        "driftMethodHint": "La dérive vectorielle utilise le modèle d'embedding ci-dessous ; Jaccard est purement lexical.",
        "embeddingModelLabel": "Modèle d'embedding",
        "embeddingLoading": "Chargement des modèles…",
        "embeddingNoModelsHint": "Aucun modèle d'embedding actif dans ce projet. Utilisez la dérive Jaccard ou enregistrez des modèles sous Foundation Models.",
        "embeddingPlaceholder": "Sélectionnez un modèle d'embedding",
        "embeddingRequiredHint": "Requis lorsque la méthode de dérive est Vecteur (stocké sous drift_embedding_model_id).",
        "guardrailsLabel": "Garde-fous de sécurité du contenu",
        "guardrailsHint": "Rejeter les candidats qui échouent aux vérifications de toxicité, PII, injection de prompt ou sécurité de marque",
        "guardrailBackendLabel": "Backend de garde-fous",
        "guardrailBackendOptions": {
          "builtin": "Intégré (basé sur des motifs)",
          "azureContentSafety": "Azure Content Safety",
          "awsBedrock": "AWS Bedrock Guardrails",
          "custom": "Personnalisé (point de terminaison HTTP)"
        },
        "guardrailBackendHint": "Le backend intégré exécute les vérifications PII, toxicité, jailbreak et sécurité de marque optionnelle sans API externes.",
        "checksLabel": "Vérifications à exécuter",
        "checksHint": "Les candidats échouant à une vérification sélectionnée sont rejetés avant l'évaluation.",
        "checkLabels": {
          "piiCheck": "PII",
          "toxicity": "toxicité",
          "promptInjection": "Injection de prompt",
          "jailbreak": "jailbreak",
          "brandSafety": "sécurité de marque",
          "lengthCheck": "vérification de longueur"
        }
      },
      "parameters": {
        "sectionTitle": "Paramètres",
        "maxIterationsLabel": "Itérations maximales",
        "maxIterationsEnsembleLabel": "Itérations maximales (par sous-framework)",
        "maxIterationsHint": "Plus élevé = plus de raffinement, temps d'exécution plus long",
        "maxIterationsEnsembleHint": "Chaque optimiseur parallèle s'exécute jusqu'à ce nombre d'itérations (l'ensemble utilise sub_max_iterations).",
        "timeBudgetLabel": "Budget temps (secondes)",
        "timeBudgetHint": "Plafond strict sur le temps d'exécution réel (60–14 400 s). L'exécution s'arrête lorsque le budget est atteint.",
        "maxCostLabel": "Coût maximum (USD, optionnel)",
        "maxCostPlaceholder": "Aucune limite",
        "maxCostHint": "Plafond de dépense estimé ; la session s'interrompt en cas de dépassement. Laissez vide pour aucune limite.",
        "targetScoreLabel": "Score cible (optionnel)",
        "targetScorePlaceholder": "Aucun",
        "targetScoreHint": "Arrêter tôt lorsque le score composite atteint cette valeur (0–1). Laissez vide pour continuer jusqu'aux itérations ou autres limites.",
        "candidateCountHint": "Nombre de prompts candidats générés ou évalués par itération pour cet optimiseur.",
        "evalMaxRowsLabel": "Lignes maximales du jeu d'évaluation",
        "evalMaxRowsHint": "Lignes récupérées du benchmark par évaluation (la baseline utilise le plafond complet ; les boucles internes peuvent en utiliser moins).",
        "rowsPerIterationLabel": "Lignes par évaluation de candidat (optionnel)",
        "rowsPerIterationPlaceholder": "Auto",
        "rowsPerIterationHint": "Limite les lignes lors de l'évaluation de chaque prompt proposé ; laissez vide pour automatique (environ la moitié des lignes max, min 5).",
        "earlyStoppingLabel": "Arrêt anticipé",
        "patienceHint": "Patience (cycles sans amélioration)",
        "candidateLabels": {
          "gepa": "Mutants par itération",
          "ape": "Candidats par tour",
          "opro": "Propositions par itération",
          "evoprompt": "Taille de la population",
          "rl_tuning": "Déploiements par itération"
        }
      },
      "reward": {
        "sectionTitle": "Fonction de récompense (Python)",
        "description": "Définissez votre fonction de récompense personnalisée. Elle reçoit chaque ligne d'évaluation et renvoie un signal de récompense dans [-1, 1]. La politique maximisera cette récompense."
      },
      "estimate": {
        "title": "Ressources estimées",
        "summary": "~{{calls}} appels LLM · environ ${{low}}–${{high}} USD",
        "monthlyUsed": "Utilisation mensuelle : ${{used}} / ${{limit}}",
        "acknowledge": "Je reconnais le coût estimé (jusqu'à ${{cost}} USD) et souhaite démarrer cette exécution"
      },
      "start": {
        "button": "Démarrer l'optimisation {{framework}}",
        "confirmButton": "Confirmer et démarrer",
        "changeParams": "Modifier les paramètres"
      },
      "toast": {
        "selectPrompt": "Veuillez sélectionner un prompt",
        "selectVersion": "Veuillez sélectionner une version de prompt",
        "selectDataset": "Veuillez sélectionner un jeu de données de référence",
        "selectResponseModel": "Veuillez sélectionner un modèle de réponse ou activer le multi-modèle avec au moins 2 modèles",
        "multiModelMin2": "L'optimisation multi-modèle nécessite au moins 2 modèles cibles",
        "dspyExpectedOutput": "Pour DSPy, sélectionnez une colonne de sortie attendue",
        "vectorDriftEmbedding": "La dérive vectorielle nécessite un modèle d'embedding, ou définissez la méthode de dérive sur Jaccard.",
        "embeddingForMetrics": "Sélectionnez un modèle d'embedding pour les métriques choisies.",
        "sqlForMetrics": "Sélectionnez une base de données d'exécution pour les métriques Text2SQL choisies.",
        "schemaForMetrics": "Fournissez une définition de schéma JSON valide pour la métrique de conformité de schéma.",
        "ensembleMin2": "L'ensemble nécessite au moins deux sous-frameworks",
        "unsupportedSubframework": "Sous-framework non pris en charge : {{list}}",
        "maxCostInvalid": "Le coût maximum (USD) doit être un nombre non négatif",
        "targetScoreInvalid": "Le score cible doit être compris entre 0 et 1",
        "llmCapExceeded": "Les appels LLM estimés ({{calls}}) dépassent la limite par session ({{cap}}). Réduisez les itérations ou la taille de population.",
        "cancelRequested": "Annulation de l'exécution d'optimisation demandée",
        "cancelFailed": "Échec de l'annulation de l'exécution d'optimisation"
      },
      "running": {
        "title": "Optimisation de « {{name}} »",
        "engineLabel": "Moteur :",
        "jobLabel": "Job :",
        "progressLabel": "Progression",
        "statusLabel": "Statut :",
        "statusStarting": "DÉMARRAGE",
        "iterationSuffix": " · Itération {{current}}/{{max}}",
        "initializing": "Initialisation du moteur {{engine}}...",
        "loadingDataset": "Chargement du jeu de données de référence",
        "completedIterations": "{{current}}/{{max}} itérations terminées",
        "errorPrefix": "Erreur : {{message}}",
        "cancelButton": "Annuler l'exécution"
      },
      "result": {
        "awaitingApproval": "En attente d'approbation",
        "complete": "Optimisation terminée",
        "cancelled": "Optimisation annulée",
        "failed": "Échec de l'optimisation",
        "approvalHint": "Le prompt optimisé nécessite une approbation humaine avant d'être enregistré comme nouvelle version. Vérifiez et approuvez-le sur la page de détail de l'exécution.",
        "baseline": "Référence",
        "optimized": "Optimisé",
        "iterationsSuffix": "Itérations : {{count}}",
        "evaluationsSuffix": " · Évaluations : {{count}}",
        "reviewApprove": "Vérifier et approuver",
        "viewRunDetails": "Voir les détails de l'exécution",
        "viewOptimizedVersion": "Voir la version optimisée"
      }
    },
    "runDetail": {
      "pageTitle": "Optimisation du prompt",
      "backToRuns": "Retour aux exécutions",
      "backToOptimizationRuns": "Retour aux exécutions d'optimisation",
      "notFound": "Exécution d'optimisation introuvable",
      "loading": "Chargement des détails de l'optimisation...",
      "status": {
        "completed": "terminé",
        "failed": "échoué",
        "cancelled": "annulé",
        "running": "en cours",
        "queued": "en file d'attente",
        "pending_approval": "approbation en attente"
      },
      "approvalBadge": {
        "pending": "Approbation en attente",
        "approved": "Approuvé",
        "rejected": "Rejeté"
      },
      "viewOptimizedPrompt": "Voir le prompt optimisé",
      "errorBanner": {
        "title": "Échec de l'optimisation"
      },
      "createdAt": "Créé le {{date}}",
      "approval": {
        "reviewTitle": "Vérifier le prompt optimisé",
        "reviewSubtitle": "Cette optimisation nécessite une approbation avant que le prompt optimisé ne soit enregistré comme nouvelle version.",
        "reasonPlaceholder": "Raison facultative pour l'approbation/le rejet...",
        "reject": "Rejeter",
        "approve": "Approuver et enregistrer comme nouvelle version",
        "approvedMessage": "Prompt approuvé et enregistré comme nouvelle version.",
        "rejectedMessage": "Prompt rejeté. Aucune nouvelle version n'a été créée.",
        "promptApprovedTitle": "Prompt approuvé",
        "promptRejectedTitle": "Prompt rejeté",
        "approvedSubtitle": "Ce prompt optimisé a été approuvé et enregistré comme nouvelle version.",
        "rejectedSubtitle": "Ce prompt optimisé a été rejeté. Aucune nouvelle version n'a été créée."
      },
      "diff": {
        "originalPrompt": "Prompt original",
        "optimizedPrompt": "Prompt optimisé"
      },
      "tabs": {
        "overview": "Aperçu",
        "insights": "Analyses",
        "rowMetrics": "Métriques par ligne",
        "candidates": "Candidats",
        "trace": "Trace",
        "abTest": "Test A/B",
        "configuration": "Configuration"
      },
      "configView": {
        "formatted": "Formaté",
        "raw": "Brut",
        "copy": "Copier",
        "copied": "Copié"
      },
      "metrics": {
        "baselineScore": "Score de référence",
        "optimizedScore": "Score optimisé",
        "improvement": "Amélioration",
        "holdoutScore": "Score de retenue",
        "holdoutSubValue": "Score réel sur l'ensemble retenu",
        "iterations": "Itérations",
        "iterationsSubValue": "sur {{max}} max",
        "evaluations": "Évaluations",
        "duration": "Durée",
        "totalTokens": "Jetons totaux",
        "tokensSubValue": "{{prompt}} prompt / {{completion}} complétion",
        "estimatedCost": "Coût estimé",
        "estimatedCostSubValue": "Consommation LLM"
      },
      "orchestrator": {
        "label": "Orchestrateur",
        "openRun": "Ouvrir l'exécution du workflow"
      },
      "earlyStopping": {
        "label": "Arrêt anticipé",
        "completedOf": "{{completed}} sur {{max}} itérations configurées terminées."
      },
      "perModelScores": {
        "title": "Scores par modèle (exécution indépendante du modèle)",
        "desc": "Le score global ci-dessus est dérivé de ces scores par modèle. Le prompt a été évalué sur chaque modèle de base."
      },
      "coproDescription": "COPRO : votre paramètre <strong>itérations maximales</strong> correspond à la profondeur d'optimisation ({{depth}}). Chaque profondeur évalue plusieurs prompts proposés (largeur {{breadth}}), donc le graphique de score liste {{candidatesTracked}} — pas seulement un point par étape de profondeur.",
      "coproScoredCandidates": "{{count}} candidats notés",
      "coproOneRowPerCandidate": "une ligne par candidat noté",
      "miproDescription": "MIPROv2 : <strong>Itérations maximales</strong> ({{trials}}) correspond au nombre d'essais d'optimisation bayésienne. Le graphique et la liste des candidats montrent les prompts évalués sur l'ensemble de validation <strong>complet</strong> (les sondages en minibatch seul sont omis), donc le nombre de lignes ({{rows}}) peut différer des essais — surtout lorsque le minibatching est activé.",
      "scoreChartTitle": "Progression du score",
      "scoreChartXAxis": "Itération",
      "scoreChartYAxis": "Score agrégé",
      "scoreChartYAxisAggregated": "Score agrégé ({{strategy}})",
      "scoreChartAggregation": {
        "mean": "Moyenne",
        "min": "Min",
        "pareto": "Pareto"
      },
      "chartTooltip": "Itération {{iteration}} : {{score}}",
      "chartTooltipBestSuffix": " (meilleur)",
      "insights": {
        "title": "Analyses de l'optimiseur",
        "foundationModel": "Modèle de base",
        "judgeModel": "Modèle juge",
        "evalMetrics": "Métriques d'évaluation",
        "mutationModel": "Modèle de mutation",
        "targetScore": "Score cible",
        "timeBudget": "Budget de temps",
        "defaultModel": "Par défaut (défaut du serveur)"
      },
      "componentsTitle": "Composants optimisés",
      "rowEvaluations": {
        "title": "Évaluations par ligne",
        "sourceLabel": "Source :",
        "source": {
          "optimization_trace": "Meilleure passe de référence de la trace de l'optimiseur",
          "final_eval": "Évaluation post-exécution du prompt optimisé sur le jeu de données",
          "none": "Aucune ligne de jeu de données n'a été évaluée pour cette exécution",
          "failed": "Impossible de capturer l'instantané des lignes"
        },
        "metricsConfigured": "Métriques configurées : {{metrics}}.",
        "emptyFailed": "L'optimiseur a terminé, mais l'enregistrement des scores par ligne a échoué. Vérifiez les journaux serveur.",
        "emptyNoDataset": "Cette exécution n'a produit aucun score par ligne (pas de jeu de données ou de lignes d'évaluation).",
        "emptyDefault": "Aucune ligne n'a été renvoyée pour cette session.",
        "columns": {
          "index": "#",
          "input": "Entrée / question",
          "generatedAnswer": "Réponse générée",
          "metrics": "Métriques",
          "score": "Score",
          "reasoning": "Raisonnement"
        },
        "expectedOutput": "Sortie attendue"
      },
      "candidates": {
        "title": "Prompts candidats ({{count}})",
        "iteration": "Itération {{iteration}}",
        "candidateLabel": "Candidat {{index}}",
        "best": "Meilleur",
        "driftRejected": "Dérive rejetée",
        "guardrails": "Garde-fous",
        "rejectionReason": "Motif de rejet :"
      },
      "trace": {
        "title": "Trace d'optimisation ({{count}} entrées)",
        "iter": "Iter {{iteration}}"
      },
      "abTest": {
        "dailyTrafficLabel": "Trafic quotidien attendu (facultatif) :",
        "dailyTrafficPlaceholder": "ex. 10000",
        "generateButton": "Générer un test A/B",
        "generating": "Génération…",
        "variantsLabel": "Variantes",
        "sampleSizeLabel": "Taille d'échantillon par variante",
        "sampleSizeValue": "{{perVariant}} (total {{total}})",
        "improvementCiLabel": "Amélioration (IC)",
        "recommendedDurationLabel": "Durée recommandée",
        "durationDays": "~{{days}} jours",
        "durationHours": "~{{hours}} heures",
        "variantPromptsSummary": "Prompts des variantes",
        "controlLabel": "Contrôle (A)",
        "treatmentLabel": "Traitement (B)"
      },
      "metadataLabels": {
        "meta_model": "Méta-modèle",
        "reflection_model": "Modèle de réflexion",
        "stale_rounds": "Rounds stagnants",
        "population_size": "Taille de population",
        "gradient_model": "Modèle de gradient",
        "mutation_model": "Modèle de mutation",
        "gen_model": "Modèle de génération",
        "policy_model": "Modèle de politique",
        "optimizer_model": "Modèle d'optimiseur",
        "compiler": "Compilateur DSPy",
        "dspy_version": "Version DSPy",
        "dspy_copro": "COPRO (profondeur / largeur)",
        "final_avg_reward": "Récompense moyenne finale",
        "baseline_reward": "Récompense de référence",
        "reward_function": "Fonction de récompense",
        "objectives": "Objectifs",
        "pareto_size": "Taille du front de Pareto",
        "early_stopping_reason": "Arrêt anticipé",
        "ensemble_frameworks": "Sous-frameworks d'ensemble",
        "fusion_strategy": "Stratégie de fusion"
      },
      "frameworkTier": {
        "dspy": "Optimisation de programme déclaratif",
        "opro": "Méta-prompting / LLM en tant qu'optimiseur",
        "reflexion": "Raffinement auto-réflexif",
        "gepa": "Recherche évolutive réflexive",
        "evoprompt": "Recherche évolutive + LLM",
        "ape": "Ingénierie automatique de prompts",
        "textgrad": "Rétropropagation textuelle",
        "rl_tuning": "Optimisation de politique basée sur le RL",
        "rag_aware": "Optimisation conjointe augmentée par récupération",
        "multi_obj": "Optimisation Pareto multi-objectifs",
        "ensemble": "Fusion multi-frameworks",
        "cot": "Prompting structuré par raisonnement"
      }
    },
    "comparison": {
      "backAriaLabel": "Retour",
      "title": "Comparer les exécutions d'optimisation",
      "subtitle": "Sélectionnez un prompt, puis choisissez 2 exécutions terminées ou plus pour comparer les trajectoires, les frameworks et les sorties optimisées",
      "promptFieldLabel": "Prompt",
      "promptPlaceholder": "Sélectionner un prompt...",
      "runsFieldLabel": "Exécutions d'optimisation",
      "runsFilterLabel": "Exécutions d'optimisation",
      "selectPromptFirst": "Sélectionnez d'abord un prompt",
      "loadingRuns": "Chargement…",
      "noCompletedRuns": "Aucune exécution terminée",
      "clearSelection": "Effacer la sélection",
      "compareButton": "Comparer ({{count}} sélectionnées)",
      "selectAtLeastTwo": "Sélectionnez au moins 2 exécutions à comparer.",
      "genericCompareError": "Échec de la comparaison des sessions",
      "scoreTrajectoriesTitle": "Trajectoires de score",
      "yAxisScore": "Score",
      "xAxisIteration": "Itération",
      "summaryTitle": "Résumé",
      "exportCsvTitle": "Exporter en CSV",
      "columns": {
        "framework": "Framework",
        "original": "Original",
        "optimized": "Optimisé",
        "improvement": "Amélioration",
        "holdout": "Retenue",
        "duration": "Durée",
        "iterations": "Itérations",
        "actions": "Actions"
      },
      "view": "Voir",
      "promptComparisonTitle": "Comparaison de prompts",
      "selectPromptVersion": "Sélectionner une version de prompt...",
      "originalPromptLabel": "Original",
      "optimizedPromptLabel": "Optimisé",
      "originalPromptOption": "Prompt original",
      "noPromptContent": "(Aucun contenu de prompt disponible)",
      "csv": {
        "sessionId": "ID de session",
        "framework": "Framework",
        "originalScore": "Score original",
        "optimizedScore": "Score optimisé",
        "improvementPct": "Amélioration %",
        "holdoutScore": "Score de retenue",
        "duration": "Durée",
        "iterations": "Itérations",
        "evaluations": "Évaluations"
      }
    },
    "editPage": {
      "backAriaLabel": "Retour aux prompts",
      "backToPrompts": "Retour aux prompts",
      "platformTooltip": "Prompt système intégré au code — lecture seule",
      "platformBadge": "Plateforme",
      "versionsCount": "{{count}} versions",
      "targetModelTooltip": "Modèle cible",
      "allModels": "Tous les modèles",
      "changeModelTooltip": "Changer de modèle ou cloner",
      "changeModelHeader": "Changer de modèle",
      "modelAgnostic": "Indépendant du modèle (tous les modèles)",
      "autoSavingAriaLabel": "Enregistrement automatique de la description",
      "autoSaving": "Enregistrement automatique...",
      "autoSaveTooltip": "Seule la description est enregistrée automatiquement. Les modifications du contenu du prompt nécessitent un commit manuel.",
      "loadingPrompt": "Chargement du prompt...",
      "notFound": "Prompt introuvable",
      "contentPlaceholder": "Saisissez le contenu du prompt... Utilisez {{syntax}} pour référencer des variables d'état.",
      "comingSoon": "Bientôt disponible...",
      "targetModelLabel": "Modèle cible *",
      "selectModelPlaceholder": "Sélectionner un modèle...",
      "cloning": "Clonage...",
      "tabs": {
        "text": "Texte du prompt",
        "diffs": "Différences du prompt",
        "testing": "Test du prompt",
        "evals": "Évaluations du prompt",
        "metrics": "Métriques"
      },
      "testing": {
        "title": "Test du prompt",
        "description": "Testez vos prompts avec différentes entrées et modèles"
      },
      "evals": {
        "title": "Évaluations du prompt",
        "description": "Évaluez les performances et la qualité du prompt"
      },
      "metrics": {
        "title": "Métriques d'optimisation",
        "description": "Cette version a été créée par optimisation IA",
        "descriptionWithFramework": "Cette version a été créée par optimisation IA ({{framework}})",
        "baselineScore": "Score de référence",
        "optimizedScore": "Score optimisé",
        "improvement": "Amélioration",
        "iterations": "Itérations",
        "evaluations": "Évaluations",
        "duration": "Durée",
        "viewAllRuns": "Voir toutes les exécutions d'optimisation"
      },
      "toast": {
        "retagged": "Réaffecté à « {{modelId}} »",
        "setModelAgnostic": "Défini comme indépendant du modèle",
        "cloned": "Prompt cloné pour « {{modelId}} »",
        "forkedSuccess": "Version clonée avec succès",
        "noChangesToCommit": "Aucune modification à valider",
        "enterCommitMessage": "Veuillez saisir un message de commit",
        "platformReadOnlyFork": "Les prompts de plateforme sont en lecture seule et ne peuvent pas être clonés",
        "platformReadOnlyModify": "Les prompts de plateforme sont en lecture seule et ne peuvent pas être modifiés"
      }
    },
    "playground": {
      "loadingPlayground": "Chargement du playground...",
      "unableToLoad": "Impossible de charger le prompt. Veuillez réessayer.",
      "unableToLoadSessions": "Impossible de charger les sessions de chat.",
      "headerTitle": "{{name}} — Playground",
      "versionOption": "v{{version}}",
      "versionOptionCurrent": "v{{version}} (actuelle)",
      "selectModelOption": "Sélectionner un modèle...",
      "loadingSession": "Chargement de la session...",
      "noModelSelected": "Aucun modèle sélectionné",
      "typeMessage": "Tapez un message...",
      "emptyStateTitleFallback": "Playground",
      "emptyStateMessage": "Commencez à tester votre prompt",
      "noResponseGenerated": "(Aucune réponse générée)",
      "toast": {
        "noModelsAvailable": "Aucun modèle disponible",
        "promptNotLoaded": "Prompt non chargé",
        "noModelsAvailableAddOne": "Aucun modèle disponible. Veuillez d'abord ajouter un modèle.",
        "switchedModel": "Passé à {{name}}",
        "stopBeforeSending": "Veuillez arrêter la réponse en cours avant d'envoyer un nouveau message",
        "uploadAttachmentsFailed": "Échec du téléversement des pièces jointes",
        "messageNotFoundForRetry": "Message introuvable pour la nouvelle tentative",
        "noUserMessageToRegenerate": "Aucun message utilisateur trouvé à régénérer",
        "cannotRegenerateEmptyContent": "Impossible de régénérer : le message utilisateur est vide",
        "cannotRetryMessageType": "Impossible de réessayer ce type de message",
        "addAttachmentFailed": "Échec de l'ajout de la pièce jointe : {{name}}"
      }
    },
    "runsPage": {
      "title": "Optimisation des prompts",
      "subtitle": "Historique de tous les cycles d'optimisation pour vos prompts",
      "backToPrompts": "Retour aux prompts",
      "compareRuns": "Comparer les cycles",
      "newOptimization": "Nouvelle optimisation",
      "loadingMessage": "Chargement des cycles d'optimisation...",
      "emptyMessage": "Aucun cycle d'optimisation pour le moment. Cliquez sur « Nouvelle optimisation » pour commencer.",
      "status": {
        "queued": "En attente",
        "running": "En cours",
        "completed": "Terminé",
        "failed": "Échoué",
        "cancelled": "Annulé"
      },
      "columns": {
        "promptName": "Nom du prompt",
        "framework": "Framework",
        "status": "Statut",
        "metrics": "Métriques",
        "improvementPct": "Amélioration %",
        "cost": "Coût",
        "tokens": "Jetons",
        "createdBy": "Créé par",
        "createdAt": "Créé le",
        "updatedAt": "Mis à jour le",
        "actions": "Actions"
      },
      "tokensTooltip": "Prompt : {{prompt}} | Complétion : {{completion}}",
      "actions": {
        "retry": "Réessayer",
        "delete": "Supprimer"
      },
      "retryConfirm": "Démarrer une nouvelle optimisation pour « {{label}} » avec le même framework et les mêmes options que ce cycle ?",
      "retryDefaultLabel": "ce prompt",
      "deleteConfirm": "Supprimer la session d'optimisation pour « {{label}} » ? Cette action est irréversible.",
      "deleteDefaultLabel": "cette session",
      "toast": {
        "newRunStarted": "Nouveau cycle d'optimisation démarré.",
        "retryFailed": "Échec de la nouvelle tentative d'optimisation.",
        "sessionDeleted": "Session d'optimisation supprimée.",
        "deleteSessionFailed": "Échec de la suppression de la session.",
        "bulkDeleteWarning": "{{deleted}} cycle(s) supprimé(s) ; {{skipped}} n'ont pas pu être supprimés.{{detail}}",
        "bulkDeleteSuccess_one": "{{count}} cycle d'optimisation supprimé.",
        "bulkDeleteSuccess_other": "{{count}} cycles d'optimisation supprimés.",
        "bulkDeleteFailed": "Échec de la suppression des cycles d'optimisation sélectionnés."
      },
      "bulkDelete": {
        "selectedLabel": "Supprimer la sélection",
        "title": "Supprimer les cycles sélectionnés",
        "message_one": "Voulez-vous vraiment supprimer {{count}} cycle d'optimisation ? Cette action est irréversible.",
        "message_other": "Voulez-vous vraiment supprimer {{count}} cycles d'optimisation ? Cette action est irréversible.",
        "confirmLabel_one": "Supprimer {{count}} cycle",
        "confirmLabel_other": "Supprimer {{count}} cycles"
      }
    },
    "optimizationLogModal": {
      "title": {
        "complete": "Optimisation terminée",
        "cancelled": "Optimisation annulée",
        "failed": "Échec de l'optimisation",
        "running": "Optimisation en cours..."
      },
      "subtitleDefault": "Prompt",
      "closeAriaLabel": "Fermer",
      "progressLabel": "Progression",
      "statusLabel": "Statut :",
      "statusStarting": "DÉMARRAGE",
      "iterationSuffix": " · Itération {{iteration}}/{{max}}",
      "bestSuffix": " · Meilleur : {{value}}",
      "runIdLabel": "ID du cycle :",
      "jobIdLabel": "ID du job :",
      "initializingEngine": "Initialisation du moteur {{framework}}...",
      "loadingDataset": "Chargement du jeu de données de référence",
      "completedIterations": "{{completed}}/{{max}} itérations terminées",
      "cancelRun": "Annuler le cycle",
      "viewResults": "Voir les résultats"
    },
    "commitMessageModal": {
      "title": "Valider la version",
      "closeAriaLabel": "Fermer",
      "description": "Saisissez un message de commit pour décrire les modifications de cette version.",
      "placeholder": "ex. : Correction d'une faute de frappe dans le prompt, ajout de nouveaux exemples...",
      "commit": "Valider",
      "committing": "Validation en cours..."
    },
    "diffView": {
      "noVersionsTitle": "Aucune version à comparer",
      "noVersionsDesc": "Créez d'autres versions pour voir les différences entre elles.",
      "baseLabel": "base :",
      "compareLabel": "comparer :",
      "swapTooltip": "Inverser base et comparaison",
      "fileLabel": "prompt.txt",
      "collapseContextTooltip": "Réduire le contexte",
      "expandContextTooltip": "Développer le contexte",
      "copyDiffTooltip": "Copier le diff",
      "loadingDiff": "Chargement du diff...",
      "expandHiddenLines": "Afficher {{count}} lignes masquées",
      "sameVersionTitle": "Même version sélectionnée",
      "sameVersionDesc": "Sélectionnez des versions différentes pour voir les différences.",
      "noDifferencesTitle": "Aucune différence",
      "noDifferencesDesc": "Ces versions sont identiques.",
      "toast": {
        "copied": "Diff copié dans le presse-papiers"
      }
    },
    "versionList": {
      "title": "Versions",
      "refreshTooltip": "Actualiser les versions",
      "searchPlaceholder": "Rechercher des versions...",
      "emptyMessage": "Aucune version trouvée"
    },
    "versionItem": {
      "commitTooltip": "Valider la version",
      "commitLabel": "Valider",
      "forkTooltip": "Créer une branche de la version {{version}}",
      "forkLabel": "Fork",
      "createdByPrefix": "par {{name}}",
      "wordCount_one": "{{count}} mot",
      "wordCount_other": "{{count}} mots"
    },
    "visibilitySelector": {
      "label": "Visibilité",
      "platformDescription": "Disponible dans tous les projets de la plateforme",
      "projectDescription": "Disponible uniquement dans le projet sélectionné",
      "platformHint": "Le prompt sera disponible dans tous les projets de la plateforme.",
      "projectHint": "Le prompt sera disponible uniquement dans le projet sélectionné.",
      "projectLabel": "Projet",
      "selectProjectPlaceholder": "Sélectionner un projet",
      "searchProjectsPlaceholder": "Rechercher des projets..."
    }
  },
  "data": {
    "tabs": {
      "knowledge": "Connaissances",
      "graph": "Graphe",
      "vector": "Base de données vectorielle",
      "storage": "Stockage"
    }
  },
  "knowledge": {
    "connections": {
      "tabs": {
        "databases": "Bases de données",
        "storage": "Comptes de stockage",
        "orchestrators": "Orchestrateurs",
        "telephony": "Téléphonie",
        "service_connections": "Connexions de service"
      }
    },
    "serviceConnectionModal": {
      "titleCreate": "Ajouter une connexion de service",
      "titleEdit": "Modifier la connexion de service",
      "titleView": "Voir la connexion de service",
      "loadingTypes": "Chargement des types de service…",
      "loadingQuota": "Vérification du quota…",
      "groups": {
        "microsoft": "Microsoft",
        "developer_tools": "Outils de développement",
        "google": "Google",
        "business_apps": "Applications métier",
        "messaging_and_events": "Messagerie et événements",
        "http_and_webhooks": "HTTP et webhooks",
        "ai_search": "Recherche IA",
        "observability": "Observabilité",
        "other": "Autre"
      },
      "fields": {
        "name": "Nom",
        "description": "Description",
        "iam": "Entrée IAM",
        "iamPlaceholder": "Sélectionner une entrée IAM",
        "host": "Hôte résolu",
        "advanced": "Avancé (facultatif)"
      },
      "hints": {
        "iamEmpty": "Aucune entrée IAM active ne correspond à {{subtypes}}. Créez-en une dans IAM.",
        "iamLink": "Ouvrir IAM",
        "inbound": "Les connexions de service entrantes n'utilisent pas d'entrée IAM.",
        "testRequired": "Testez la connexion avant d'enregistrer.",
        "secretsOnIam": "Les secrets restent sur l'entrée IAM et ne sont jamais stockés ici.",
        "missing": "Obligatoire : {{fields}}"
      },
      "buttons": {
        "back": "Retour",
        "close": "Fermer",
        "cancel": "Annuler",
        "create": "Créer",
        "save": "Enregistrer"
      },
      "toasts": {
        "created": "Connexion de service créée",
        "updated": "Connexion de service mise à jour"
      },
      "errors": {
        "testFailed": "Échec du test de connexion",
        "selectTenant": "Sélectionnez un locataire",
        "selectProject": "Sélectionnez un projet",
        "saveFailed": "Impossible d'enregistrer la connexion de service"
      }
    },
    "connectorsTab": {
      "testErrorToast": "Échec du test de connexion",
      "batchTestSuccessToast_one": "Test de connexion réussi pour {{count}} connexion importée",
      "batchTestSuccessToast_other": "Test de connexion réussi pour {{count}} connexions importées",
      "batchTestFailedToast_one": "Test de connexion échoué pour {{count}} connexion importée",
      "batchTestFailedToast_other": "Test de connexion échoué pour {{count}} connexions importées",
      "batchTestFinishedToast": "Tests de connexion terminés : {{success}} réussis, {{fail}} échoués",
      "loadErrorToast": "Impossible de charger les connecteurs",
      "loadingMessage": "Chargement des connexions...",
      "filterResourceLabel": {
        "database": "Moteur de base de données",
        "storage": "Type de stockage",
        "orchestrator": "Type d'orchestrateur",
        "telephony": "Type de téléphonie",
        "service": "Type de service"
      },
      "filterAllTypesPlaceholder": "Tous les types",
      "filterCreatorLabel": "Créateur",
      "filterAllCreatorsPlaceholder": "Tous les créateurs",
      "filterStatusLabel": "Statut",
      "filterAllStatusesPlaceholder": "Tous les statuts",
      "filterStatusError": "Erreur",
      "deletePermissionDeniedToast": "Vous n'êtes pas autorisé à supprimer ce connecteur",
      "deleteErrorToast": "Échec de la suppression du connecteur",
      "bulkDeletePermissionDeniedToast": "Vous n'êtes pas autorisé à supprimer des connecteurs",
      "bulkDeletePartialWarning": "{{deleted}} connecteur(s) supprimé(s), {{skipped}} échoué(s) : {{errors}}",
      "bulkDeleteSuccessToast_one": "{{count}} connecteur supprimé avec succès",
      "bulkDeleteSuccessToast_other": "{{count}} connecteurs supprimés avec succès",
      "bulkDeleteErrorToast": "Échec de la suppression des connecteurs",
      "unsetDefaultToast": "{{name}} n'est plus le {{category}} par défaut",
      "setDefaultToast": "{{name}} est maintenant le {{category}} par défaut",
      "unsetDefaultErrorToast": "Impossible de retirer le {{category}} par défaut",
      "setDefaultErrorToast": "Impossible de définir le {{category}} par défaut",
      "status": {
        "active": "Actif",
        "failed": "Échec",
        "notTested": "Non testé",
        "unknown": "Inconnu"
      },
      "statusTooltip": "Statut : {{status}}",
      "authModeTooltip": "Authentification : {{mode}}",
      "columnName": "Nom",
      "columnCloud": "Cloud",
      "columnResource": "Ressource",
      "columnType": "Type",
      "columnHost": "Hôte",
      "columnStatus": "Statut",
      "columnLastTested": "Dernier test",
      "columnCreatedBy": "Créé par",
      "columnUpdatedBy": "Modifié par",
      "columnActions": "Actions",
      "actionView": "Afficher",
      "actionTestConnection": "Tester la connexion",
      "actionRemoveAsDefault": "Retirer comme {{category}} par défaut",
      "actionSetAsDefault": "Définir par défaut",
      "actionExport": "Exporter",
      "actionEdit": "Modifier",
      "actionDelete": "Supprimer",
      "entityFilterAllLabel": "Tous",
      "entityFilterFavoritesLabel": "Favoris",
      "bulkExportSelected": "Exporter la sélection",
      "bulkDeleteSelected": "Supprimer la sélection",
      "emptyMessage": "Aucun connecteur trouvé. Ajoutez une connexion pour vous connecter à des bases de données, du stockage ou d'autres sources de données.",
      "addConnection": "Ajouter une connexion",
      "deleteDialogTitle": "Supprimer le connecteur",
      "deleteDialogMessage": "Voulez-vous vraiment supprimer « {{name}} » ? Cela supprimera également toutes les tables enregistrées de ce connecteur.",
      "deleteDialogConfirmLabel": "Supprimer",
      "bulkDeleteDialogTitle": "Supprimer les connecteurs sélectionnés",
      "bulkDeleteDialogMessage_one": "Voulez-vous vraiment supprimer {{count}} connecteur ? Cela supprimera également toutes les tables enregistrées de ces connecteurs. Cette action est irréversible.",
      "bulkDeleteDialogMessage_other": "Voulez-vous vraiment supprimer {{count}} connecteurs ? Cela supprimera également toutes les tables enregistrées de ces connecteurs. Cette action est irréversible.",
      "bulkDeleteDialogConfirmLabel_one": "Supprimer {{count}} connecteur",
      "bulkDeleteDialogConfirmLabel_other": "Supprimer {{count}} connecteurs"
    },
    "tab": {
      "unknownConnectorType": "Inconnu",
      "filterEngineLabel": "Moteur de base de données",
      "filterAllEnginesPlaceholder": "Tous les moteurs",
      "filterCreatorLabel": "Créateur",
      "filterAllCreatorsPlaceholder": "Tous les créateurs",
      "deleteErrorToast": "Échec de la suppression de la table de connaissances",
      "bulkDeletePartialWarning": "{{deleted}} table(s) supprimée(s), {{skipped}} échouée(s) : {{errors}}",
      "bulkDeleteSuccessToast_one": "{{count}} table supprimée avec succès",
      "bulkDeleteSuccessToast_other": "{{count}} tables supprimées avec succès",
      "bulkDeleteErrorToast": "Échec de la suppression des tables",
      "deleteSchemaErrorToast": "Échec de la suppression du schéma",
      "deleteSchemaPartialWarning": "{{deleted}} table(s) supprimée(s) sur {{schemaCount}} schéma(s) ; {{skipped}} échouée(s)",
      "deleteSchemaSuccessToast_one": "Schéma supprimé ({{count}} table)",
      "deleteSchemaSuccessToast_other": "Schéma supprimé ({{count}} tables)",
      "deleteSchemaSuccessToastNamed_one": "Schéma « {{schema}} » supprimé ({{count}} table)",
      "deleteSchemaSuccessToastNamed_other": "Schéma « {{schema}} » supprimé ({{count}} tables)",
      "deleteSchemasSuccessToast_one": "{{schemaCount}} schémas supprimés ({{count}} table)",
      "deleteSchemasSuccessToast_other": "{{schemaCount}} schémas supprimés ({{count}} tables)",
      "syncRequeuedToast": "Synchronisation des métadonnées remise en file (était bloquée) pour « {{name}} »",
      "syncQueuedToast": "Synchronisation des métadonnées mise en file pour « {{name}} »",
      "syncQueueErrorToast": "Impossible de mettre en file la synchronisation des métadonnées pour « {{name}} »",
      "bulkSyncStartedRequeuedToast_one": "Synchronisation des métadonnées démarrée pour {{count}} table (introspection bloquée remise en file)",
      "bulkSyncStartedRequeuedToast_other": "Synchronisation des métadonnées démarrée pour {{count}} tables (introspection bloquée remise en file)",
      "bulkSyncStartedToast_one": "Synchronisation des métadonnées démarrée pour {{count}} table",
      "bulkSyncStartedToast_other": "Synchronisation des métadonnées démarrée pour {{count}} tables",
      "bulkSyncStartErrorToast": "Impossible de démarrer la synchronisation groupée des métadonnées",
      "columnName": "Nom",
      "defaultBadgeTooltip": "Par défaut",
      "schemaTooltip": "Schéma : {{schema}}",
      "columnDatabase": "Base de données",
      "columnType": "Type",
      "columnRows": "Lignes",
      "columnIntrospection": "Introspection",
      "syncStatus": {
        "queued": "En file",
        "running": "En cours",
        "synced": "Synchronisé",
        "failed": "Échec",
        "active": "Actif"
      },
      "viewSyncLogsTooltip": "Afficher les journaux de synchronisation",
      "columnStatus": "Statut",
      "columnCreated": "Créé",
      "columnUpdated": "Modifié",
      "columnCreator": "Créateur",
      "unknownCreator": "Inconnu",
      "columnLogs": "Journaux",
      "viewLink": "Afficher",
      "columnActions": "Actions",
      "actionViewDetails": "Voir les détails",
      "actionPreviewData": "Aperçu des données",
      "actionApprovals": "Approbations",
      "actionEvals": "Évaluations",
      "actionEdit": "Modifier",
      "actionRequeueSync": "Remettre la synchro en file",
      "actionSyncMetadata": "Synchroniser les métadonnées",
      "actionExport": "Exporter",
      "actionDelete": "Supprimer",
      "databaseViewLabel": "Vue base de données",
      "collectionViewLabel": "Vue collection",
      "addGraphTable": "Ajouter une table de graphe",
      "addKnowledgeTable": "Ajouter une table de connaissances",
      "leafTitleTables": "Tables",
      "leafTitleGraphTables": "Tables de graphe",
      "defaultSchemaLabel": "(par défaut)",
      "entityFilterAllLabel": "Tous",
      "entityFilterFavoritesLabel": "Favoris",
      "noGraphConnectorsEmptyMessage": "Aucun connecteur de base de graphe pour l'instant.",
      "noDataConnectorsEmptyMessage": "Aucun connecteur de données pour l'instant.",
      "schemasPaneTitle": "Schémas",
      "bulkExportSelected": "Exporter la sélection",
      "bulkSyncMetadata": "Synchroniser les métadonnées",
      "bulkDeleteSelected": "Supprimer la sélection",
      "graphDataExplorerAriaLabel": "Explorateur de données de graphe",
      "knowledgeDataExplorerAriaLabel": "Explorateur de données de connaissances",
      "deleteDialogTitle": "Supprimer la table de connaissances",
      "deleteDialogMessage": "Voulez-vous vraiment supprimer « {{name}} » ? Cette action est irréversible.",
      "deleteDialogConfirmLabel": "Supprimer",
      "deleteSchemaDialogTitle": "Supprimer le schéma",
      "deleteSchemasDialogTitle": "Supprimer les schémas",
      "deleteSchemaDialogMessage_one": "Voulez-vous vraiment supprimer le schéma « {{schema}} » et la {{count}} table enregistrée qu'il contient ? Cela ne supprime que les métadonnées {{brand}} et est irréversible.",
      "deleteSchemaDialogMessage_other": "Voulez-vous vraiment supprimer le schéma « {{schema}} » et les {{count}} tables enregistrées qu'il contient ? Cela ne supprime que les métadonnées {{brand}} et est irréversible.",
      "deleteSchemasDialogMessage_one": "Voulez-vous vraiment supprimer {{schemaCount}} schémas et la {{count}} table enregistrée qu'ils contiennent ? Cela ne supprime que les métadonnées {{brand}} et est irréversible.",
      "deleteSchemasDialogMessage_other": "Voulez-vous vraiment supprimer {{schemaCount}} schémas et les {{count}} tables enregistrées qu'ils contiennent ? Cela ne supprime que les métadonnées {{brand}} et est irréversible.",
      "deletingLabel": "Suppression…",
      "deleteSchemasDialogConfirmLabel": "Supprimer {{count}} schémas",
      "andOthersLabel": "{{names}} et {{count}} autres",
      "bulkDeleteDialogTitle": "Supprimer les tables sélectionnées",
      "bulkDeleteDialogMessage_one": "Voulez-vous vraiment supprimer {{count}} table ? Cette action est irréversible.",
      "bulkDeleteDialogMessage_other": "Voulez-vous vraiment supprimer {{count}} tables ? Cette action est irréversible.",
      "bulkDeleteDialogConfirmLabel_one": "Supprimer {{count}} table",
      "bulkDeleteDialogConfirmLabel_other": "Supprimer {{count}} tables",
      "emptyStatePermissionDenied": "Vous n'êtes pas autorisé à afficher {{resource}}. Contactez votre administrateur.",
      "emptyStateSearching": "Aucun(e) {{resource}} ne correspond à votre recherche.",
      "emptyStateDefault": "Aucun(e) {{resource}} trouvé(e). Créez votre premier(ère) {{resourceSingular}} pour commencer.",
      "resourceGraphTables": "tables de graphe",
      "resourceGraphTable": "table de graphe",
      "resourceKnowledgeTables": "tables de connaissances",
      "resourceKnowledgeTable": "table de connaissances"
    },
    "addTableModal": {
      "title": "Ajouter une table de connaissances",
      "closeDialogAriaLabel": "Fermer la boîte de dialogue",
      "cancelButton": "Annuler",
      "loadConnectorsError": "Échec du chargement des connecteurs",
      "noDatabasesFoundWarning": "Aucune base de données trouvée. Le connecteur n'a peut-être pas accès à des bases de données.",
      "loadTablesTimedOut": "Le chargement des tables a expiré. Essayez une portée plus restreinte ou vérifiez votre connexion.",
      "loadTablesForSchemaError": "Échec du chargement des tables pour le schéma",
      "loadingTablesForSchema": "Chargement des tables pour {{schema}}...",
      "schemaFallbackLabel": "schéma",
      "inlineSearch": {
        "defaultPlaceholder": "Rechercher",
        "clearAriaLabel": "Effacer la recherche"
      },
      "breadcrumb": {
        "backAriaLabel": "Retour",
        "schemasCount_one": "{{count}} schéma",
        "schemasCount_other": "{{count}} schémas"
      },
      "connectorSelection": {
        "emptyTitle": "Aucun connecteur",
        "emptyMessage": "Créez d'abord un connecteur pour ajouter des tables de connaissances",
        "filterByTypeLabel": "Filtrer par type de connecteur",
        "connectorTypeLabel": "Type de connecteur",
        "allConnectorTypesPlaceholder": "Tous les types de connecteurs ({{count}})",
        "searchPlaceholder": "Rechercher des connecteurs",
        "noMatchingConnections": "Aucune connexion correspondante. Ajustez la recherche ou choisissez un autre type de connecteur."
      },
      "databaseSelection": {
        "loadingCatalog": "Chargement du catalogue…",
        "catalogUnavailableTitle": "Catalogue indisponible",
        "catalogUnavailableMessage": "Impossible de charger le catalogue. Vérifiez la configuration du connecteur et réessayez.",
        "noDatabasesTitle": "Aucune base de données trouvée",
        "noDatabasesMessage": "Le connecteur n'a pas accès aux bases de données, ou l'introspection a échoué.",
        "title": "Sélectionner une base de données",
        "countLabel_one": "{{shown}} sur {{count}} base de données",
        "countLabel_other": "{{shown}} sur {{count}} bases de données",
        "searchPlaceholder": "Rechercher des bases de données",
        "noMatchMessage": "Aucune base de données ne correspond à votre recherche.",
        "schemaCount_one": "{{count}} schéma",
        "schemaCount_other": "{{count}} schémas"
      },
      "schemaSelection": {
        "title": "Sélectionner un schéma",
        "countLabel_one": "{{shown}} sur {{count}} schéma",
        "countLabel_other": "{{shown}} sur {{count}} schémas",
        "selectedCount": "{{count}} sélectionné(s)",
        "deselectAll": "Tout désélectionner",
        "selectAll": "Tout sélectionner",
        "continueWith_one": "Continuer avec {{count}} schéma",
        "continueWith_other": "Continuer avec {{count}} schémas",
        "searchPlaceholder": "Rechercher des schémas",
        "hint": "Cochez des schémas et cliquez sur Continuer pour les parcourir un par un, ou cliquez sur une carte pour ouvrir un schéma.",
        "noMatchMessage": "Aucun schéma ne correspond à votre recherche.",
        "selectSchemaAriaLabel": "Sélectionner le schéma {{schema}}",
        "tableCount_one": "{{count}} table",
        "tableCount_other": "{{count}} tables",
        "clickToLoadTables": "Cliquer pour charger les tables"
      },
      "tableSelection": {
        "loadingTables": "Chargement des tables…",
        "noTablesFoundTitle": "Aucune table trouvée",
        "noTablesInSchema": "Aucune table disponible dans ce schéma",
        "noTablesInDatabase": "Aucune table disponible dans cette base de données",
        "hint": "Les tables se chargent uniquement pour le schéma ouvert. Cliquez sur les lignes ou utilisez la case à cocher d'en-tête pour sélectionner.",
        "searchPlaceholder": "Rechercher des tables",
        "showingCount": "Affichage de {{shown}} sur {{count}}",
        "selectedAcrossSchemas": "{{count}} sélectionné(s) sur plusieurs schémas",
        "deselectAllAriaLabel": "Désélectionner toutes les tables",
        "selectAllAriaLabel": "Sélectionner toutes les tables",
        "columnTable": "Table",
        "columnDatabase": "Base de données",
        "columnRows": "Lignes",
        "columnCols": "Colonnes",
        "noMatchMessage": "Aucune table ne correspond à votre recherche.",
        "selectTableAriaLabel": "Sélectionner {{label}}",
        "updateAvailableTooltip": "Nouveaux nœuds/labels disponibles",
        "updateAvailableBadge": "Mise à jour disponible",
        "alreadyRegisteredTooltip": "Vous avez déjà enregistré cette table",
        "registeredBadge": "Enregistrée"
      },
      "registrationStep": {
        "loadingTables": "Chargement des tables…",
        "selectedSchemasAriaLabel": "Schémas sélectionnés",
        "multiGraphRegistrationLabel": "Enregistrement multi-graphes :",
        "multiGraphRegistrationTextPrefix": "Chaque ligne",
        "multiGraphRegistrationTextSuffix": "sélectionnée s'enregistre comme un actif de connaissances pour ce graphe.",
        "graphSchemaRegistrationLabel": "Enregistrement du schéma de graphe :",
        "graphSchemaRegistrationText": "Les tables de graphe sélectionnées seront enregistrées comme une seule entrée de schéma de graphe.",
        "relationshipTypesDetected_one": "{{count}} type de relation détecté.",
        "relationshipTypesDetected_other": "{{count}} types de relation détectés.",
        "finalizeAndRegisterTitle": "Finaliser et enregistrer",
        "subtitleRegisterPrefix": "Enregistrer",
        "subtitleChoosePrefix": "Choisissez comment ces connaissances seront utilisées, puis enregistrez",
        "subtitleGraphSchemaSuffix_one": "table de graphe comme une seule entrée de schéma de graphe.",
        "subtitleGraphSchemaSuffix_other": "tables de graphe comme une seule entrée de schéma de graphe.",
        "subtitleGraphsSuffix_one": "graphe en une étape.",
        "subtitleGraphsSuffix_other": "graphes en une étape.",
        "subtitleGraphTablesSuffix_one": "table de graphe en une étape.",
        "subtitleGraphTablesSuffix_other": "tables de graphe en une étape.",
        "subtitleTablesSuffix_one": "table en une étape.",
        "subtitleTablesSuffix_other": "tables en une étape.",
        "selectGraphTablesAbove": "Sélectionnez des tables de graphe ci-dessus",
        "selectGraphsAbove": "Sélectionnez des graphes ci-dessus",
        "selectTablesAbove": "Sélectionnez des tables ci-dessus",
        "registerGraphSchema_one": "Enregistrer le schéma de graphe ({{count}} table de graphe)",
        "registerGraphSchema_other": "Enregistrer le schéma de graphe ({{count}} tables de graphe)",
        "registerGraphs_one": "Enregistrer {{count}} graphe",
        "registerGraphs_other": "Enregistrer {{count}} graphes",
        "registerGraphTables_one": "Enregistrer {{count}} table de graphe",
        "registerGraphTables_other": "Enregistrer {{count}} tables de graphe",
        "registerTables_one": "Enregistrer {{count}} table",
        "registerTables_other": "Enregistrer {{count}} tables"
      },
      "introspectionError": {
        "thisConnection": "cette connexion",
        "timedOut": "{{name}} a pris trop de temps à répondre.",
        "forbidden": "Vous n'avez pas accès pour parcourir {{name}} — demandez à un administrateur du projet.",
        "credentialsRejected": "{{name}} a rejeté les identifiants enregistrés.",
        "missingSecret": "{{name}} n'a pas de mot de passe ou de secret configuré.",
        "databaseNotFound": "La base de données ou le catalogue enregistré sur {{name}} n'existe plus.",
        "hostUnreachable": "Impossible d'atteindre l'hôte configuré sur {{name}}.",
        "serviceBusy": "{{name}} est occupé actuellement.",
        "notConnecting": "{{name}} ne se connecte pas.",
        "genericFailure": "Impossible de charger le catalogue depuis {{name}}.",
        "validateInConnections": "Valider dans Connexions",
        "tryAgain": "Réessayer"
      }
    },
    "editModal": {
      "title": "Modifier la table de connaissances",
      "closeDialogAriaLabel": "Fermer la boîte de dialogue",
      "vectorDbBadge": "BD vectorielle",
      "displayNameLabel": "Nom d’affichage",
      "displayNamePlaceholder": "Saisir le nom d’affichage",
      "nameAlreadyExistsToast": "Une table de connaissances portant ce nom existe déjà",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Saisir une description (facultatif)",
      "knowledgeTypeLabel": "Type de connaissance",
      "knowledgeTypeData": "Données",
      "knowledgeTypeDataHint": "= connaissance générale.",
      "knowledgeTypeBenchmarks": "Benchmarks",
      "knowledgeTypeBenchmarksFull": "Benchmarks (Évaluations et simulations)",
      "knowledgeTypeBenchmarksHint": "= affiché dans Évaluations et simulations.",
      "knowledgeTypePlaceholder": "Sélectionner un type de connaissance...",
      "benchmarkTypeLabel": "Type de benchmark",
      "benchmarkTypeHint": "Catégorie de charge de travail affichée dans l’onglet Benchmarks (Text2SQL, RAG, utilisation d’outils, …).",
      "benchmarkTypePlaceholder": "Sélectionner un type de benchmark…",
      "benchmarkIconLabel": "Icône du benchmark",
      "benchmarkIconHint": "Affichée sur la carte du benchmark dans Évaluations et simulations. Revient à l’icône du connecteur si aucune image n’est définie.",
      "embeddingModelLabel": "Modèle d’embedding",
      "embeddingModelHint": "Sélectionnez le modèle d’embedding utilisé pour créer les vecteurs dans cette table.",
      "embeddingModelPlaceholder": "Sélectionner un modèle d’embedding...",
      "searchModelsPlaceholder": "Rechercher des modèles...",
      "loadingModelsMessage": "Chargement des modèles d’embedding...",
      "noModelsRegisteredMessage": "Aucun modèle d’embedding enregistré. Veuillez en enregistrer un d’abord.",
      "noModelSelectedWarning": "Aucun modèle d’embedding sélectionné. La recherche vectorielle peut échouer ou renvoyer des résultats incorrects.",
      "defaultBadge": "Par défaut",
      "loadModelsErrorToast": "Échec du chargement des modèles d’embedding",
      "updateErrorToast": "Échec de la mise à jour de la table de connaissances",
      "cancelButton": "Annuler",
      "savingButton": "Enregistrement...",
      "saveChangesButton": "Enregistrer les modifications"
    },
    "modal": {
      "title": "Enregistrer des tables pour la base de connaissances",
      "closeDialogAriaLabel": "Fermer la boîte de dialogue",
      "registeringTooltip_one": "Enregistrement de {{count}} table depuis {{name}}",
      "registeringTooltip_other": "Enregistrement de {{count}} tables depuis {{name}}",
      "registeringText_one": "Enregistrement de {{count}} table depuis {{name}}",
      "registeringText_other": "Enregistrement de {{count}} tables depuis {{name}}",
      "registerSubmitLabel_one": "Enregistrer {{count}} table",
      "registerSubmitLabel_other": "Enregistrer {{count}} tables",
      "tablesToRegisterLabel": "Tables à enregistrer",
      "columnsCount_one": "{{count}} colonne",
      "columnsCount_other": "{{count}} colonnes",
      "rowsCount_one": "{{formattedCount}} ligne",
      "rowsCount_other": "{{formattedCount}} lignes",
      "columnsHeader": "Colonnes",
      "notNullBadge": "NOT NULL",
      "cancelButton": "Annuler"
    },
    "viewModal": {
      "title": "Détails de la table de connaissances",
      "closeDialogAriaLabel": "Fermer la boîte de dialogue",
      "closeButton": "Fermer",
      "notAvailable": "N/D",
      "yesLabel": "Oui",
      "noLabel": "Non",
      "noneDetectedMessage": "Aucun détecté",
      "statusUnknown": "Inconnu",
      "statusActive": "Actif",
      "statusError": "Erreur",
      "statusSyncing": "Synchronisation",
      "noErrorsMessage": "Aucune erreur",
      "noColumnInfoMessage": "Aucune information de colonne disponible",
      "basicInformationHeader": "Informations de base",
      "tableInformationHeader": "Informations sur la table",
      "graphInformationHeader": "Informations sur le graphe",
      "embeddingModelHeader": "Modèle d’embedding",
      "columnsHeader": "Colonnes",
      "errorInformationHeader": "Informations sur l’erreur",
      "metadataHeader": "Métadonnées",
      "auditInformationHeader": "Informations d’audit",
      "fieldId": "ID",
      "fieldConnector": "Connecteur",
      "fieldStatus": "Statut",
      "fieldDatabase": "Base de données",
      "fieldSchema": "Schéma",
      "fieldTableName": "Nom de la table",
      "fieldRowCountNodes": "Nombre de lignes (nœuds)",
      "fieldTotalNodes": "Nœuds au total",
      "fieldTotalEdges": "Arêtes au total",
      "fieldRelationshipTypes": "Types de relations",
      "fieldNodeLabels": "Libellés des nœuds",
      "fieldModel": "Modèle",
      "fieldErrorMessage": "Message d’erreur",
      "fieldCreatedAt": "Créé le",
      "fieldUpdatedAt": "Mis à jour le",
      "fieldCreatedBy": "Créé par",
      "fieldUpdatedBy": "Mis à jour par",
      "noEmbeddingModelConfiguredTitle": "Aucun modèle d’embedding configuré",
      "noEmbeddingModelConfiguredHint": "La recherche vectorielle peut échouer ou renvoyer des résultats incorrects. Modifiez cette table pour assigner un modèle d’embedding correspondant à celui utilisé pour créer les vecteurs stockés.",
      "columnName": "Nom",
      "columnType": "Type",
      "columnNullable": "Nullable"
    },
    "registerFields": {
      "embeddingModelLabel": "Modèle d’embedding",
      "embeddingModelHint": "Modèle utilisé pour la recherche sémantique sur ces tables vectorielles.",
      "loadingModelsMessage": "Chargement des modèles d’embedding…",
      "noModelsRegisteredMessage": "Aucun modèle d’embedding enregistré. Enregistrez-en un d’abord.",
      "selectEmbeddingModelOption": "— Sélectionner un modèle d’embedding —",
      "defaultBadge": "Par défaut",
      "managedVectorDbHint": "Ce connecteur gère les index et les embeddings de manière interne — aucun mappage de colonnes requis. Le modèle d’embedding sélectionné sera utilisé au moment de la requête pour encoder votre recherche.",
      "columnMappingLabel": "Mappage des colonnes",
      "columnMappingHint": "Mappez les colonnes ID, contenu et embedding pour la recherche vectorielle.",
      "columnLabelId": "ID",
      "columnLabelContent": "Contenu",
      "columnLabelEmbedding": "Embedding",
      "columnFieldLabel": "Colonne {{column}}",
      "selectOption": "— Sélectionner —",
      "vectorSuffix": "vecteur",
      "knowledgePurposeLabel": "Objectif de la connaissance",
      "knowledgeTypeData": "Données",
      "knowledgeTypeDataHint": "pour du RAG général.",
      "knowledgeTypeBenchmarks": "Benchmarks",
      "knowledgeTypeBenchmarksHint": "affiche ces données dans Évaluations et simulations.",
      "knowledgeTypeGroupAriaLabel": "Type de connaissance",
      "encryptDataLabel": "Chiffrer les données de la table au repos pour les lecteurs",
      "encryptDataHint": "Seul vous (le créateur) voyez les valeurs en clair ; les autres voient le texte chiffré. Utilise la même clé que les secrets d’outils.",
      "selectEmbeddingModelTooltip": "Sélectionner un modèle d’embedding",
      "mapColumnsTooltip": "Mapper les colonnes ID, contenu et embedding",
      "registeringButton": "Enregistrement…"
    },
    "groupedView": {
      "loadingMessage": "Chargement des tables...",
      "emptyMessage": "Aucune table de connaissances trouvée",
      "emptySearchHint": "Essayez d’ajuster votre recherche",
      "tableCount_one": "{{count}} table",
      "tableCount_other": "{{count}} tables",
      "rowsCount_one": "{{formattedCount}} ligne",
      "rowsCount_other": "{{formattedCount}} lignes",
      "vectorDbTooltip": "Base de données vectorielle",
      "vectorDbBadge": "BD vectorielle",
      "createdTooltip": "Créé",
      "updatedTooltip": "Mis à jour",
      "statusUnknown": "Inconnu",
      "statusError": "Erreur",
      "statusActive": "Actif",
      "statusSyncing": "Synchronisation",
      "actionViewDetails": "Voir les détails",
      "actionPreviewData": "Aperçu des données",
      "actionEdit": "Modifier",
      "actionVectorSearch": "Recherche vectorielle",
      "actionSync": "Synchroniser",
      "actionManageAccess": "Gérer l’accès",
      "actionDelete": "Supprimer"
    },
    "addStorageFolderModal": {
      "title": "Ajouter un dossier de stockage",
      "closeDialogAriaLabel": "Fermer la boîte de dialogue",
      "selectConnectorTitle": "Sélectionner un connecteur de stockage",
      "noConnectorsFoundMessage": "Aucun connecteur de stockage trouvé. Veuillez d'abord créer un connecteur de stockage.",
      "searchConnectorsPlaceholder": "Rechercher des connecteurs",
      "countOf": "{{shown}} sur {{count}}",
      "noConnectorsMatchFilters": "Aucun connecteur ne correspond à vos filtres.",
      "connectorTypeLabel": "Type de connecteur",
      "allConnectorTypesPlaceholder": "Tous les types de connecteurs ({{count}})",
      "selectBucketTitle": "Sélectionner un bucket",
      "noBucketsFoundMessage": "Aucun bucket trouvé.",
      "searchBucketsPlaceholder": "Rechercher des buckets",
      "noBucketsMatchSearch": "Aucun bucket ne correspond à votre recherche.",
      "selectFoldersTitle": "Sélectionner des dossiers",
      "selectAllButton": "Tout sélectionner",
      "deselectAllButton": "Tout désélectionner",
      "searchFoldersPlaceholder": "Rechercher des dossiers",
      "fileCount_one": "{{count}} fichier",
      "fileCount_other": "{{count}} fichiers",
      "openSubfolderTooltip": "Ouvrir le sous-dossier",
      "noFoldersMatchSearch": "Aucun dossier ne correspond à votre recherche.",
      "noSubfoldersMessage": "Aucun sous-dossier ici. Vous pouvez enregistrer ce chemin de dossier s'il contient des fichiers.",
      "noFoldersInBucketMessage": "Aucun dossier trouvé dans ce bucket.",
      "selectFolderButton": "Sélectionner le dossier « {{name}} »",
      "selectedFoldersCount_one": "{{count}} dossier sélectionné",
      "selectedFoldersCount_other": "{{count}} dossiers sélectionnés",
      "cancelButton": "Annuler",
      "registeringButton": "Enregistrement...",
      "registerFoldersButton_one": "Enregistrer {{count}} dossier",
      "registerFoldersButton_other": "Enregistrer {{count}} dossiers",
      "registerSuccessToast_one": "{{count}} dossier de stockage enregistré avec succès",
      "registerSuccessToast_other": "{{count}} dossiers de stockage enregistrés avec succès"
    },
    "splitView": {
      "storageBucketPane": {
        "title": "Buckets",
        "columnBucket": "Bucket",
        "columnFolders": "Dossiers",
        "defaultBucketLabel": "(par défaut)",
        "searchPlaceholder": "Rechercher des buckets…",
        "emptyMessage": "Aucun bucket enregistré.",
        "emptySearchMessage": "Aucun bucket ne correspond à cette recherche.",
        "loadErrorMessage": "Échec du chargement des buckets"
      },
      "connectorPane": {
        "columnCreatedAt": "Créé",
        "columnDatabase": "Type",
        "columnName": "Nom",
        "columnStatus": "Statut",
        "columnUpdatedAt": "Mis à jour",
        "emptyMessage": "Aucun connecteur trouvé.",
        "emptySearchMessage": "Aucun connecteur ne correspond à votre recherche.",
        "loadErrorMessage": "Échec du chargement des connecteurs.",
        "searchPlaceholder": "Rechercher des connecteurs…",
        "title": "Connecteurs"
      },
      "schemaPane": {
        "ariaDeleteMany_one": "Supprimer {{count}} schéma sélectionné",
        "ariaDeleteMany_other": "Supprimer {{count}} schémas sélectionnés",
        "ariaDeleteOne": "Supprimer le schéma sélectionné",
        "columnName": "Nom",
        "columnObjects": "Objets",
        "defaultLabel": "par défaut",
        "deleteTitleEmpty": "Supprimer le schéma",
        "deleteTitleMany_one": "Supprimer {{count}} schéma",
        "deleteTitleMany_other": "Supprimer {{count}} schémas",
        "deleteTitleOne": "Supprimer le schéma",
        "deleteTitleOneNamed": "Supprimer {{schema}}",
        "emptyMessage": "Aucun schéma trouvé",
        "emptySearchMessage": "Aucun schéma ne correspond à votre recherche",
        "loadErrorMessage": "Échec du chargement des schémas",
        "searchPlaceholder": "Rechercher {{title}}…",
        "title": "Schémas"
      }
    },
    "connectorFields": {
      "extraParamField": {
        "authApiKey": "Clé API",
        "authBasic": "Authentification de base",
        "configured": "configuré",
        "engineMssql": "SQL Server",
        "engineMysql": "MySQL",
        "enginePostgres": "PostgreSQL",
        "payloadBase64Json": "Base64 JSON",
        "payloadBinary": "Binaire",
        "provisioned": "Provisionné",
        "schemeBolt": "bolt",
        "schemeBoltS": "bolt+s",
        "schemeNeo4j": "neo4j",
        "schemeNeo4jS": "neo4j+s",
        "serverless": "Sans serveur"
      },
      "extraParams": {
        "advancedLabel": "Options avancées"
      },
      "scopeSelector": {
        "currentScope": "Portée actuelle : {{scope}}",
        "enableTenantNote": "Activez cette option pour passer la portée en mode Locataire.",
        "projectDescription": "Disponible uniquement dans un projet spécifique",
        "projectFieldLabel": "Projet",
        "projectHint": "Ce connecteur ne sera disponible que dans le projet sélectionné.",
        "projectLabel": "Projet",
        "projectPlaceholder": "Sélectionner un projet",
        "projectSearchPlaceholder": "Rechercher des projets…",
        "tenantDescription": "Disponible pour tous les projets de ce locataire",
        "tenantHint": "Ce connecteur sera disponible pour tous les projets de ce locataire.",
        "tenantLabel": "Locataire",
        "tenantToggleLabel": "Portée locataire"
      },
      "shared": {
        "aihubSubscriptionKeySecretNameLabel": "Nom du secret de la clé d'abonnement AI Hub",
        "authHelp": {
          "awsDefault": "Fournissez les identifiants AWS pour ce connecteur.",
          "awsKeyBoto": "Clé d'accès et clé secrète AWS utilisées via boto3.",
          "awsKeySql": "Clé d'accès et clé secrète AWS utilisées pour se connecter à la base de données.",
          "awsWif": "Utilisez la fédération d'identité de charge de travail AWS au lieu de clés d'accès à longue durée de vie.",
          "azureAiSearchKey": "Connectez-vous à Azure AI Search à l'aide d'une clé API administrateur.",
          "azureAihub": "Connectez-vous à l'aide d'une clé d'abonnement AI Hub au lieu des identifiants Azure AD.",
          "azureBlobKey": "Connectez-vous à Azure Blob Storage à l'aide d'une clé de compte.",
          "azureDocIntelligenceKey": "Connectez-vous à Azure Document Intelligence à l'aide d'une clé API.",
          "azureKeyDefault": "Connectez-vous à l'aide d'une clé ou d'une chaîne de connexion.",
          "azureOboAiSearch": "Accédez à Azure AI Search pour le compte de l'utilisateur connecté (authentification déléguée).",
          "azureOboBlob": "Accédez à Azure Blob Storage pour le compte de l'utilisateur connecté (authentification déléguée).",
          "azureOboDefault": "Accédez à cette ressource pour le compte de l'utilisateur connecté (authentification déléguée).",
          "azureOboDocIntelligence": "Accédez à Azure Document Intelligence pour le compte de l'utilisateur connecté (authentification déléguée).",
          "azureOboSharePoint": "Accédez à SharePoint pour le compte de l'utilisateur connecté (authentification déléguée).",
          "azureSharePointKey": "Connectez-vous à SharePoint à l'aide d'un secret client.",
          "azureSpAiSearch": "Accédez à Azure AI Search dans {brand} à l'aide d'un principal de service enregistré.",
          "azureSpBlob": "Accédez à Azure Blob Storage à l'aide d'un principal de service enregistré.",
          "azureSpDefault": "Accédez à cette ressource dans {brand} à l'aide d'un principal de service enregistré.",
          "azureSpDocIntelligence": "Accédez à Azure Document Intelligence dans {brand} à l'aide d'un principal de service enregistré.",
          "azureSpRlsDeprecated": "Ce mode de principal de service est obsolète. Passez à un mode d'authentification pris en charge.",
          "azureSpSharePoint": "Accédez à SharePoint à l'aide d'un principal de service enregistré.",
          "gcpDefault": "Fournissez les identifiants GCP pour ce connecteur.",
          "gcpKey": "Connectez-vous à l'aide d'une clé de compte de service GCP.",
          "gcpSaDefault": "Connectez-vous à l'aide d'un compte de service GCP.",
          "gcpSaGcs": "Accédez à Google Cloud Storage à l'aide d'un compte de service GCP.",
          "gcpSaRlsDeprecated": "Ce mode de compte de service est obsolète. Passez à un mode d'authentification pris en charge.",
          "gcpWifDefault": "Connectez-vous à l'aide de la fédération d'identité de charge de travail GCP.",
          "gcpWifGcs": "Accédez à Google Cloud Storage à l'aide de la fédération d'identité de charge de travail GCP.",
          "oracleIamRequired": "Une entrée Cloud IAM est requise pour ce mode d'authentification Oracle.",
          "oracleUsernamePassword": "Connectez-vous à l'aide d'un nom d'utilisateur et d'un mot de passe de base de données Oracle.",
          "oracleWallet": "Connectez-vous à l'aide d'un portefeuille Oracle."
        },
        "authModeLabel": "Mode d'authentification",
        "authModePlaceholder": "Sélectionner le mode d'authentification",
        "databaseEngineHelpText": "Sélectionnez le moteur de base de données sous-jacent pour cette connexion Azure Managed SQL.",
        "databaseEngineLabel": "Moteur de base de données",
        "databaseLabel": "Base de données",
        "databaseUsernameEntraLabel": "Nom d'affichage Entra",
        "descriptionLabel": "Description",
        "descriptionPlaceholder": "Description facultative pour ce connecteur",
        "displayNameLabel": "Nom d'affichage",
        "displayNamePlaceholder": "ex. Base de données de production",
        "docIntelVerifySslHelpText": "Désactivez uniquement lors de la connexion à un point de terminaison Document Intelligence avec un certificat auto-signé.",
        "engineMysql": "MySQL",
        "enginePostgresql": "PostgreSQL",
        "engineSqlServer": "SQL Server",
        "entraDisplayNamePlaceholder": "ex. john.doe@company.com",
        "entraUsernameHelpText": "Saisissez le nom d'affichage Entra ID ou l'UPN du principal de la base de données.",
        "fromIamSuffix": "(depuis Cloud IAM)",
        "iamEmptyWarning": {
          "awsBasicAuth": "Aucune entrée Cloud IAM d'authentification de base AWS trouvée. Ajoutez-en une avant de continuer.",
          "awsIamUser": "Aucune entrée Cloud IAM utilisateur AWS IAM trouvée. Ajoutez-en une avant de continuer.",
          "awsWif": "Aucune entrée Cloud IAM de fédération d'identité de charge de travail AWS trouvée. Ajoutez-en une avant de continuer.",
          "azureBasicAuth": "Aucune entrée Cloud IAM d'authentification de base Azure trouvée. Ajoutez-en une avant de continuer.",
          "azureBlobIamOnly": "Aucune entrée Cloud IAM Azure Blob Storage trouvée. Ajoutez-en une avant de continuer.",
          "azureBlobKey": "Aucune entrée Cloud IAM de clé Azure Blob Storage trouvée. Ajoutez-en une avant de continuer.",
          "azureServicePrincipal": "Aucune entrée Cloud IAM de principal de service Azure trouvée. Ajoutez-en une avant de continuer.",
          "databricks": "Aucune entrée Cloud IAM Databricks trouvée. Ajoutez un jeton d'accès personnel avant de continuer.",
          "default": "Aucune entrée Cloud IAM trouvée. Ajoutez-en une avant de continuer.",
          "gcp": "Aucune entrée Cloud IAM GCP trouvée. Ajoutez-en une avant de continuer.",
          "gcpBasicAuth": "Aucune entrée Cloud IAM d'authentification de base GCP trouvée. Ajoutez-en une avant de continuer.",
          "gcpServiceAccount": "Aucune entrée Cloud IAM de compte de service GCP trouvée. Ajoutez-en une avant de continuer.",
          "tokenBasedOnprem": "Aucune entrée Cloud IAM de jeton d'accès trouvée. Ajoutez-en une avant de continuer."
        },
        "iamHelp": {
          "awsAccessKeys": "Sélectionnez l'entrée Cloud IAM contenant votre clé d'accès et votre clé secrète AWS.",
          "awsBasicAuth": "Sélectionnez l'entrée Cloud IAM contenant vos identifiants de base de données AWS.",
          "awsWif": "Sélectionnez l'entrée Cloud IAM configurée pour la fédération d'identité de charge de travail AWS.",
          "azureBasicAuth": "Sélectionnez l'entrée Cloud IAM contenant vos identifiants d'authentification de base Azure.",
          "azureBlobIamOnly": "Sélectionnez l'entrée Cloud IAM pour l'accès à Azure Blob Storage.",
          "azureBlobKey": "Sélectionnez l'entrée Cloud IAM contenant votre clé de compte Azure Blob Storage.",
          "azureServicePrincipal": "Sélectionnez l'entrée Cloud IAM pour le principal de service Azure.",
          "databricks": "Sélectionnez l'entrée Cloud IAM contenant votre jeton d'accès personnel Databricks.",
          "default": "Sélectionnez une entrée Cloud IAM pour ce connecteur.",
          "gcp": "Sélectionnez l'entrée Cloud IAM pour ce connecteur GCP.",
          "gcpBasicAuth": "Sélectionnez l'entrée Cloud IAM contenant vos identifiants d'authentification de base GCP.",
          "gcpServiceAccount": "Sélectionnez l'entrée Cloud IAM contenant votre clé de compte de service GCP.",
          "gcpTokenMode": "Sélectionnez l'entrée Cloud IAM utilisée pour générer les jetons d'accès.",
          "gcpWif": "Sélectionnez l'entrée Cloud IAM configurée pour la fédération d'identité de charge de travail GCP.",
          "oracleOptional": "Vous pouvez éventuellement sélectionner une entrée Cloud IAM au lieu de saisir directement les identifiants.",
          "oracleRequired": "Sélectionnez l'entrée Cloud IAM requise pour ce mode d'authentification Oracle.",
          "tokenBasedOnprem": "Sélectionnez l'entrée Cloud IAM contenant votre jeton d'accès."
        },
        "iamLabel": {
          "accessToken": "Jeton d'accès",
          "awsAccessKeys": "Clés d'accès AWS",
          "awsBasicAuth": "Authentification de base AWS",
          "awsWif": "Fédération d'identité de charge de travail AWS",
          "azureBasicAuth": "Authentification de base Azure",
          "azureBlobStorage": "Azure Blob Storage",
          "azureOrGraph": "Azure AD / Microsoft Graph",
          "azureServicePrincipal": "Principal de service Azure",
          "azureStorage": "Azure Storage",
          "cloudIam": "Cloud IAM",
          "cloudIamOptional": "Cloud IAM (facultatif)",
          "databricksIam": "IAM Databricks (PAT ou principal de service)",
          "databricksPat": "Jeton d'accès personnel Databricks",
          "gcp": "Cloud IAM GCP",
          "gcpBasicAuth": "Authentification de base GCP",
          "gcpServiceAccount": "Compte de service GCP",
          "gcpWif": "Fédération d'identité de charge de travail GCP"
        },
        "iamPlaceholder": {
          "accessToken": "Sélectionner un jeton d'accès",
          "awsAccessKeys": "Sélectionner les clés d'accès AWS",
          "awsBasicAuth": "Sélectionner les identifiants d'authentification de base AWS",
          "awsWif": "Sélectionner l'entrée de fédération d'identité de charge de travail AWS",
          "azureBasicAuth": "Sélectionner les identifiants d'authentification de base Azure",
          "azureBlobIamOnly": "Sélectionner une entrée Cloud IAM Azure Blob Storage",
          "azureBlobKey": "Sélectionner une clé Azure Blob Storage",
          "azureServicePrincipal": "Sélectionner un principal de service Azure",
          "databricksIam": "Sélectionner une entrée IAM Databricks (PAT ou principal de service)",
          "databricksPat": "Sélectionner un jeton d'accès personnel Databricks",
          "default": "Sélectionner une entrée Cloud IAM",
          "gcp": "Sélectionner une entrée Cloud IAM GCP",
          "gcpBasicAuth": "Sélectionner les identifiants d'authentification de base GCP",
          "gcpServiceAccount": "Sélectionner un compte de service GCP",
          "gcpWif": "Sélectionner une entrée de fédération d'identité de charge de travail GCP"
        },
        "loadingIamEntries": "Chargement des entrées Cloud IAM…",
        "passwordSecretKeyNameOptionalLabel": "Nom de la clé secrète du mot de passe (facultatif)",
        "portLabel": "Port",
        "schemaLabel": "Schéma",
        "secretKeyNameLabel": "Nom de la clé secrète",
        "secretKeyNamePlaceholder": "ex. my-connector-password",
        "serverHostHelpMssql": "Saisissez le nom d'hôte SQL Server, par ex. myserver.database.windows.net",
        "serverHostHelpMysql": "Saisissez le nom d'hôte MySQL, par ex. myserver.mysql.database.azure.com",
        "serverHostHelpPostgres": "Saisissez le nom d'hôte PostgreSQL, par ex. myserver.postgres.database.azure.com",
        "serverHostLabel": "Hôte du serveur",
        "usernameLabel": "Nom d'utilisateur"
      },
      "testSection": {
        "cancel": "Annuler",
        "connectionFailed": "Échec de la connexion",
        "connectionSuccessful": "Connexion réussie",
        "latency": "Latence : {{ms}} ms",
        "subtitle": "Vérifiez vos paramètres de connexion avant d'enregistrer",
        "testConnection": "Tester la connexion",
        "title": "Tester la connexion",
        "version": "Version : {{version}}"
      }
    },
    "connectorModal": {
      "aria": {
        "backToSelection": "Retour à la sélection du connecteur",
        "closeDialog": "Fermer la boîte de dialogue"
      },
      "buttons": {
        "addConnector": "Ajouter un connecteur",
        "back": "Retour",
        "cancel": "Annuler",
        "creating": "Création en cours…",
        "updateConnector": "Mettre à jour le connecteur",
        "updating": "Mise à jour en cours…"
      },
      "connectorsLabel": "Connecteurs",
      "errors": {
        "aiHubSecretRequired": "Le nom du secret de la clé d'abonnement AI Hub est requis",
        "awsIamUserRequired": "Sélectionnez une entrée Cloud IAM pour un utilisateur AWS IAM",
        "awsWifIamRequired": "Sélectionnez une entrée Cloud IAM pour la fédération d'identité de charge de travail AWS",
        "azureBasicAuthIamRequired": "Sélectionnez une entrée Cloud IAM pour l'authentification de base Azure",
        "azureBlobIamRequired": "Sélectionnez une entrée Cloud IAM pour Azure Blob Storage",
        "azureBlobIamRequiredFull": "Une entrée Cloud IAM est requise pour accéder à Azure Blob Storage",
        "azureSpIamRequiredObo": "Sélectionnez une entrée Cloud IAM pour l'accès délégué On-Behalf-Of",
        "azureSpIamRequiredSp": "Sélectionnez une entrée Cloud IAM pour le principal de service Azure",
        "cloudIamOrSecretRequired": "Fournissez une entrée Cloud IAM ou un nom de clé secrète",
        "cloudIamRequired": "Une entrée Cloud IAM est requise",
        "cloudIamRequiredForMode": "Une entrée Cloud IAM est requise pour ce mode d'authentification",
        "displayNameRequired": "Le nom d'affichage est requis",
        "fieldRequired": "{{field}} est requis",
        "gcpBasicAuthIamRequired": "Sélectionnez une entrée Cloud IAM pour l'authentification de base GCP",
        "gcpServiceAccountIamRequired": "Sélectionnez une entrée Cloud IAM pour le compte de service GCP",
        "hostNoUnderscores": "L'hôte ne peut pas contenir de traits de soulignement",
        "nameAlreadyExists": "Un connecteur portant ce nom existe déjà",
        "oracleCloudIamRequired": "Une entrée Cloud IAM est requise pour ce mode d'authentification Oracle",
        "oracleSecretOrIamRequired": "{{field}} est requis, ou sélectionnez une entrée Cloud IAM",
        "portRange": "Le port doit être compris entre 1 et 65535",
        "projectRequired": "Sélectionnez un projet",
        "provideCloudIamOrSecret": "Fournissez une entrée Cloud IAM ou un secret avant de tester",
        "schemaRequired": "Le schéma est requis",
        "sharepointCredentialsRequired": "Les identifiants SharePoint sont requis",
        "testFailedCheckConfig": "Le test de connexion a échoué. Vérifiez votre configuration et réessayez.",
        "usernameRequired": "Le nom d'utilisateur est requis",
        "walletLocationRequired": "L'emplacement du portefeuille est requis"
      },
      "fields": {
        "aiHubSubscriptionKeySecretName": "Nom du secret de la clé d'abonnement AI Hub",
        "awsIamUserCloudIamEntry": "Entrée Cloud IAM utilisateur AWS IAM",
        "awsWifCloudIamEntry": "Entrée Cloud IAM de fédération d'identité de charge de travail AWS",
        "azureBasicAuthIamRequired": "Entrée Cloud IAM d'authentification de base Azure",
        "azureBlobIamEntry": "Entrée Cloud IAM Azure Blob Storage",
        "azureBlobIamRequiredForMode": "Entrée Cloud IAM Azure Blob Storage",
        "azureSpIamObo": "Entrée Cloud IAM du principal de service Azure (On-Behalf-Of)",
        "azureSpIamSp": "Entrée Cloud IAM du principal de service Azure",
        "cloudIamEntry": "Entrée Cloud IAM",
        "cloudIamOrPasswordSecretKeyName": "Entrée Cloud IAM ou nom de clé secrète du mot de passe",
        "connectorFallback": "connecteur",
        "database": "Base de données",
        "displayName": "Nom d'affichage",
        "gcpIamEntryBasicAuth": "Entrée Cloud IAM d'authentification de base GCP",
        "gcpIamEntryServiceAccount": "Entrée Cloud IAM du compte de service GCP",
        "host": "Hôte",
        "passwordSecretKeyName": "Nom de la clé secrète du mot de passe",
        "project": "Projet",
        "secretKeyName": "Nom de la clé secrète",
        "sharepointCredentialsRequired": "Identifiants SharePoint",
        "walletLocation": "Emplacement du portefeuille"
      },
      "loadingQuota": "Chargement du quota…",
      "missingFieldsTitle": "Champs obligatoires manquants : {{fields}}",
      "requiredFieldsHint": "Manquant : {{fields}}",
      "titles": {
        "configureConnector": "Configurer {{name}}",
        "editConnector": "Modifier le connecteur",
        "selectConnectorType": "Sélectionner le type de connecteur"
      },
      "toasts": {
        "createFailed": "Échec de la création du connecteur",
        "updateFailed": "Échec de la mise à jour du connecteur"
      }
    },
    "connectorSelectionGrid": {
      "categories": {
        "aws": "AWS",
        "azure": "Azure",
        "databricks": "Databricks",
        "gcp": "GCP",
        "onprem": "Sur site",
        "orchestrators": "Orchestrateurs",
        "snowflake": "Snowflake",
        "storage": "Stockage",
        "telephony": "Téléphonie",
        "vectorDb": "Base de données vectorielle"
      },
      "loading": "Chargement des types de connecteurs…"
    },
    "connectorViewModal": {
      "aria": {
        "backToSelection": "Retour à la sélection du connecteur",
        "closeDialog": "Fermer la boîte de dialogue"
      },
      "buttons": {
        "addConnector": "Ajouter un connecteur",
        "back": "Retour",
        "cancel": "Annuler",
        "close": "Fermer",
        "creating": "Création en cours…",
        "updateConnector": "Mettre à jour le connecteur",
        "updating": "Mise à jour en cours…"
      },
      "connectorsLabel": "Connecteurs",
      "errors": {
        "aiHubSecretRequired": "Le nom du secret de la clé d'abonnement AI Hub est requis",
        "awsIamUserRequired": "Sélectionnez une entrée Cloud IAM pour un utilisateur AWS IAM",
        "awsWifIamRequired": "Sélectionnez une entrée Cloud IAM pour la fédération d'identité de charge de travail AWS",
        "azureBasicAuthIamRequired": "Sélectionnez une entrée Cloud IAM pour l'authentification de base Azure",
        "azureBlobIamRequired": "Sélectionnez une entrée Cloud IAM pour Azure Blob Storage",
        "azureBlobIamRequiredFull": "Une entrée Cloud IAM est requise pour accéder à Azure Blob Storage",
        "azureSpIamRequiredObo": "Sélectionnez une entrée Cloud IAM pour l'accès délégué On-Behalf-Of",
        "azureSpIamRequiredSp": "Sélectionnez une entrée Cloud IAM pour le principal de service Azure",
        "cloudIamOrSecretRequired": "Fournissez une entrée Cloud IAM ou un nom de clé secrète",
        "cloudIamRequired": "Une entrée Cloud IAM est requise",
        "cloudIamRequiredForMode": "Une entrée Cloud IAM est requise pour ce mode d'authentification",
        "displayNameRequired": "Le nom d'affichage est requis",
        "fieldRequired": "{{field}} est requis",
        "gcpBasicAuthIamRequired": "Sélectionnez une entrée Cloud IAM pour l'authentification de base GCP",
        "gcpServiceAccountIamRequired": "Sélectionnez une entrée Cloud IAM pour le compte de service GCP",
        "oracleCloudIamRequired": "Une entrée Cloud IAM est requise pour ce mode d'authentification Oracle",
        "oracleSecretOrIamRequired": "{{field}} est requis, ou sélectionnez une entrée Cloud IAM",
        "portRange": "Le port doit être compris entre 1 et 65535",
        "provideCloudIamOrSecret": "Fournissez une entrée Cloud IAM ou un secret avant de tester",
        "schemaRequired": "Le schéma est requis",
        "sharepointCredentialsRequired": "Les identifiants SharePoint sont requis",
        "testFailedCheckConfig": "Le test de connexion a échoué. Vérifiez votre configuration et réessayez.",
        "usernameRequired": "Le nom d'utilisateur est requis",
        "walletLocationRequired": "L'emplacement du portefeuille est requis"
      },
      "fields": {
        "aiHubSubscriptionKeySecretName": "Nom du secret de la clé d'abonnement AI Hub",
        "awsIamUserCloudIamEntry": "Entrée Cloud IAM utilisateur AWS IAM",
        "awsWifCloudIamEntry": "Entrée Cloud IAM de fédération d'identité de charge de travail AWS",
        "azureBasicAuthIamRequired": "Entrée Cloud IAM d'authentification de base Azure",
        "azureBlobIamEntry": "Entrée Cloud IAM Azure Blob Storage",
        "azureBlobIamRequiredForMode": "Entrée Cloud IAM Azure Blob Storage",
        "azureSpIamObo": "Entrée Cloud IAM du principal de service Azure (On-Behalf-Of)",
        "azureSpIamSp": "Entrée Cloud IAM du principal de service Azure",
        "cloudIamEntry": "Entrée Cloud IAM",
        "cloudIamOrPasswordSecretKeyName": "Entrée Cloud IAM ou nom de clé secrète du mot de passe",
        "connectorFallback": "connecteur",
        "database": "Base de données",
        "displayName": "Nom d'affichage",
        "gcpIamEntryBasicAuth": "Entrée Cloud IAM d'authentification de base GCP",
        "gcpIamEntryServiceAccount": "Entrée Cloud IAM du compte de service GCP",
        "host": "Hôte",
        "passwordSecretKeyName": "Nom de la clé secrète du mot de passe",
        "secretKeyName": "Nom de la clé secrète",
        "sharepointCredentialsRequired": "Identifiants SharePoint",
        "walletLocation": "Emplacement du portefeuille"
      },
      "loadingQuota": "Chargement du quota…",
      "missingFieldsTitle": "Champs obligatoires manquants : {{fields}}",
      "requiredFieldsHint": "Manquant : {{fields}}",
      "titles": {
        "configureConnector": "Configurer {{name}}",
        "editConnector": "Modifier le connecteur",
        "selectConnectorType": "Sélectionner le type de connecteur",
        "viewConnection": "Voir la connexion"
      },
      "toasts": {
        "createFailed": "Échec de la création du connecteur",
        "updateFailed": "Échec de la mise à jour du connecteur"
      }
    },
    "graphEvals": {
      "backToGraphAriaLabel": "Retour au graphe",
      "cancel": "Annuler",
      "close": "Fermer",
      "columnConfidence": "Confiance",
      "columnDateTime": "Date / Heure",
      "columnGrade": "Note",
      "columnReport": "Rapport",
      "columnSchema": "Schéma",
      "columnSemantic": "Sémantique",
      "columnStatus": "Statut",
      "columnStructural": "Structure",
      "confidenceMeta": "Confiance : {{value}}",
      "configModalAriaLabel": "Configuration de l'évaluation",
      "derivationsDescFallback": "Lancez une évaluation pour voir comment la note de qualité est calculée.",
      "download": "Télécharger",
      "downloadReportTooltip": "Télécharger le rapport PDF",
      "emptyRunsMessage": "Aucune évaluation n'a encore été exécutée.",
      "entityCompletenessLabel": "Exhaustivité des entités",
      "gradeConfidenceSummary": "Note {{grade}} · confiance {{confidence}}",
      "gradeErrorAbbreviation": "ERR",
      "hideFormulas": "Masquer les formules",
      "howScoresCalculatedTitle": "Comment les scores sont calculés",
      "latestScoresAriaLabel": "Derniers scores de qualité",
      "llmModelLabel": "Modèle LLM",
      "llmModelTooltip": "Modèle utilisé pour juger la cohérence sémantique",
      "loadingEvaluations": "Chargement des évaluations…",
      "loadingModelsPlaceholder": "Chargement des modèles…",
      "loadingReport": "Chargement du rapport…",
      "missingGraphIdMessage": "Aucune table de graphe n'a été spécifiée.",
      "modelDefaultLabel": "{{name}} (par défaut)",
      "noMatchingEvaluations": "Aucune évaluation ne correspond à votre recherche.",
      "noReportAttachedMessage": "Aucun rapport n'est joint à cette exécution.",
      "noStructuralBreakdown": "Aucune décomposition structurelle disponible.",
      "pageSubtitle": "Historique des évaluations de qualité pour {{name}}",
      "pageTitle": "Évaluations du graphe",
      "pdfFrameTitle": "Rapport de validation",
      "qualityGradeHelp": "Note de qualité globale, dérivée du mélange pondéré de la santé structurelle, de la conformité au schéma et de la cohérence sémantique.",
      "qualityGradeLabel": "Note de qualité",
      "refresh": "Actualiser",
      "relationshipRichnessLabel": "Richesse des relations",
      "reportDownloadFailedMessage": "Échec du téléchargement du rapport.",
      "reportLoadFailedGeneric": "Échec du chargement du rapport",
      "reportLoadFailedMessage": "Échec du chargement du fichier de rapport.",
      "reportModalAriaLabel": "Rapport de validation",
      "runEvaluationButton": "Lancer l'évaluation",
      "runEvaluationDescription": "Choisissez ce qu'il faut valider et la part du graphe à échantillonner.",
      "runEvaluationTitle": "Lancer l'évaluation",
      "running": "En cours…",
      "runningEvaluation": "Évaluation en cours…",
      "sampleSizeLabel": "Taille de l'échantillon",
      "schemaConformanceDerivationHelp": "Comment le score de conformité au schéma est dérivé de l'exhaustivité des entités et des relations.",
      "schemaConformanceHelp": "Dans quelle mesure les entités et relations du graphe respectent le schéma enregistré.",
      "schemaConformanceLabel": "Conformité au schéma",
      "schemaFormulaFallback": "Lancez une évaluation pour voir la formule de conformité au schéma.",
      "schemaMetaFallback": "Aucune donnée de schéma pour le moment",
      "schemaPartsFormula": "Entité {{entity}} × Relation {{relationship}} = {{result}}",
      "scopeAll": "Graphe entier",
      "scopeSample": "Échantillon",
      "scoreDerivationsAriaLabel": "Dérivations des scores",
      "searchEvaluationsPlaceholder": "Rechercher des évaluations…",
      "searchModelsPlaceholder": "Rechercher des modèles…",
      "selectAtLeastOneTargetError": "Sélectionnez au moins une cible de validation.",
      "selectModelPlaceholder": "Sélectionner un modèle",
      "semanticCoherenceCaveat": "La cohérence sémantique est jugée sur un échantillon et peut ne pas refléter tout le graphe.",
      "semanticCoherenceDerivationHelp": "Comment le score de cohérence sémantique est dérivé des triplets échantillonnés.",
      "semanticCoherenceHelp": "Si les relations du graphe ont un sens logique et factuel.",
      "semanticCoherenceLabel": "Cohérence sémantique",
      "semanticFactScopeLegend": "Faits à valider",
      "semanticFormula": "{{coherent}} cohérents / {{sampled}} échantillonnés = {{result}}",
      "semanticMetaCoherent": "{{coherent}} / {{sampled}} cohérents",
      "semanticMetaFallback": "Aucune donnée sémantique pour le moment",
      "semanticMetaSampled": "{{sampled}} échantillonnés sur {{total}}",
      "semanticMetaTotal": "{{total}} triplets",
      "showFormulas": "Afficher les formules",
      "startEvaluation": "Démarrer l'évaluation",
      "structuralFormula": "Moyenne pondérée des contrôles d'intégrité des nœuds/arêtes",
      "structuralHealthDerivationHelp": "Comment le score de santé structurelle est dérivé des contrôles d'intégrité sous-jacents.",
      "structuralHealthHelp": "Intégrité structurelle du graphe — références orphelines, nœuds isolés et arêtes malformées.",
      "structuralHealthLabel": "Santé structurelle",
      "structuralMetaFallback": "Aucune donnée structurelle pour le moment",
      "targetSchema": "Conformité au schéma",
      "targetSemantic": "Cohérence sémantique",
      "targetStructural": "Santé structurelle",
      "validatingHint": "Cela peut prendre quelques minutes selon la taille du graphe.",
      "validationReportTitle": "Rapport de validation",
      "validationTargetsLegend": "Cibles de validation",
      "view": "Voir",
      "weightBitSchema": "schéma {{value}}",
      "weightBitSemantic": "sémantique {{value}}",
      "weightBitStructural": "structure {{value}}",
      "weightedMixSummary": "Mélange pondéré de {{bits}} = confiance {{confidence}}"
    },
    "graphApprovalSession": {
      "addToQueue": "Ajouter à la file",
      "addTripletButton": "Ajouter un triplet",
      "addTripletDescription": "Proposez un nouveau triplet sujet–relation–objet pour cette session.",
      "addTripletTitle": "Ajouter un triplet",
      "approve": "Approuver",
      "approveAll": "Tout approuver",
      "backToApprovalsAriaLabel": "Retour aux approbations",
      "cancel": "Annuler",
      "collapse": "Réduire",
      "collapsePanelAriaLabel": "Réduire le panneau de révision",
      "collapseSchemaPanelAriaLabel": "Réduire le panneau de schéma",
      "collapseSchemaTooltip": "Réduire le panneau de schéma",
      "columnConfidence": "Confiance",
      "columnObject": "Objet",
      "columnRelation": "Relation",
      "columnSubject": "Sujet",
      "commit": "Valider",
      "commitSuccessApplied": "Modifications appliquées",
      "commitSuccessCounted_one": "{{count}} décision validée",
      "commitSuccessCounted_other": "{{count}} décisions validées",
      "committing": "Validation en cours…",
      "confidenceRangeLabel": "Confiance (0–1)",
      "confidenceTooltip": "Confiance : {{value}}",
      "decisionRecorded": "Décision enregistrée.",
      "defaultSessionTitle": "Session d'approbation",
      "emptyAllMessage": "Aucune modification proposée dans cette session.",
      "emptyFilteredMessage": "Aucun élément « {{kind}} » ne correspond au filtre actuel.",
      "entityNamePlaceholder": "Nom de l'entité",
      "expandPanelAriaLabel": "Développer le panneau de révision",
      "expandSchemaPanelAriaLabel": "Développer le panneau de schéma",
      "filterAll": "Tous",
      "filterEntities": "Entités",
      "filterProposedUpdatesAriaLabel": "Filtrer les modifications proposées",
      "filterTriplets": "Triplets",
      "graphCanvasAriaLabel": "Zone de dessin du graphe",
      "legendConflict": "Conflit",
      "legendExisting": "Existant",
      "legendNew": "Nouveau",
      "missingIdsMessage": "Aucune table ou session n'a été spécifiée.",
      "modify": "Modifier",
      "modifySnapshotTitle": "Modifier l'instantané",
      "noChangesStaged": "Aucune modification en attente",
      "noConfidenceScore": "Aucun score de confiance",
      "pendingBadge_one": "{{count}} en attente",
      "pendingBadge_other": "{{count}} en attente",
      "proposedUpdatesAriaLabel": "Modifications proposées",
      "proposedUpdatesTitle": "Modifications proposées",
      "refresh": "Actualiser",
      "refreshSessionTooltip": "Actualiser la session",
      "reject": "Rejeter",
      "rejectAll": "Tout rejeter",
      "relationPlaceholder": "Type de relation",
      "reviewerNotePlaceholder": "Ajouter une note (facultatif)",
      "schemaLabel": "Schéma",
      "schemaSidebarAriaLabel": "Schéma du graphe",
      "sessionContextAriaLabel": "Contexte de la session",
      "sessionSummary": "{{total}} au total · {{pending}} en attente",
      "showSchemaPanelAriaLabel": "Afficher le panneau de schéma",
      "showSchemaTooltip": "Afficher le panneau de schéma",
      "stageAllApproveTooltip": "Mettre en attente l'approbation de tous les éléments en attente",
      "stageAllRejectTooltip": "Mettre en attente le rejet de tous les éléments en attente",
      "stageFilteredApproveTooltip_one": "Mettre en attente l'approbation de {{count}} élément visible",
      "stageFilteredApproveTooltip_other": "Mettre en attente l'approbation de {{count}} éléments visibles",
      "stageFilteredRejectTooltip_one": "Mettre en attente le rejet de {{count}} élément visible",
      "stageFilteredRejectTooltip_other": "Mettre en attente le rejet de {{count}} éléments visibles",
      "stageModification": "Mettre la modification en attente",
      "stagedApprove": "Approuver",
      "stagedCount_one": "{{count}} modification en attente",
      "stagedCount_other": "{{count}} modifications en attente",
      "stagedModify": "Modifier",
      "stagedReject": "Rejeter",
      "unappliedCount_one": "{{count}} modification approuvée non encore écrite",
      "unappliedCount_other": "{{count}} modifications approuvées non encore écrites",
      "undo": "Annuler",
      "undoAll": "Tout annuler",
      "undoAllTooltip": "Abandonner toutes les décisions en attente"
    },
    "graphApprovals": {
      "auditLog": "Journal d'audit",
      "auditTrailTitle": "Piste d'audit",
      "backToGraphAriaLabel": "Retour au graphe",
      "columnAction": "Action",
      "columnActions": "Actions",
      "columnActor": "Acteur",
      "columnChangeRun": "Exécution de modifications",
      "columnCommit": "Commit",
      "columnCreatedAt": "Créé le",
      "columnCreatedBy": "Créé par",
      "columnMessage": "Message",
      "columnMode": "Mode",
      "columnPending": "En attente",
      "columnSource": "Source",
      "columnStatus": "Statut",
      "columnTriplet": "Triplet",
      "columnUpdatedAt": "Mis à jour",
      "columnVersion": "Version",
      "columnWhen": "Quand",
      "commitHistoryTitle": "Historique des commits",
      "commits": "Commits",
      "emptyAuditMessage": "Aucune entrée d'audit pour le moment.",
      "emptyCommitsMessage": "Aucun commit pour le moment.",
      "emptyRunsMessage": "Aucune exécution de modifications pour le moment.",
      "exportAuditAriaLabel": "Exporter le journal d'audit en CSV",
      "exportCsv": "Exporter en CSV",
      "filterAll": "Tous",
      "filterModeLabel": "Mode",
      "filterStatusLabel": "Statut",
      "footnoteText": "Les modifications approuvées sont écrites dans le graphe en direct. ",
      "hideAudit": "Masquer l'audit",
      "hideCommits": "Masquer les commits",
      "missingTableIdMessage": "Aucune table de graphe n'a été spécifiée.",
      "modeApprovalRequired": "Approbation requise",
      "modeBypassed": "Contourné",
      "openLivePreview": "Ouvrir l'aperçu en direct",
      "openSession": "Ouvrir la session",
      "pageSubtitle": "File de révision pour {{name}}",
      "pageTitle": "Approbations du graphe",
      "refresh": "Actualiser",
      "review": "Réviser",
      "runCount_one": "{{count}} exécution",
      "runCount_other": "{{count}} exécutions",
      "searchAuditPlaceholder": "Rechercher dans le journal d'audit…",
      "searchChangeRunsPlaceholder": "Rechercher des exécutions de modifications…",
      "searchCommitsPlaceholder": "Rechercher des commits…",
      "statusApplied": "Appliqué",
      "statusAutoApplied": "Appliqué automatiquement",
      "statusPartiallyApplied": "Partiellement appliqué",
      "statusPending": "En attente",
      "statusRejected": "Rejeté",
      "systemActor": "Système",
      "unknownUser": "Utilisateur inconnu",
      "wholeRun": "Exécution entière"
    },
    "graphTablePreview": {
      "addedInVersionLegend": "Ajouté dans v{{version}}",
      "alreadyThereLegend": "Déjà présent",
      "askTheGraphDescription": "Posez une question en langage naturel et elle sera transformée en requête de graphe.",
      "askTheGraphTitle": "Interroger le graphe",
      "back": "Retour",
      "backToDataAriaLabel": "Retour aux données",
      "chatAssistantAriaLabel": "Assistant de chat du graphe",
      "chatDisabledLabel": "Chat indisponible",
      "chatDisabledTooltip": "Aucun modèle LLM n'est configuré pour ce locataire, le chat du graphe est donc indisponible.",
      "chatInputPlaceholder": "Posez une question sur ce graphe…",
      "chatWelcomeMessage": "Posez-moi une question sur ce graphe et je l'interrogerai pour vous.",
      "collapse": "Réduire",
      "collapseChatAriaLabel": "Réduire le chat",
      "commitLegendAriaLabel": "Légende de la version du commit",
      "commitOptionPlain": "v{{version}}{{whenSuffix}}",
      "commitOptionWithMessage": "v{{version}} — {{message}}{{whenSuffix}}",
      "commitVersionPlaceholder": "Sélectionner une version",
      "couldNotBuildQueryMessage": "Impossible de transformer cela en requête de graphe. Essayez de reformuler votre question.",
      "defaultGraphTitle": "Aperçu du graphe",
      "expandChatAriaLabel": "Développer le chat",
      "graphCanvasAriaLabel": "Zone de dessin du graphe",
      "graphContextAriaLabel": "Contexte du graphe",
      "graphSchemaAriaLabel": "Schéma du graphe",
      "highlightingMatchesMessage": "Mise en évidence de {{nodesPart}} et {{relsPart}}.",
      "latestLiveOption": "Dernière version (en direct)",
      "matchedNodesPart_one": "{{count}} nœud correspondant",
      "matchedNodesPart_other": "{{count}} nœuds correspondants",
      "matchedRelationshipsPart_one": "{{count}} relation correspondante",
      "matchedRelationshipsPart_other": "{{count}} relations correspondantes",
      "missingTableIdMessage": "Aucune table de graphe n'a été spécifiée.",
      "modelLabel": "Modèle",
      "modelLabelLoading": "Chargement des modèles…",
      "newestCommitMatchesLatestNotice": "La version {{version}} est le commit le plus récent, cette vue correspond donc au graphe en direct.",
      "noCommitStampsNotice": "Ce graphe n'a aucun horodatage de version de commit, le filtrage par version est donc impossible.",
      "noModelsConfiguredPlaceholder": "Aucun modèle configuré",
      "noNodesMatchedMessage": "Aucun nœud ne correspond à votre question.",
      "nothingToResetTooltip": "Rien à réinitialiser",
      "reset": "Réinitialiser",
      "resetViewTooltip": "Revenir à la vue complète du graphe",
      "schemaLabel": "Schéma",
      "searchModelsPlaceholder": "Rechercher des modèles…",
      "selectModelPlaceholder": "Sélectionner un modèle",
      "send": "Envoyer",
      "showSchemaPanelAriaLabel": "Afficher le panneau de schéma",
      "showSchemaTooltip": "Afficher le panneau de schéma",
      "statusAsOfVersion": "À la version v{{version}}",
      "statusHighlighted": "Mis en évidence",
      "statusSample": "Échantillon",
      "thinking": "Réflexion en cours…",
      "unexpectedResponseMessage": "Cette requête n'a pas renvoyé de données de graphe. Essayez de reformuler votre question.",
      "updatedGraphFallbackMessage": "Voici le graphe mis à jour.",
      "viewCommitVersionTooltip": "Afficher une version de commit spécifique",
      "wrongTableTypeError": "Cette table n'est pas une table de graphe."
    },
    "graphSchemaPanel": {
      "collapseAriaLabel": "Réduire le panneau de schéma",
      "collapseTooltip": "Réduire le panneau de schéma",
      "defaultEngineName": "Base de données de graphe",
      "deselectAll": "Tout désélectionner",
      "edgesLabel": "Arêtes",
      "emptyLabelTooltip": "Aucun nœud {{label}} dans cette version",
      "engineLabel": "Moteur",
      "graphDetailsTitle": "Détails du graphe",
      "labelCountTooltip_one": "{{count}} nœud {{label}}",
      "labelCountTooltip_other": "{{count}} nœuds {{label}}",
      "labelsTitle": "Labels",
      "nodesLabel": "Nœuds",
      "notAvailable": "N/D",
      "relationshipsTitle_one": "Relations ({{count}})",
      "relationshipsTitle_other": "Relations ({{count}})",
      "schemaTitle": "Schéma",
      "selectAll": "Tout sélectionner",
      "selectLabelsEmptyState": "Sélectionnez au moins un label pour voir ses relations.",
      "snapshotLabel": "Instantané"
    },
    "graphWebglCanvas": {
      "layingOutGraphAriaLabel": "Disposition du graphe en cours…"
    },
    "neo4jGraphView": {
      "canvasControlsAriaLabel": "Commandes de la zone de dessin",
      "clearSearchAriaLabel": "Effacer la recherche",
      "closeDetailsAriaLabel": "Fermer les détails",
      "closeDetailsKeepHighlightTooltip": "Fermer (conserve la mise en évidence)",
      "closeDetailsTooltip": "Fermer",
      "fitToViewTooltip": "Ajuster à la vue",
      "focusHintAfter": "pour réinitialiser le focus.",
      "focusHintBefore": "Focus sur un nœud — utilisez",
      "genericNodeLabel": "Nœud",
      "hiddenPropertiesFoot_one": "{{count}} autre propriété non affichée",
      "hiddenPropertiesFoot_other": "{{count}} autres propriétés non affichées",
      "lodHintDefault": "Zoomez pour plus de détails",
      "noMatchingNodes": "Aucun nœud correspondant",
      "nodeDetailsAriaLabel": "Détails de {{name}}",
      "relationshipDetailsAriaLabel": "Détails de la relation",
      "resetFocusTooltip": "Réinitialiser le focus",
      "searchAriaLabel": "Rechercher des nœuds",
      "searchPlaceholder": "Rechercher des nœuds…",
      "searchingEllipsis": "Recherche en cours…",
      "zoomInTooltip": "Zoomer",
      "zoomOutTooltip": "Dézoomer"
    },
    "vectorTab": {
      "actionDelete": "Supprimer",
      "actionEdit": "Modifier",
      "actionPreviewData": "Aperçu des données",
      "actionRemoveAsDefault": "Retirer par défaut",
      "actionSetAsDefault": "Définir par défaut",
      "actionSync": "Synchroniser",
      "actionVectorSearch": "Recherche vectorielle",
      "actionViewDetails": "Voir les détails",
      "addVectorDbTableButton": "Ajouter une table de base vectorielle",
      "allLabel": "Tous",
      "andOthersLabel_one": "{{names}} et {{count}} autre",
      "andOthersLabel_other": "{{names}} et {{count}} autres",
      "bulkActionDeleteSelected": "Supprimer la sélection",
      "bulkActionSyncMetadata": "Synchroniser les métadonnées",
      "bulkDeletePartialWarning": "{{deleted}} supprimées, {{skipped}} ignorées : {{errors}}",
      "bulkDeleteSuccessToast_one": "{{count}} table supprimée",
      "bulkDeleteSuccessToast_other": "{{count}} tables supprimées",
      "bulkSyncStartedRequeuedToast_one": "Synchronisation des métadonnées remise en file pour {{count}} table",
      "bulkSyncStartedRequeuedToast_other": "Synchronisation des métadonnées remise en file pour {{count}} tables",
      "bulkSyncStartedToast_one": "Synchronisation des métadonnées démarrée pour {{count}} table",
      "bulkSyncStartedToast_other": "Synchronisation des métadonnées démarrée pour {{count}} tables",
      "clearDefaultErrorToast": "Échec du retrait de {{name}} par défaut",
      "collectionViewTooltip": "Vue collection",
      "columnActions": "Actions",
      "columnCreator": "Créateur",
      "columnDatabase": "Base de données",
      "columnEmbeddingModel": "Modèle d'embedding",
      "columnIntrospection": "Introspection",
      "columnLogs": "Journaux",
      "columnName": "Nom",
      "columnStatus": "Statut",
      "columnVectors": "Vecteurs",
      "databaseViewTooltip": "Vue base de données",
      "defaultBadgeTooltip": "Table par défaut",
      "defaultSchemaLabel": "par défaut",
      "deleteConfirmLabel": "Supprimer",
      "deleteNamespaceConfirmMessage_one": "Voulez-vous vraiment supprimer l'espace de noms {{schema}} et sa {{count}} table enregistrée ? Seules les métadonnées {{brand}} seront supprimées, et cette action est irréversible.",
      "deleteNamespaceConfirmMessage_other": "Voulez-vous vraiment supprimer l'espace de noms {{schema}} et ses {{count}} tables enregistrées ? Seules les métadonnées {{brand}} seront supprimées, et cette action est irréversible.",
      "deleteNamespacePartialWarning": "{{deleted}} espace(s) de noms supprimé(s) sur {{schemaCount}}, {{skipped}} ignoré(s)",
      "deleteNamespaceSuccessToast_one": "Espace de noms supprimé ({{count}} table retirée)",
      "deleteNamespaceSuccessToast_other": "Espace de noms supprimé ({{count}} tables retirées)",
      "deleteNamespaceSuccessToastNamed_one": "Espace de noms {{schema}} supprimé ({{count}} table retirée)",
      "deleteNamespaceSuccessToastNamed_other": "Espace de noms {{schema}} supprimé ({{count}} tables retirées)",
      "deleteNamespaceTitle": "Supprimer l'espace de noms",
      "deleteNamespacesConfirmMessage_one": "Voulez-vous vraiment supprimer {{namespaceCount}} espaces de noms et leur {{count}} table enregistrée ? Seules les métadonnées {{brand}} seront supprimées, et cette action est irréversible.",
      "deleteNamespacesConfirmMessage_other": "Voulez-vous vraiment supprimer {{namespaceCount}} espaces de noms et leurs {{count}} tables enregistrées ? Seules les métadonnées {{brand}} seront supprimées, et cette action est irréversible.",
      "deleteNamespacesCountLabel_one": "Supprimer {{count}} espace de noms",
      "deleteNamespacesCountLabel_other": "Supprimer {{count}} espaces de noms",
      "deleteNamespacesSuccessToast_one": "{{schemaCount}} espaces de noms supprimés ({{count}} table retirée)",
      "deleteNamespacesSuccessToast_other": "{{schemaCount}} espaces de noms supprimés ({{count}} tables retirées)",
      "deleteNamespacesTitle": "Supprimer les espaces de noms",
      "deleteSelectedTablesConfirmMessage_one": "Voulez-vous vraiment supprimer la {{count}} table sélectionnée ? Cette action est irréversible.",
      "deleteSelectedTablesConfirmMessage_other": "Voulez-vous vraiment supprimer les {{count}} tables sélectionnées ? Cette action est irréversible.",
      "deleteSelectedTablesTitle": "Supprimer les tables sélectionnées",
      "deleteTableConfirmMessage": "Voulez-vous vraiment supprimer {{name}} ? Cette action est irréversible.",
      "deleteTableConfirmTitle": "Supprimer la table",
      "deleteTablesCountLabel_one": "Supprimer {{count}} table",
      "deleteTablesCountLabel_other": "Supprimer {{count}} tables",
      "deletingLabel": "Suppression…",
      "favoritesLabel": "Favoris",
      "filterAllCreatorsPlaceholder": "Tous les créateurs",
      "filterAllEnginesPlaceholder": "Tous les moteurs",
      "filterCreatorLabel": "Créateur",
      "filterEngineLabel": "Moteur",
      "namespacesTitle": "Espaces de noms",
      "noConnectorsYet": "Aucun connecteur pour le moment",
      "notConfigured": "Non configuré",
      "setDefaultErrorToast": "Échec de la définition de {{name}} par défaut",
      "syncMetadataErrorToast": "Échec de la synchronisation des métadonnées de {{name}}",
      "syncStatus": {
        "active": "Actif",
        "failed": "Échec",
        "inactive": "Inactif",
        "queued": "En file d'attente",
        "running": "En cours",
        "synced": "Synchronisé"
      },
      "unknownConnectorType": "Inconnu",
      "unknownCreator": "Inconnu",
      "vectorDbExplorerAriaLabel": "Explorateur de base vectorielle",
      "vectorTablesLeafTitle": "Tables vectorielles",
      "vectorTablesLeafTitleWithSchema": "Tables vectorielles — {{schema}}",
      "viewLink": "Voir",
      "viewSyncLogsTooltip": "Voir les journaux de synchronisation",
      "resourceVectorDatabases": "bases de données vectorielles",
      "resourceVectorDatabase": "base de données vectorielle"
    },
    "vectorSearchModal": {
      "advancedRagLabel": "RAG avancé",
      "closeDialogAriaLabel": "Fermer",
      "contentLabel": "Contenu",
      "coverageLabel": "Couverture",
      "embeddingModelLabel": "Modèle d'embedding",
      "enhancementsLabel": "Améliorations",
      "foundResultsPrefix": "Trouvé",
      "hideButton": "Masquer",
      "hydeEnhancementLabel": "HyDE (Hypothetical Document Embeddings)",
      "idFallbackLabel": "Résultat {{id}}",
      "latencyMs": "{{ms}} ms",
      "loadingOption": "Chargement…",
      "metadataLabel": "Métadonnées",
      "missingAspectsLabel": "Aspects manquants : {{aspects}}",
      "modelDefaultLabel": "{{name}} (par défaut)",
      "modelLabel": "Modèle : {{name}}",
      "modelsWordBold": "modèles",
      "multiQueryExpansionLabel": "Expansion multi-requêtes",
      "noEmbeddingModelsOption": "Aucun modèle d'embedding disponible",
      "noModelRegisteredBody": "Pour effectuer une recherche vectorielle sur cette table, enregistrez un ou plusieurs",
      "noModelRegisteredBold": "Aucun modèle d'embedding enregistré.",
      "noModelRegisteredSuffix": "pour les embeddings, ou passez au RAG avancé.",
      "noResultsBasicHint": "Essayez une autre requête ou vérifiez votre modèle d'embedding.",
      "noResultsFoundTitle": "Aucun résultat trouvé",
      "noResultsRagHint": "Reformulez votre requête ou ajustez la stratégie RAG.",
      "qualityLabel": "Qualité :",
      "ragSearchButton": "Recherche RAG",
      "ragSearchingButton": "Recherche en cours…",
      "ragStrategyConfigTitle": "Configuration de la stratégie RAG",
      "registerModelFirstTooltip": "Enregistrez d'abord un modèle d'embedding",
      "relevanceLabel": "Pertinence :",
      "rerankingLabel": "Reranking",
      "resultFallbackLabel": "Résultat {{index}}",
      "resultsInLatencyMiddle": "résultats en",
      "resultsLabel": "Résultats :",
      "resultsSuffix": "résultats",
      "searchButton": "Rechercher",
      "searchFailedTitle": "Échec de la recherche",
      "searchModelsPlaceholder": "Rechercher des modèles…",
      "searchPlaceholder": "Saisissez votre requête de recherche…",
      "searchingButton": "Recherche en cours…",
      "selfCorrectedBadge_one": "Auto-corrigé ({{count}} tentative)",
      "selfCorrectedBadge_other": "Auto-corrigé ({{count}} tentatives)",
      "selfRagCorrectionLabel": "Correction Self-RAG",
      "semanticSearchBody": "Saisissez une requête ci-dessus pour rechercher dans les embeddings vectoriels de cette table.",
      "semanticSearchTitle": "Recherche sémantique",
      "settingsButton": "Paramètres",
      "strategyAutoOption": "Automatique",
      "strategyDecompositionOption": "Décomposition",
      "strategyDescriptionAuto": "Sélectionne automatiquement la meilleure stratégie de récupération pour votre requête.",
      "strategyDescriptionDecomposition": "Décompose les requêtes complexes en sous-questions et effectue une récupération pour chacune.",
      "strategyDescriptionDirect": "Recherche directement à partir du texte brut de la requête.",
      "strategyDescriptionHyde": "Génère d'abord une réponse hypothétique, puis effectue la recherche à partir de son embedding.",
      "strategyDescriptionMultiQuery": "Génère plusieurs variantes de la requête pour élargir la couverture de la récupération.",
      "strategyDirectOption": "Direct",
      "strategyHydeOption": "HyDE",
      "strategyLabel": "Stratégie",
      "strategyMultiQueryOption": "Multi-requêtes",
      "title": "Recherche vectorielle",
      "useDefaultOption": "Utiliser la valeur par défaut"
    },
    "storageTab": {
      "actionDelete": "Supprimer",
      "actionExport": "Exporter",
      "actionPreviewFiles": "Aperçu des fichiers",
      "actionSetAsDefault": "Définir par défaut",
      "actionSync": "Synchroniser",
      "actionSyncing": "Synchronisation…",
      "actionViewDetails": "Voir les détails",
      "addStorageButton": "Ajouter un stockage",
      "allLabel": "Tous",
      "columnActions": "Actions",
      "columnConnector": "Connecteur",
      "columnContainer": "Conteneur",
      "columnCreated": "Créé",
      "columnFolder": "Dossier",
      "columnLogs": "Journaux",
      "columnStatus": "Statut",
      "columnUpdated": "Mis à jour",
      "defaultBadgeTooltip": "Dossier par défaut",
      "defaultBucketLabel": "par défaut",
      "defaultConnectorName": "Connecteur inconnu",
      "deleteConfirmLabel": "Supprimer",
      "deleteConfirmMessage": "Voulez-vous vraiment supprimer {{name}} ? Cette action est irréversible.",
      "deleteConfirmTitle": "Supprimer le dossier de stockage",
      "emptyMessage": "Aucun dossier de stockage trouvé",
      "exportSelectedAction": "Exporter la sélection",
      "favoritesLabel": "Favoris",
      "filterAllCreatorsPlaceholder": "Tous les créateurs",
      "filterAllTypesPlaceholder": "Tous les types",
      "filterCreatorLabel": "Créateur",
      "filterStorageTypeLabel": "Type de stockage",
      "foldersLeafTitle": "Dossiers",
      "foldersLeafTitleWithBucket": "Dossiers — {{bucket}}",
      "listViewTooltip": "Vue liste",
      "noConnectorsYet": "Aucun connecteur pour le moment",
      "pendingBadge": "En attente",
      "setDefaultErrorToast": "Échec de la définition de {{name}} par défaut",
      "setDefaultSuccessToast": "{{name}} défini par défaut",
      "splitViewTooltip": "Vue partagée",
      "statusActive": "Actif",
      "statusApproved": "Approuvé",
      "statusRequested": "Demandé",
      "statusUnknown": "Inconnu",
      "storageExplorerAriaLabel": "Explorateur de stockage",
      "unknownConnectorType": "Inconnu",
      "viewLink": "Voir",
      "viewSyncLogsTooltip": "Voir les journaux de synchronisation"
    },
    "storageViewModal": {
      "auditInformationSectionTitle": "Informations d'audit",
      "basicInformationSectionTitle": "Informations de base",
      "closeButton": "Fermer",
      "closeDialogAriaLabel": "Fermer",
      "errorInformationSectionTitle": "Informations sur l'erreur",
      "fieldBucketName": "Nom du bucket",
      "fieldConnector": "Connecteur",
      "fieldCreatedAt": "Créé le",
      "fieldCreatedBy": "Créé par",
      "fieldErrorMessage": "Message d'erreur",
      "fieldFileCount": "Nombre de fichiers",
      "fieldFolderPath": "Chemin du dossier",
      "fieldId": "ID",
      "fieldStatus": "Statut",
      "fieldTotalSize": "Taille totale",
      "fieldUpdatedAt": "Mis à jour le",
      "fieldUpdatedBy": "Mis à jour par",
      "metadataSectionTitle": "Métadonnées",
      "noErrors": "Aucune erreur",
      "notAvailable": "N/D",
      "status": {
        "active": "Actif",
        "error": "Erreur",
        "syncing": "Synchronisation",
        "unknown": "Inconnu"
      },
      "storageInformationSectionTitle": "Informations de stockage",
      "title": "Détails du dossier de stockage"
    },
    "storageFolderPreview": {
      "actionsTooltip": "Actions",
      "cancelButton": "Annuler",
      "clearSearchAriaLabel": "Effacer la recherche",
      "clearSelectionAriaLabel": "Effacer la sélection",
      "closeDialogAriaLabel": "Fermer",
      "columnActions": "Actions",
      "columnModified": "Modifié",
      "columnName": "Nom",
      "columnSize": "Taille",
      "columnType": "Type",
      "downloadErrorToast": "Échec du téléchargement du fichier",
      "downloadResultAllFailed": "Aucun des fichiers sélectionnés n'a pu être téléchargé.",
      "downloadResultAllSuccess": "Les {{count}} fichiers ont tous été téléchargés avec succès.",
      "downloadResultOk": "OK",
      "downloadResultPartial": "{{successCount}} fichier(s) sur {{total}} téléchargé(s) avec succès. Échecs : {{failedNames}}",
      "downloadResultTitleFailed": "Téléchargement échoué",
      "downloadResultTitlePartial": "Téléchargement incomplet",
      "downloadResultTitleSuccess": "Téléchargement terminé",
      "downloadSelectedButton": "Télécharger la sélection",
      "downloadSelectedTooltip": "Télécharger les fichiers sélectionnés",
      "downloadingSelectedButton": "Téléchargement…",
      "emptySearchState": "Aucun fichier ne correspond à votre recherche",
      "emptyState": "Ce dossier ne contient aucun fichier",
      "exportAction": "Télécharger",
      "firstPageTooltip": "Première page",
      "lastPageTooltip": "Dernière page",
      "nextPageTooltip": "Page suivante",
      "openingFileLabel": "Ouverture du fichier…",
      "paginationInfo": "Affichage de {{from}} à {{to}} sur {{total}}",
      "previousPageTooltip": "Page précédente",
      "searchPlaceholder": "Rechercher des fichiers…",
      "selectAllAriaLabel": "Sélectionner tous les fichiers",
      "selectFileAriaLabel": "Sélectionner {{name}}",
      "selectedCount": "{{count}} sélectionné(s)",
      "selectionLimitWarning": "Vous ne pouvez sélectionner que 10 fichiers à la fois.",
      "syncButtonLabel": "Synchroniser",
      "syncButtonTooltip": "Synchroniser les fichiers de ce dossier",
      "syncingButtonLabel": "Synchronisation…",
      "viewAction": "Aperçu"
    },
    "storageFilePreview": {
      "closeDialogAriaLabel": "Fermer",
      "downloadButton": "Télécharger",
      "downloadErrorToast": "Échec du téléchargement du fichier",
      "emptyTable": "Aucune ligne à afficher",
      "imagePreviewAlt": "Aperçu de l'image",
      "loadErrorToast": "Échec de l'aperçu du fichier",
      "loadingDocument": "Chargement du document…",
      "loadingPresentation": "Chargement de la présentation…",
      "nullValueLabel": "NULL",
      "pdfPreviewTitle": "Aperçu PDF",
      "pptxPreviewTitle": "Aperçu PowerPoint",
      "rowsUnit": "lignes",
      "textPreviewAriaLabel": "Contenu du fichier",
      "tryAgainButton": "Réessayer",
      "unableToLoadTitle": "Impossible d'afficher le fichier",
      "unsupportedHint": "Ce type de fichier ne peut pas être affiché dans le navigateur. Téléchargez le fichier pour l'ouvrir.",
      "unsupportedTitle": "Aperçu non disponible"
    },
    "groupedStorageView": {
      "bucketPathTooltip": "{{bucket}}/{{path}}",
      "createdTooltip": "Créé",
      "emptyState": "Aucun dossier de stockage trouvé",
      "emptyStateHint": "Essayez un autre terme de recherche",
      "fileCount_one": "{{count}} fichier",
      "fileCount_other": "{{count}} fichiers",
      "folderCount_one": "{{count}} dossier",
      "folderCount_other": "{{count}} dossiers",
      "loadingFolders": "Chargement des dossiers…",
      "unknownConnectorName": "Connecteur inconnu",
      "updatedTooltip": "Mis à jour"
    },
    "metadataSyncLogsModal": {
      "bulkJobLabel": "tâche groupée",
      "closeAriaLabel": "Fermer",
      "collapseDetailAriaLabel": "Réduire les détails",
      "columnMessage": "Message",
      "columnStatus": "Statut",
      "columnWhen": "Quand",
      "emptyState": "Aucun journal de synchronisation trouvé",
      "entryCount_one": "{{count}} entrée",
      "entryCount_other": "{{count}} entrées",
      "expandDetailAriaLabel": "Développer les détails",
      "loadingLogs": "Chargement des journaux…",
      "title": "Journaux de synchronisation des métadonnées",
      "triggerLabel": "déclencheur :"
    },
    "bulkMetadataSyncModal": {
      "closeAriaLabel": "Fermer",
      "columnDetail": "Détail",
      "columnStatus": "Statut",
      "columnTable": "Table",
      "jobLabel": "Tâche",
      "loadingStatus": "Chargement du statut de synchronisation…",
      "noJobData": "Aucune donnée de tâche disponible",
      "requeuedToast_one": "{{count}} élément remis en file pour nouvelle tentative",
      "requeuedToast_other": "{{count}} éléments remis en file pour nouvelle tentative",
      "retryFailedButton_one": "Réessayer {{count}} échec",
      "retryFailedButton_other": "Réessayer {{count}} échecs",
      "title": "Synchronisation groupée des métadonnées"
    },
    "tableDataPreview": {
      "loadErrorToast": "Échec du chargement des données du tableau",
      "nullValueLabel": "NULL",
      "columnEdit": "Modifier",
      "editGoldenAnswerAriaLabel": "Modifier la réponse de référence",
      "csvExportedToast_other": "{{count}} lignes exportées au format CSV",
      "jsonExportedToast_other": "{{count}} lignes exportées au format JSON",
      "previewNotAvailable": "Aperçu non disponible pour cette source de données",
      "vertexAiDataStoreHint": "Ce tableau s'appuie sur un data store Vertex AI Search. Obtenez un aperçu en interrogeant directement le data store.",
      "vertexAiVectorSearchHint": "Ce tableau s'appuie sur un index Vertex AI Vector Search. Obtenez un aperçu en exécutant une recherche vectorielle.",
      "closeDialogAriaLabel": "Fermer",
      "unableToLoadTitle": "Impossible de charger les données",
      "dataUnavailableTitle": "Données indisponibles",
      "syncingButton": "Synchronisation…",
      "refreshMetadataButton": "Actualiser les métadonnées",
      "tryAgainButton": "Réessayer",
      "documentsUnit": "documents",
      "rowsUnit": "lignes",
      "elasticsearchSearchPlaceholder": "Rechercher avec la syntaxe de requête Lucene…",
      "searchPlaceholder": "Rechercher…",
      "clearSearchAriaLabel": "Effacer la recherche",
      "luceneQueryHintTitle": "Prend en charge la syntaxe de requête Lucene, par ex. champ:valeur AND autre:valeur",
      "paginationFullTextSearchHint": "La recherche en texte intégral s'applique à toutes les colonnes",
      "tableViewTitle": "Vue tableau",
      "tableTab": "Tableau",
      "graphViewTitle": "Vue graphique",
      "graphTab": "Graphique",
      "documentViewJsonTitle": "Vue document (JSON)",
      "documentsTab": "Documents",
      "tabularViewTitle": "Vue tabulaire",
      "exportJsonButton": "Exporter en JSON",
      "exportingButton": "Exportation…",
      "exportCsvButton": "Exporter en CSV",
      "documentFallbackLabel": "Document {{index}}",
      "statusLabel": "Statut : {{status}}",
      "hideJsonButton": "Masquer le JSON",
      "showJsonButton": "Afficher le JSON",
      "noPreviewFieldsHint": "Aucun champ d'aperçu configuré pour ce document.",
      "pageOfLabel": "Page {{page}} sur {{totalPages}}",
      "pageSizeLabel": "Lignes par page",
      "previousButton": "Précédent",
      "nextButton": "Suivant",
      "noDataFoundEmptyMessage": "Aucune donnée trouvée"
    },
    "ontology": {
      "retrievalConfigPanel": {
        "strategyAuto": "Auto",
        "strategyAutoDescription": "Choisit automatiquement la meilleure stratégie de récupération selon la requête",
        "strategyVector": "Recherche vectorielle",
        "strategyVectorDescription": "Récupère les résultats via une recherche de similarité sémantique sur les embeddings",
        "strategySql": "SQL",
        "strategySqlDescription": "Récupère les résultats en générant et exécutant des requêtes SQL sur la table",
        "strategyHybrid": "Hybride",
        "strategyHybridDescription": "Combine la recherche vectorielle et la recherche par mots-clés/SQL pour des résultats plus précis",
        "fusionMethodRrf": "Fusion par rang réciproque",
        "fusionMethodRrfDescription": "Combine les listes de résultats classés par fusion de rang réciproque",
        "fusionMethodWeighted": "Somme pondérée",
        "fusionMethodWeightedDescription": "Combine les scores via une somme pondérée des résultats vectoriels et par mots-clés",
        "fusionMethodCascade": "Cascade",
        "fusionMethodCascadeDescription": "Exécute d'abord la recherche par mots-clés, puis reclasse avec la recherche vectorielle",
        "distanceMetricCosine": "Cosinus",
        "distanceMetricEuclidean": "Euclidienne",
        "distanceMetricDotProduct": "Produit scalaire",
        "title": "Configuration de récupération",
        "resetToDefaultsTitle": "Réinitialiser aux valeurs par défaut",
        "resetButton": "Réinitialiser",
        "defaultStrategyLabel": "Stratégie de récupération par défaut",
        "vectorSearchSettingsLabel": "Paramètres de recherche vectorielle",
        "idColumnLabel": "Colonne ID",
        "autoDetectOption": "Détection automatique",
        "contentColumnLabel": "Colonne de contenu",
        "embeddingColumnLabel": "Colonne d'embedding",
        "distanceMetricLabel": "Métrique de distance",
        "hybridFusionSettingsLabel": "Paramètres de fusion hybride",
        "fusionMethodLabel": "Méthode de fusion",
        "weightDistributionLabel": "Répartition des poids",
        "vectorSliderLabel": "Poids vectoriel",
        "keywordSliderLabel": "Poids des mots-clés",
        "sqlSettingsLabel": "Paramètres SQL",
        "maxRowsLabel": "Nombre maximal de lignes renvoyées",
        "enableFullTextSearchLabel": "Activer la recherche en texte intégral",
        "rerankingLabel": "Reclassement",
        "enableCrossEncoderRerankingLabel": "Activer le reclassement par cross-encoder",
        "rerankingModelLabel": "Modèle de reclassement",
        "loadingModelsOption": "Chargement des modèles…",
        "noRegisteredModelsOption": "Aucun modèle enregistré",
        "rerankTopKLabel": "Top K du reclassement",
        "infoCardText": "Ces paramètres contrôlent la façon dont cette table est récupérée lors des requêtes RAG. Les changements s'appliquent à la prochaine interrogation de cette table."
      },
      "columnEditor": {
        "semanticTypeId": "Identifiant",
        "semanticTypeIdDescription": "Identifie de manière unique un enregistrement (par ex. clé primaire)",
        "semanticTypeEntity": "Entité",
        "semanticTypeEntityDescription": "Fait référence à une personne, un lieu ou une chose nommée",
        "semanticTypeMetric": "Métrique",
        "semanticTypeMetricDescription": "Une valeur numérique utilisée pour l'agrégation ou la mesure",
        "semanticTypeDimension": "Dimension",
        "semanticTypeDimensionDescription": "Un attribut catégoriel utilisé pour le regroupement ou le filtrage",
        "semanticTypeTimestamp": "Horodatage",
        "semanticTypeTimestampDescription": "Une valeur de date ou d'heure",
        "semanticTypeText": "Texte",
        "semanticTypeTextDescription": "Contenu textuel libre",
        "closeEditorTitle": "Fermer l'éditeur",
        "businessNameLabel": "Nom métier",
        "businessNameHint": "Un nom convivial pour cette colonne",
        "businessNamePlaceholder": "par ex. Nom du client",
        "descriptionLabel": "Description",
        "descriptionHint": "Expliquez ce que représente cette colonne",
        "descriptionPlaceholder": "par ex. Le nom légal complet du client",
        "semanticTypeLabel": "Type sémantique",
        "semanticTypeHint": "Classez le type de données que contient cette colonne",
        "exampleValuesLabel": "Valeurs d'exemple",
        "exampleValuesHint": "Des exemples de valeurs pour aider les autres à comprendre cette colonne",
        "addExamplePlaceholder": "Ajouter une valeur d'exemple",
        "constraintsLabel": "Contraintes",
        "constraintsHint": "Règles métier ou contraintes de validation pour cette colonne",
        "constraintsPlaceholder": "par ex. Ne doit pas être vide",
        "relationshipsLabel": "Relations",
        "relationshipsHint": "Autres tables ou colonnes en relation avec cette colonne",
        "tableNamePlaceholder": "Nom de la table",
        "columnNamePlaceholder": "Nom de la colonne",
        "relationshipTypeForeignKey": "Clé étrangère",
        "relationshipTypeReference": "Référence",
        "addRelationshipButton": "Ajouter une relation",
        "searchSettingsLabel": "Paramètres de recherche",
        "searchSettingsHint": "Contrôle la façon dont cette colonne est utilisée dans la recherche et la récupération",
        "searchableLabel": "Consultable",
        "searchableHint": "Inclure cette colonne dans la recherche en texte intégral et par mots-clés",
        "embedForVectorSearchLabel": "Intégrer pour la recherche vectorielle",
        "embedForVectorSearchHint": "Générer des embeddings pour cette colonne afin de prendre en charge la recherche sémantique"
      },
      "tableDescriptionEditor": {
        "tablePurposeLabel": "Objectif de la table",
        "tablePurposeHelp": "Décrivez à quoi sert cette table",
        "tablePurposePlaceholder": "par ex. Stocke l'historique des commandes clients pour les rapports",
        "businessContextLabel": "Contexte métier",
        "businessContextHelp": "Expliquez le contexte métier et la place de cette table dans le modèle de données global",
        "businessContextPlaceholder": "par ex. Utilisée par l'équipe commerciale pour suivre le traitement des commandes",
        "sampleQuestionsLabel": "Questions types",
        "sampleQuestionsHelp": "Exemples de questions auxquelles cette table peut aider à répondre",
        "removeQuestionTitle": "Supprimer la question",
        "addQuestionPlaceholder": "Ajouter une question type",
        "addQuestionTitle": "Ajouter une question",
        "addButton": "Ajouter",
        "tipsTitle": "Conseils",
        "tip1": "Soyez précis sur ce que contient la table et qui l'utilise.",
        "tip2": "Incluez les termes métier que les utilisateurs pourraient rechercher.",
        "tip3": "Ajoutez des questions types pour aider le modèle de récupération à cibler les requêtes pertinentes.",
        "tip4": "Gardez les descriptions concises mais informatives."
      },
      "schemaVisualizer": {
        "semanticTypeId": "Identifiant",
        "semanticTypeTimestamp": "Horodatage",
        "semanticTypeMetric": "Métrique",
        "semanticTypeDimension": "Dimension",
        "semanticTypeEntity": "Entité",
        "semanticTypeText": "Texte",
        "groupPrimaryKeys": "Clés primaires",
        "groupForeignKeys": "Clés étrangères",
        "groupTimestamps": "Horodatages",
        "groupMetrics": "Métriques",
        "groupDimensions": "Dimensions",
        "groupOther": "Autres",
        "subtitle": "Aperçu visuel des colonnes de la table et de leurs relations",
        "columnCount": "{{count}} colonne",
        "columnCount_other": "{{count}} colonnes",
        "hasOntologyLegend": "Ontologie définie",
        "foreignKeyLegend": "Clé étrangère"
      }
    },
    "tableOntologyPage": {
      "noTableIdError": "Aucun identifiant de table fourni",
      "saveSuccessToast": "Ontologie enregistrée avec succès",
      "saveErrorToast": "Échec de l'enregistrement de l'ontologie : {{message}}",
      "unsavedChangesConfirm": "Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter ?",
      "loadingMessage": "Chargement de l'ontologie de la table…",
      "schemaEditorUnavailableTitle": "Éditeur de schéma indisponible",
      "schemaEditorUnavailableMessage": "L'éditeur de schéma n'est pas disponible pour le type de connecteur de cette table.",
      "failedToLoadTitle": "Échec du chargement de la table",
      "tableNotFoundMessage": "La table demandée est introuvable.",
      "goBack": "Retour",
      "backToKnowledgeTooltip": "Retour à Knowledge",
      "breadcrumbKnowledge": "Knowledge",
      "breadcrumbTables": "Tables",
      "breadcrumbOntology": "Ontologie",
      "vectorBadge": "Vecteur",
      "unsavedChangesBadge": "Modifications non enregistrées",
      "resetToSavedTooltip": "Réinitialiser à la dernière version enregistrée",
      "reset": "Réinitialiser",
      "saving": "Enregistrement…",
      "saveChanges": "Enregistrer les modifications",
      "schemaPanelTitle": "Schéma",
      "databaseLabel": "Base de données",
      "schemaLabel": "Schéma",
      "tableLabel": "Table",
      "rowsLabel": "Lignes",
      "embeddingModelTitle": "Modèle d'embedding",
      "loadingModels": "Chargement des modèles…",
      "noEmbeddingModelsWarning": "Aucun modèle d'embedding n'est enregistré. Enregistrez-en un pour activer la recherche vectorielle pour cette table.",
      "selectModelOption": "Sélectionner un modèle",
      "modelOptionDefaultLabel": "{{name}} (par défaut)",
      "modelOptionLabel": "{{name}}",
      "noModelSelectedWarning": "Aucun modèle d'embedding sélectionné. La recherche vectorielle ne sera pas disponible pour cette table.",
      "columnsHeader": "Colonnes",
      "hasOntologyDefinedTooltip": "Ontologie définie pour cette colonne",
      "tabDescription": "Description",
      "tabRetrieval": "Récupération",
      "tabTest": "Test",
      "queryTestingTitle": "Test de requêtes",
      "queryTestingDescription": "Testez comment les requêtes sont récupérées selon la configuration de cette table.",
      "comingSoon": "Bientôt disponible"
    },
    "mongoCompassDocumentView": {
      "documentViewTitle": "Vue document",
      "documentsTab": "Documents",
      "tabularViewTitle": "Vue tabulaire",
      "tableTab": "Tableau",
      "exportDataButton": "Exporter les données",
      "closeAriaLabel": "Fermer",
      "filterLabel": "Filtre",
      "filterPlaceholder": "par ex. { status: \"active\" }",
      "filterInputAriaLabel": "Requête de filtre",
      "clearFilterAriaLabel": "Effacer le filtre",
      "applyFilterTitle": "Appliquer le filtre",
      "findButton": "Rechercher",
      "queryHint": "Entrez un filtre de requête MongoDB au format JSON",
      "documentCountLabel": "{{count}} document",
      "documentCountLabel_other": "{{count}} documents",
      "zeroResults": "Aucun résultat",
      "pageRangeHint": "{{from}}–{{to}} sur {{total}}",
      "documentFallbackLabel": "Document {{index}}",
      "hideDocumentAriaLabel": "Masquer le document",
      "showDocumentAriaLabel": "Afficher le document",
      "skipLimitLabel": "Ignorés : {{skip}}, Limite : {{limit}}",
      "pageSizeLabel": "Taille de page",
      "pageSizeSelectAriaLabel": "Sélectionner la taille de page",
      "previousButton": "Précédent",
      "nextButton": "Suivant"
    }
  },
  "accessRequests": {
    "manageAccessTitle": "Gérer l'accès à {{assetLabel}}",
    "assetTypeLabels": {
      "models": "Modèles",
      "tools": "Outils",
      "knowledge": "Connaissances",
      "storage": "Stockage",
      "skills": "Compétences",
      "orchestrators": "Orchestrateurs",
      "default": "Ressources"
    },
    "statusLabels": {
      "requested": "En attente",
      "approved": "Approuvé",
      "open": "Révoqué"
    },
    "loadingRequests": "Chargement des demandes d'accès...",
    "clearSearch": "Effacer la recherche",
    "emptyStateAll": "Aucune demande d'accès pour {{assetType}}.",
    "emptyStateFiltered": "Aucune demande d'accès {{status}} pour {{assetType}}.",
    "selectedCount": "{{count}} sélectionné(s)",
    "selectAll": "Tout sélectionner",
    "deselectAll": "Tout désélectionner",
    "approveSelected": "Approuver la sélection ({{count}})",
    "rejectSelected": "Rejeter la sélection ({{count}})",
    "columnAssetName": "Nom de la ressource",
    "columnProject": "Projet",
    "columnRequestedBy": "Demandé par",
    "columnStatus": "Statut",
    "columnCreated": "Créé",
    "columnLastUpdated": "Dernière mise à jour",
    "columnActions": "Actions",
    "approve": "Approuver",
    "reject": "Rejeter",
    "reApprove": "Réapprouver",
    "revokeAccess": "Révoquer l'accès",
    "rowsPerPage": "Lignes par page :",
    "showingRange": "Affichage de {{start}} à {{end}} sur {{total}}",
    "goToFirstPage": "Aller à la première page",
    "goToPreviousPage": "Aller à la page précédente",
    "goToPage": "Aller à la page {{page}}",
    "goToNextPage": "Aller à la page suivante",
    "goToLastPage": "Aller à la dernière page",
    "firstPage": "Première page",
    "previousPage": "Page précédente",
    "nextPage": "Page suivante",
    "lastPage": "Dernière page",
    "endOfTableReached": "Fin du tableau atteinte",
    "statusFilterLabel": "Statut",
    "statusFilterPlaceholder": "Statut",
    "projectFilterLabel": "Projet",
    "projectFilterPlaceholder": "Projet",
    "requestedByFilterLabel": "Demandé par",
    "requestedByFilterPlaceholder": "Demandé par",
    "bulkApprovePartial": "{{processed}} approuvée(s) ; {{skipped}} échouée(s) : {{errors}}",
    "bulkRejectPartial": "{{processed}} rejetée(s) ; {{skipped}} échouée(s) : {{errors}}"
  },
  "skills": {
    "title": "Compétences (Skills)",
    "subtitle": "Les compétences sont des packages d'instructions modulaires qui améliorent les capacités des agents.",
    "list": {
      "columns": {
        "name": "Nom de la compétence",
        "category": "Catégorie",
        "type": "Type",
        "model": "Modèle",
        "visibility": "Visibilité",
        "version": "Version",
        "access": "Accès",
        "updated": "Mise à jour",
        "actions": "Actions"
      },
      "actions": {
        "view": "Voir",
        "edit": "Modifier",
        "delete": "Supprimer",
        "export": "Exporter",
        "clone": "Cloner dans le projet",
        "manageAccess": "Gérer l'accès",
        "exportSelected": "Exporter la sélection",
        "deleteSelected": "Supprimer la sélection"
      },
      "badges": {
        "builtin": "Intégré",
        "platform": "Plateforme",
        "allModels": "Tous les modèles"
      },
      "bulkDelete": {
        "title": "Supprimer les compétences sélectionnées",
        "noSelection": "Aucune compétence sélectionnée",
        "cannotDeleteBuiltin": "Impossible de supprimer les compétences de la plateforme intégrées",
        "skippedBuiltin": "{{count}} compétence(s) intégrée(s) ignorée(s).",
        "success": "{{count}} compétence(s) supprimée(s) avec succès",
        "partial": "{{deleted}} compétence(s) supprimée(s), {{skipped}} échec(s) : {{errors}}",
        "error": "Échec de la suppression des compétences"
      }
    },
    "categories": {
      "data_processing": "Traitement des données",
      "data_analysis": "Analyse des données",
      "reasoning": "Raisonnement",
      "code_generation": "Génération de code",
      "document_analysis": "Analyse de documents",
      "web_interaction": "Interaction Web",
      "communication": "Communication",
      "research": "Recherche",
      "automation": "Automatisation",
      "custom": "Personnalisé"
    },
    "types": {
      "behavioral": "Comportemental",
      "procedural": "Procédural",
      "knowledge": "Connaissance",
      "guardrail": "Garde-fou",
      "custom": "Personnalisé"
    },
    "visibility": {
      "project": "Projet",
      "tenant": "Organisation",
      "public": "Plateforme"
    },
    "filters": {
      "category": "Catégorie",
      "type": "Type",
      "visibility": "Visibilité",
      "project": "Projet",
      "all": "Tout",
      "favorites": "Favoris"
    },
    "newSkill": "Nouvelle compétence",
    "loading": "Chargement des compétences...",
    "empty": {
      "message": "Aucune compétence trouvée. Créez votre première compétence pour améliorer les capacités de l'agent."
    },
    "delete": {
      "title": "Supprimer la compétence",
      "message": "Êtes-vous sûr de vouloir supprimer \"{{name}}\" ? Cette action est irréversible.",
      "bulkMessage": "Êtes-vous sûr de vouloir supprimer {{count}} compétence(s) ? Cette action est irréversible.",
      "bulkConfirm": "Supprimer {{count}} compétence(s)",
      "bulkDepsOthers": "{{names}} et {{count}} autres"
    },
    "messages": {
      "dependencyCheckFailed": "Échec de la vérification des dépendances de la compétence",
      "deleteFailed": "Échec de la suppression de la compétence"
    },
    "edit": {
      "subtitle": {
        "new": "Créer une capacité modulaire",
        "readonly": "Configuration de la compétence (Lecture seule)",
        "edit": "Modifier la configuration de la compétence"
      },
      "sidebar": {
        "settings": "Paramètres de la compétence",
        "tags": "Tags",
        "loadingQuota": "Chargement du quota..."
      },
      "placeholders": {
        "name": "Nom de la compétence",
        "description": "Brève description de ce que fait cette compétence",
        "instructions": "# Instructions de la compétence\nDécrivez la capacité spécifique que cette compétence fournit.\n\n## Règles de base\n1. Définissez comment l'agent doit se comporter\n2. Listez les procédures étape par étape\n3. Précisez les contraintes éventuelles\n\n## Exemples\nFournissez des exemples de résultats attendus...",
        "project": "Sélectionner un projet",
        "modelAgnostic": "Indépendant du modèle (tous les modèles)"
      },
      "hints": {
        "targetModel": "Taguez éventuellement cette compétence pour un modèle spécifique. Les compétences non taguées sont compatibles avec tous les modèles.",
        "visibilityProject": "La compétence sera disponible uniquement pour le projet sélectionné.",
        "visibilityPlatform": "La compétence sera disponible pour tous les projets via un processus d'approbation."
      },
      "editor": {
        "instructions": "Instructions (SKILL.md)",
        "markdownSupported": "Markdown supporté",
        "noInstructions": "Aucune instruction à prévisualiser pour le moment."
      },
      "header": {
        "quotaExceeded": "Quota de compétences dépassé",
        "createSkill": "Créer une compétence",
        "saveChanges": "Enregistrer les modifications"
      }
    }
  },
  "agentAutoTune": {
    "meta": {
      "breadcrumb": "Fil d'Ariane",
      "agentStudio": "Agent Studio",
      "autoTuneRunsList": "Liste d'exécutions d'auto-réglage",
      "metaDashboard": "Méta tableau de bord"
    },
    "compare": {
      "phaseStep": "Phase / étape",
      "score": "Score",
      "metric": "Métrique",
      "baselineScore": "Score de base",
      "optimizedScore": "Score optimisé",
      "improvementPct": "Amélioration %",
      "holdoutScore": "Score de réserve",
      "costUsd": "Coût (USD)",
      "iterations": "Itérations",
      "nodesOptimized": "Nœuds optimisés",
      "nodesTotal": "Nœuds totaux",
      "version": "Version",
      "node": "Nœud",
      "loadingSessions": "Chargement des sessions pour la comparaison...",
      "selectSessions": "Sélectionnez au moins 2 sessions pour comparer.",
      "backToRuns": "Retour aux exécutions",
      "runComparisonTitle": "Comparaison d'exécution",
      "comparingSessions": "Comparaison de {{count}} sessions d'auto-réglage",
      "summaryComparison": "Comparaison de résumé",
      "noDataToCompare": "Aucune donnée à comparer",
      "scoreTrajectoryOverlay": "Superposition de trajectoire de score",
      "comparingRuns": "comparaison des exécutions",
      "chartExplainer1": "pas pour l'attribution au niveau du nœud. Les séries sont complétées avec des lacunes afin que les",
      "chartExplainer2": "longueurs de trajectoires s'alignent par index.",
      "labelsMatch": "Les étiquettes correspondent à la session la plus longue",
      "phasesBaseline": "phases afin que la Base /",
      "validationLinesUp": "la validation soit alignée d'une exécution à l'autre.",
      "notEnoughTrajectory": "Pas assez de données de trajectoire (au moins deux points nécessaires).",
      "nodeLevelScore": "Comparaison de score par nœud",
      "noNodeDataToCompare": "Aucune donnée de nœud à comparer",
      "overlayExplainer": "Superpose les courbes de score composites. L'axe X suit les phases les plus longues."
    },
    "runs": {
      "title": "Optimiseur d'Agent",
      "subtitle": "Exécutions d'optimisation de bout en bout pour vos agents",
      "newAutoTune": "Nouvel Auto-Tune",
      "newAutoTuneButton": "Nouvel Auto-Tune",
      "selectProjectAgent": "Sélectionnez un projet et un agent pour démarrer l'optimisation",
      "project": "Projet",
      "agent": "Agent",
      "proceed": "Continuer",
      "proceedButton": "Continuer",
      "startAutoTune": "Démarrer l'Auto-Tune",
      "metaDashboard": "Méta-tableau de bord",
      "metaDashboardButton": "Méta-tableau de bord",
      "compareSelected": "Comparer les éléments sélectionnés",
      "status": "Statut",
      "approval": "Approbation",
      "optimizer": "Optimiseur",
      "searchPlaceholder": "Rechercher des sessions...",
      "backToAgentsAria": "Retour aux agents",
      "loadingMessage": "Chargement des exécutions d'auto-tune...",
      "emptyMessage": "Aucune exécution d'auto-tune pour le moment. Cliquez sur 'Nouvel Auto-Tune' pour commencer.",
      "statuses": {
        "all": "Tous les statuts",
        "queued": "En file d'attente",
        "running": "En cours",
        "baseline_running": "Base",
        "optimizing": "Optimisation",
        "validating": "Validation",
        "completed": "Terminé",
        "completed_partial": "Partiel",
        "failed": "Échoué",
        "cancelled": "Annulé"
      },
      "approvals": {
        "all": "Toutes les approbations",
        "pending": "En attente",
        "approved": "Approuvé",
        "rejected": "Rejeté"
      },
      "optimizers": {
        "all": "Tous les optimiseurs"
      },
      "picker": {
        "loadingProjects": "Chargement des projets…",
        "selectProject": "Sélectionner un projet…",
        "selectAgent": "Sélectionner un agent…",
        "selectProjectFirst": "Sélectionner d'abord un projet…",
        "loadingAgents": "Chargement des agents…",
        "noAgents": "Aucun agent dans ce projet"
      },
      "columns": {
        "agentName": "Nom de l'agent",
        "dataset": "Jeu de données",
        "optimizer": "Optimiseur",
        "version": "Version",
        "status": "Statut",
        "approval": "Approbation",
        "baselineScore": "Score de base",
        "postTuneScore": "Score après réglage",
        "holdout": "Holdout",
        "improvement": "Amélioration",
        "trajectory": "Trajectoire",
        "cost": "Coût",
        "nodes": "Nœuds",
        "healing": "Correction",
        "duration": "Durée",
        "createdBy": "Créé par",
        "createdAt": "Créé le",
        "actions": "Actions",
        "optimizedNodes": "{{optimized}}/{{total}} optimisé"
      },
      "actions": {
        "compareSelected": "Comparer les éléments sélectionnés",
        "retry": "Réessayer",
        "stopRun": "Arrêter l'exécution",
        "delete": "Supprimer",
        "stopConfirm": "Annuler l'auto-tune pour \"{{label}}\" ? Cela arrêtera le workflow immédiatement.",
        "cancelSuccess": "Auto-tune annulé.",
        "cancelError": "Échec de l'annulation de l'auto-tune. Veuillez réessayer.",
        "deleteConfirm": "Supprimer la session d'auto-tune pour \"{{label}}\" ? Cela ne peut pas être annulé.",
        "deleteSuccess": "Session d'auto-tune supprimée.",
        "deleteError": "Échec de la suppression de la session."
      },
      "retryDialog": {
        "title": "Réessayer l'Auto-Tune",
        "message": "Démarrer un nouvel auto-tune pour",
        "messageSuffix": " en utilisant le même jeu de données et les mêmes options que cette exécution ?",
        "confirmLabel": "Réessayer",
        "successToast": "Nouvel auto-tune démarré.",
        "errorToast": "Échec du redémarrage de l'auto-tune."
      }
    },
    "detail": {
      "agentStudio": "Agent Studio",
      "autoTuneRunsList": "Liste d'exécutions d'auto-réglage",
      "backToList": "Retour à la liste",
      "sessionOverview": "Aperçu de session",
      "configuration": "Configuration",
      "evaluationDetail": "Détail de l'évaluation",
      "nodeFeedback": "Retour sur nœud",
      "nodeComparison": "Comparaison de nœud",
      "iterationHistory": "Historique des itérations",
      "approveDeploy": "Approuver et déployer",
      "applyChanges": "Appliquer au brouillon",
      "rejectOptimization": "Rejeter l'optimisation",
      "sessionStatus": "Statut de session",
      "optimizerConfig": "Config d'optimiseur",
      "evaluation": "Évaluation",
      "originalSystemPrompt": "Invite système d'origine",
      "optimizedSystemPrompt": "Invite système optimisée",
      "loading": {
        "opening": "Ouverture des exécutions d'auto-tune…",
        "session": "Chargement de la session d'optimisation..."
      },
      "notFound": {
        "message": "Session d'auto-tune introuvable",
        "backButton": "Retour aux exécutions d'auto-tune"
      },
      "header": {
        "defaultTitle": "Centre d'intelligence d'optimisation",
        "workflow": "Workflow",
        "created": "Créé",
        "backToRunsAria": "Retour aux exécutions"
      },
      "banner": {
        "failedTitle": "Échec de l'optimisation",
        "rejectedTitle": "Prompt optimisé rejeté",
        "noReason": "Aucun motif de rejet n'a été fourni."
      },
      "tabs": {
        "overview": "Aperçu",
        "objectives": "Fonctions d'objectif",
        "nodes": "Analyse de nœud",
        "prompts": "Labo de prompts",
        "regression": "Analyse de régression",
        "execution": "Traces d'exécution",
        "audit": "Audit et correction"
      },
      "applyPanel": {
        "title": "Appliquer la stratégie",
        "applyCurrent": "Appliquer à l'agent actuel",
        "newVersion": "Enregistrer sous nouvelle version",
        "previewOnly": "Aperçu uniquement",
        "versionBump": "Incrément de version :",
        "saveAsNewProject": "Enregistrer sous nouveau projet",
        "projectName": "Nom du projet",
        "placeholderReason": "Raison facultative...",
        "reject": "Rejeter",
        "approveApply": "Approuver et appliquer",
        "noPermission": "Vous n'avez pas l'autorisation de créer des projets.",
        "previewUnavailable": "Non disponible pour Aperçu uniquement — choisissez d'abord une stratégie d'application."
      },
      "overview": {
        "pairedBaseline": "Base appariée (entraînement)",
        "pairedPostMean": "Moyenne post-appariée",
        "evalAccuracyImprovement": "Amélioration de la précision de l'évaluation",
        "baselineTrain": "Base (entraînement)",
        "baselineHoldout": "Base (holdout)",
        "optimizedScoreTrain": "Score optimisé (entraînement)",
        "optimizedScoreHoldout": "Score optimisé (holdout)",
        "improvementTrain": "Amélioration (entraînement)",
        "improvementHoldout": "Amélioration (holdout)",
        "estimatedCost": "Coût estimé",
        "duration": "Durée",
        "totalIterations": "Itérations totales",
        "optimizer": "Optimiseur",
        "nodesTotal": "Total des nœuds",
        "tokensSession": "Tokens (session)",
        "metricsUsed": "Métriques utilisées",
        "orchestrator": "Orchestrateur",
        "openWorkflowRun": "Ouvrir l'exécution du workflow",
        "lightningRuns": "Exécutions du graphe Agent Lightning",
        "runId": "ID d'exécution",
        "start": "Début",
        "end": "Fin",
        "optimizedScore": "Score optimisé",
        "improvement": "Amélioration",
        "iterations": "Itérations",
        "holdoutPostTune": "Holdout (post-réglage)",
        "cost": "Coût",
        "version": "Version",
        "configurationSummary": "Résumé de la configuration",
        "runTimeline": "Chronologie d'exécution",
        "timeline": {
          "created": "Créé",
          "started": "Démarré",
          "completed": "Terminé",
          "approvedBy": "Approuvé par {{user}}"
        },
        "noMetricBreakdown": "Aucune répartition par métrique n'est disponible pour cette session (par exemple, les scores n'ont pas été persistés par métrique). Ouvrez les détails de la notation (icône d'information) pour voir comment les scores principaux sont définis.",
        "metricBreakdownTitle": "Répartition des métriques",
        "columnMetric": "Métrique",
        "columnBaseline": "Base",
        "columnOptimized": "Optimisé",
        "columnDelta": "Delta",
        "columnChange": "Changement",
        "explainerLead": "Les scores sont un composite unique dans la plage 0–1 construit à partir de vos métriques d'évaluation, puis agrégé à travers les lignes de référence.",
        "explainerStep1Title": "Composite par ligne (objectif)",
        "explainerStep1Desc": "Pour chaque ligne de jeu de données, le système exécute les évaluateurs configurés (voir les métriques ci-dessous), produisant un score par métrique. Les métriques où les valeurs brutes inférieures sont meilleures (par exemple la toxicité) sont mappées afin que plus haut signifie toujours mieux avant le mixage.",
        "explainerWeightedSumPrefix": "Le score de la ligne est une",
        "explainerWeightedSum": "somme pondérée",
        "explainerWeightedSumMid": "de ces scores ajustés :",
        "explainerWeightedSumSuffix1": ", en utilisant",
        "explainerWeightedSumSuffix2": "de cette session (normalisé pour une somme de 1).",
        "explainerUnweightedPrefix": "Aucun",
        "explainerUnweightedMid": "n'est défini, donc le score de la ligne est la",
        "explainerUnweighted": "moyenne non pondérée",
        "explainerUnweightedSuffix": "des scores de métriques ajustés pour cette ligne.",
        "explainerStep2Title": "Score de base (fractionnement d'entraînement)",
        "explainerStep2Desc": "La base principale est la moyenne arithmétique des scores composites par ligne sur le fractionnement d'entraînement (lignes holdout exclues), en utilisant uniquement les métriques de session configurées, sur les lignes qui se sont terminées sans erreur d'exécution :",
        "explainerStep3Title": "Score optimisé et trajectoire",
        "explainerStep3Desc": "La même définition composite est utilisée lors de l'évaluation de l'agent après des modifications de prompt ; le score optimisé principal et la courbe d'itération utilisent cette même échelle.",
        "explainerMultiObjEnabled": "Le mode multi-objectif est activé.",
        "explainerMultiObjMid": "(ci-dessous) peut guider l'optimisation multi-objectif ; les composites de base et de ligne suivent toujours",
        "explainerMultiObjSuffix": "lorsqu'ils sont définis, sinon pondération égale comme décrit ci-dessus.",
        "explainerMetricsEvaluated": "Métriques évaluées dans cette session",
        "explainerRowWeights": "Poids composites de ligne",
        "explainerMultiObjWeights": "Poids multi-objectifs",
        "columnRawWeight": "Poids brut",
        "columnNormalized": "Normalisé",
        "columnMetricObjective": "Métrique / objectif",
        "explainerThisSession": "Cette session :",
        "explainerBaselineTrain": "Base (entraînement) =",
        "explainerOptimizedEquals": "Optimisé ="
      },
      "objectives": {
        "noObjectives": "Aucun objectif défini",
        "columnName": "Nom de l'objectif",
        "columnWeight": "Poids",
        "columnFormula": "Formule",
        "columnDescription": "Description"
      },
      "nodes": {
        "noNodes": "Aucun résultat de nœud disponible",
        "columnId": "ID de nœud",
        "columnOptimizer": "Optimiseur",
        "columnBaseline": "Score de base",
        "columnOptimized": "Score optimisé",
        "columnImprovement": "Amélioration",
        "columnTrajectory": "Trajectoire",
        "columnHoldout": "Score Holdout",
        "columnHoldoutImp": "Amélioration Holdout",
        "customPrompt": "Prompt système personnalisé",
        "modelOverride": "Surcharge de modèle",
        "instructionsOverride": "Surcharge d'instructions DSPy",
        "columnNode": "Nœud",
        "columnIter": "Itér",
        "columnBlame": "Blâme",
        "columnOriginalTrain": "Original (entraînement)",
        "columnOptimizedTrain": "Optimisé (entraînement)",
        "columnHealing": "Correction",
        "columnCost": "Coût",
        "collapse": "Réduire",
        "showConfig": "Afficher la configuration / détails de l'optimiseur",
        "noNodeAnalysisData": "Aucune donnée d'analyse de nœud disponible pour cette session."
      },
      "prompts": {
        "nodeLabel": "Nœud :",
        "selectNode": "Sélectionnez un nœud pour inspecter ses prompts...",
        "originalSystemPrompt": "Prompt système original",
        "optimizedSystemPrompt": "Prompt système optimisé",
        "originalInstructions": "Instructions d'origine (DSPy)",
        "optimizedInstructions": "Instructions optimisées (DSPy)",
        "versionBase": "Base",
        "versionLatest": "Dernier optimisé",
        "selectVersion": "Sélectionner la version",
        "fallbackLeft": "Gauche",
        "fallbackRight": "Droite",
        "noData": "Aucune donnée de prompt ou de paramètre disponible pour cette session."
      },
      "regression": {
        "noData": "Aucune donnée d'analyse de régression disponible.",
        "columnRowIndex": "Index de ligne",
        "columnBaseline": "Base",
        "columnOptimized": "Optimisé",
        "columnChange": "Variation",
        "columnInput": "Aperçu de l'entrée",
        "columnError": "Erreur",
        "columnOutput": "Aperçu de la sortie",
        "improvedRows": "Lignes améliorées",
        "degradedRows": "Lignes dégradées",
        "quarantinedRows": "Lignes en quarantaine",
        "columnRowNumber": "Ligne #",
        "columnQuestionInput": "Question / entrée",
        "columnDelta": "Delta",
        "columnWhatChanged": "Ce qui a changé",
        "columnInputPreview": "Aperçu de l'entrée",
        "columnOutputPreview": "Aperçu de la sortie",
        "metricNetImprovement": "Amélioration nette",
        "metricImprovedRows": "Lignes améliorées",
        "metricDegradedRows": "Lignes dégradées",
        "metricUnchangedRows": "Lignes inchangées",
        "metricTotalRows": "Total des lignes",
        "metricHoldoutEvaluated": "Lignes Holdout évaluées",
        "noDegradedRows": "Aucune ligne dégradée",
        "noImprovedRows": "Aucune ligne améliorée",
        "noQuarantinedRows": "Aucune ligne en quarantaine",
        "noReport": "Aucun rapport de régression ou ligne en quarantaine pour cette session."
      },
      "execution": {
        "title": "Chronologie d'exécution du pipeline",
        "noData": "Aucune donnée de chronologie d'exécution disponible.",
        "columnTask": "Tâche / Phase",
        "columnDuration": "Durée",
        "columnStatus": "Statut",
        "columnDetails": "Détails / Sortie",
        "activeRun": "Exécution active",
        "currentProcess": "Processus actuel",
        "activeNode": "Nœud actif",
        "optimizingNode": "Optimisation du nœud : {{node}}",
        "nodeId": "ID du nœud",
        "lastProcess": "Dernier processus",
        "phaseDurationWaterfall": "Cascade de durée de phase",
        "phaseDurationDesc": "Durées des phases d'exécution terminées en secondes (chronologique).",
        "phaseDurationExplainer": "Chaque barre représente une phase de workflow terminée (base, joint/Lightning, optimisation par nœud, validation). Les hauteurs représentent la durée en secondes ; la barre totale finale additionne toutes les phases terminées.",
        "phaseDurationsPending": "Les durées des phases apparaîtront ici au fur et à mesure que les étapes se terminent.",
        "phaseDurationsEmpty": "Aucun historique de durée de phase n'a été enregistré pour cette exécution.",
        "phaseLog": "Journal de phase",
        "fallbackPhase": "Phase {{num}}"
      },
      "audit": {
        "healingEvents": "Événements de correction",
        "auditTrail": "Piste d'audit",
        "noData": "Aucune donnée d'audit ou de correction disponible pour cette session.",
        "auditTrailCount": "Piste d'audit"
      },
      "charts": {
        "scoreTrajectory": "Trajectoire du score",
        "baselineObjective": "Base et notation de l'objectif",
        "metricComparison": "Comparaison de métriques : base vs optimisé",
        "convergenceAnalysis": "Analyse de convergence",
        "blameWaterfall": "Cascade de blâme",
        "costTokenBreakdown": "Répartition des coûts et tokens par nœud",
        "scatterBaselineOpt": "Nuage de points Base vs Optimisé (lignes d'entraînement)",
        "phaseDuration": "Cascade de durée de phase",
        "howToRead": "Comment lire ce graphique",
        "xAxisPhase": "Phase",
        "yAxisDuration": "Durée (secondes)",
        "summaryScoreTrajectory": "Score composite à chaque jalon d'exécution (base, Lightning facultatif, itérations d'optimisation, validation), avec des deltas étape par étape sur le deuxième axe.",
        "summaryBaselineObjective": "Scores composites 0–1 de vos métriques ; moyennes de base sur les lignes réussies. Utilisez l'icône d'informations pour les formules, les poids et les valeurs de cette session.",
        "summaryMetricComparison": "Les barres groupées comparent la base de chaque métrique configurée à la moyenne post-réglage.",
        "summaryConvergenceAnalysis": "|Δ score| entre des points de trajectoire consécutifs—aide à repérer le ralentissement ou la stagnation des améliorations.",
        "summaryBlameWaterfall": "Scores de blâme relatifs par nœud de canevas—les barres plus hautes indiquent les nœuds ayant le plus contribué aux mauvais résultats de base et ont tendance à être priorisés pour l'optimisation.",
        "summaryCostTokenBreakdown": "Total des tokens de prompt et de complétion (axe gauche) et coût estimé (axe droit) attribués à chaque nœud à travers toutes les évaluations.",
        "summaryScatterBaselineOpt": "Chaque point représente une ligne d'entraînement après validation : x = score composite avant réglage, y = score composite avec les prompts réglés. La diagonale en pointillés est la ligne de non-changement (y = x)."
      }
    }
  },
  "aiTransparency": {
    "title": "Transparence de l'IA",
    "loadingInventory": "Chargement de l'inventaire de transparence de l'IA...",
    "allSystemAgents": "Tous les agents système",
    "systemAgent": "Agent système",
    "registeredBy": "Enregistré par",
    "project": "Projet",
    "agentSubAgent": "Agent / Sous-agent",
    "env": "Environnement",
    "subAgentCount": "Nombre de sous-agents",
    "actions": "Actions",
    "viewMetadata": "Voir les métadonnées",
    "searchAgents": "Rechercher des agents...",
    "emptyMessage": "Aucun agent enregistré pour le moment. Enregistrez les agents publiés depuis Agent Studio pour les voir ici.",
    "unknown": "Inconnu",
    "status": "Statut",
    "metadata": "Métadonnées",
    "expandAgent": "Développer {{name}}",
    "collapseAgent": "Réduire {{name}}",
    "subAgentFallback": "Sous-agent {{index}}",
    "subAgentTypes": {
      "agent": "Sous-agent",
      "supervisor": "Superviseur",
      "intent_classifier": "Classificateur d'intention",
      "disambiguation": "Désambiguïsation",
      "external_agent": "Agent externe",
      "rlm": "RLM",
      "router": "Routeur",
      "hitl": "Approbation humaine",
      "sub_agent": "Sous-agent"
    }
  },
  "registry": {
    "agents": {
      "columnAgentName": "Agent Name",
      "registerAgent": "Enregistrer l'agent",
      "searchRegisteredAgents": "Rechercher des agents enregistrés...",
      "searchArchivedAgents": "Rechercher des agents archivés...",
      "emptyActiveAgentsDesc": "Aucun agent enregistré pour le moment. Enregistrez les agents publiés à partir d'Agent Studio pour les voir ici.",
      "emptyArchivedAgentsDesc": "Aucun agent archivé. Les agents archivés à partir du registre apparaîtront ici.",
      "registeredAgentsTitle": "Agents enregistrés",
      "archivedAgentsTitle": "Agents archivés",
      "agentsLabel": "Agents",
      "agentRegistryTitle": "Registre des agents",
      "filterSystemAgent": "Agent système",
      "filterAllSystemAgents": "Tous les agents système",
      "loadingAgents": "Chargement des agents...",
      "searchAgents": "Rechercher des agents...",
      "dynamicFilter_agent_type": "Type",
      "columnAgent": "Agent",
      "editAgentTitle": "Edit Agent",
      "configureAgentTitle": "Configure {{platformName}}",
      "registerAgentBtn": "Register Agent",
      "selectAgentPlatformDesc": "Sélectionnez la plateforme où votre agent a été créé",
      "importAgentsTitle": "Importer des agents depuis CSV",
      "importAgentsDesc": "Crée uniquement des agents externes. Les lignes correspondant à un nom + version existant sont ignorées. Les identifiants ne sont jamais lus depuis le CSV.",
      "agentEntity": "agent"
    },
    "workflows": {
      "columnWorkflow": "Nom du workflow",
      "workflowsLabel": "Workflows",
      "searchRegisteredWorkflows": "Rechercher les workflows enregistrés...",
      "searchArchivedWorkflows": "Rechercher les workflows archivés...",
      "loadingRegisteredWorkflows": "Chargement des workflows enregistrés...",
      "loadingArchivedWorkflows": "Chargement des workflows archivés...",
      "emptyRegisteredWorkflows": "Aucun workflow enregistré.",
      "emptyArchivedWorkflows": "Aucun workflow archivé.",
      "bulkArchiveWorkflows": "Archiver la sélection",
      "bulkRestoreWorkflows": "Restaurer la sélection",
      "workflowRegistryTitle": "Registre des workflows",
      "registeredWorkflowsTitle": "Workflows enregistrés",
      "archivedWorkflowsTitle": "Workflows archivés",
      "registerExternalWorkflowTitle": "Register External Workflow",
      "selectWorkflowPlatformDesc": "Sélectionnez la plateforme où votre workflow a été construit. Cette inscription est uniquement pour le catalogue.",
      "importWorkflowsTitle": "Importer des workflows depuis CSV",
      "importWorkflowsDesc": "Créer uniquement des brouillons de workflows. La clé de correspondance est le nom + la version.",
      "workflowEntity": "workflow",
      "loading": "Chargement des workflows..."
    },
    "guardrails": {
      "guardrailsLabel": "Guardrails",
      "actionGuardrails": "Guardrails",
      "guardrailsRepository": "Dépôt de Guardrails",
      "agentGuardrails": "Guardrails des agents",
      "guardrailsCoverage": "Couverture",
      "searchProfiles": "Rechercher des profils...",
      "newProfile": "Nouveau profil",
      "noGuardrailsAccess": "Vous n'avez accès à aucune fonctionnalité de Guardrails.",
      "loadingProfiles": "Chargement des profils...",
      "columnAttachedProfiles": "Profils attachés",
      "coverageBanner": "Couverture configurée uniquement — ne modifie pas l'application. Les lacunes sont des signaux d'inventaire.",
      "exportCoverageCsv": "Exporter CSV",
      "loadingCoverage": "Chargement de la carte de couverture...",
      "coverageCovered": "Couvert",
      "coverageGap": "Écart",
      "coverageNA": "N/A",
      "coverageUnknown": "Inconnu",
      "createProfileBtn": "Créer le profil",
      "savingProfileBtn": "Enregistrement...",
      "updateProfileBtn": "Mettre à jour le profil",
      "editProfileTitle": "Modifier le profil",
      "newGuardrailProfileTitle": "Nouveau profil Guardrail",
      "profileNameLabel": "Nom du profil *",
      "profileNamePlaceholder": "ex: Norme de protection des PII",
      "profileNameHint": "Lettres, chiffres, espaces, tirets et traits de soulignement uniquement",
      "profileDescLabel": "Description",
      "profileDescPlaceholder": "Décrivez ce profil guardrail...",
      "profileDescHint": "Texte brut uniquement — pas d'émojis ou caractères spéciaux",
      "guardrailsEnabled": "Guardrails activés",
      "guardrailsDisabled": "Guardrails désactivés",
      "noEnginesConfigured": "Aucun moteur guardrail configuré",
      "enginesActive": "{{enabledCount}}/{{totalCount}} moteurs actifs",
      "inactiveDeploymentBanner": "Le déploiement de cet agent est inactif. La configuration est restreinte.",
      "devFrozenBanner": "Cet agent est publié. Les guardrails DEV sont gelés — modifiez plutôt les guardrails de déploiement QA/UAT/PROD.",
      "adminOnlyBanner": "Deployment guardrails can only be modified by administrators.",
      "recentViolations": "Recent Violations",
      "metricsSummaryTitle": "Résumé des métriques",
      "metricTotalChecks": "VÉRIFICATIONS TOTALES",
      "metricBlocked": "BLOQUÉ",
      "metricWarned": "AVERTISSEMENT",
      "metricPassed": "RÉUSSI",
      "metricErrors": "ERREURS",
      "metricLatency": "LATENCE",
      "searchViolationsPlaceholder": "Rechercher des violations...",
      "noRecentViolations": "Aucune violation récente",
      "violationTimestamp": "Horodatage",
      "violationUser": "Utilisateur",
      "violationEngine": "Moteur",
      "violationStatus": "Statut",
      "violationDetails": "Détails",
      "violationAction": "Action",
      "violationRule": "Règle",
      "columnEngines": "Engines",
      "loading": "Chargement des guardrails...",
      "configMode": "MODE",
      "configExecution": "EXÉCUTION",
      "configTimeout": "DÉLAI PAR DÉFAUT (SECONDES)",
      "configSafeMessage": "MESSAGE SÉCURISÉ",
      "configCircuitBreaker": "DISJONCTEUR",
      "configFailureThreshold": "SEUIL D'ÉCHEC",
      "configCooldown": "TEMPS DE REFROIDISSEMENT (SECONDES)",
      "modeBlock": "Bloquer — Bloquer le contenu signalé",
      "modeObserve": "Observer — Journaliser uniquement, ne pas bloquer",
      "execSequential": "Séquentiel",
      "execParallel": "Parallèle",
      "safeMessagePlaceholder": "Je ne peux pas traiter cette demande en raison des restrictions de la politique de contenu.",
      "mode_block": "Bloquer — Bloquer le contenu signalé",
      "mode_warn": "Avertir — Journaliser l'avertissement, autoriser le contenu",
      "mode_shadow": "Observer — Journaliser uniquement, ne pas bloquer",
      "exec_sequential": "Séquentiel",
      "exec_parallel": "Parallèle"
    },
    "common": {
      "columnProject": "Projet",
      "columnVersion": "Version",
      "exportCsvTitle": "Exporter CSV (inclut la configuration des colonnes)",
      "exportCsvAria": "Exporter CSV",
      "importCsvTitle": "Importer CSV",
      "importCsvAria": "Importer CSV",
      "columnEnv": "Environnement",
      "columnOrchestrator": "Orchestrateur",
      "columnFramework": "Framework",
      "columnRegisteredBy": "Enregistré par",
      "columnRegisteredAt": "Enregistré le",
      "columnArchivedAt": "Archivé le",
      "columnActions": "Actions",
      "columnStatus": "Statut",
      "filterBarTitle": "Filtres",
      "filterAll": "Tous",
      "filterFavorites": "Favoris",
      "filterFramework": "Framework",
      "filterProject": "Projet",
      "filterRegisteredBy": "Enregistré par",
      "filterType": "Type",
      "filterStatus": "Statut",
      "loadingRegistered": "Chargement des agents enregistrés...",
      "loadingArchived": "Chargement des agents archivés...",
      "bulkArchive": "Archiver la sélection",
      "bulkRestore": "Restaurer la sélection",
      "bulkDelete": "Supprimer la sélection",
      "deleteSelected": "Supprimer la sélection",
      "showLess": "Moins",
      "actionTest": "Tester",
      "actionExecute": "Exécuter",
      "actionEdit": "Edit",
      "actionViewMetadata": "Voir les métadonnées",
      "actionEditMetadata": "Modifier les métadonnées",
      "actionEvaluate": "Évaluer",
      "actionViewEvalRuns": "Voir les évaluations",
      "actionTraces": "Traces",
      "actionLogs": "Journaux",
      "actionApiDocs": "Docs API",
      "actionClone": "Cloner",
      "actionDeploy": "Déployer",
      "actionDelete": "Delete",
      "actionArchive": "Archiver du registre",
      "actionRestore": "Restaurer dans le registre",
      "actionOpen": "Ouvrir",
      "actionPromoteToStore": "Promouvoir dans la boutique",
      "actionRuns": "Exécutions",
      "actionOpenCanvas": "Ouvrir le canevas",
      "registerExternal": "Enregistrer externe",
      "allCreators": "Tous les créateurs",
      "searchCreators": "Rechercher des créateurs...",
      "creatorLabel": "Créateur",
      "tableRows": "Lignes :",
      "tableShowing": "Affichage de {{startItem}} à {{endItem}} sur {{totalItems}}",
      "filterResultsOf": "{{resultCount}} sur {{totalCount}}",
      "filterResultsCount": "{{count}} résultat{{s}}",
      "filterLess": "Moins",
      "filterMore": "plus",
      "filterClearAll": "Effacer tous les filtres",
      "filterClear": "Effacer",
      "filterSavePreset": "Enregistrer le préréglage du filtre",
      "noDataAvailable": "Aucune donnée disponible",
      "actionView": "View",
      "filterAllEnvironments": "Toutes les environnements",
      "dynamicFilter_status": "Statut",
      "dynamicFilter_catalog_status": "Statut",
      "dynamicFilter_type": "Type",
      "columnEnvShort": "Env",
      "columnChat": "Chat",
      "columnAPI": "API",
      "columnVoice": "Voix",
      "columnRAG": "RAG",
      "columnTools": "Outils",
      "columnEnabled": "Activé",
      "columnMode": "Mode",
      "columnContentSafety": "Sécurité du contenu",
      "columnJailbreak": "Jailbreak / Prompt Shields",
      "columnDLP": "DLP / PII",
      "columnProfileAttached": "Profil associé",
      "columnWorkflowChannel": "Workflow",
      "cancelBtn": "Annuler",
      "globalSettings": "Paramètres globaux",
      "architectureTitle": "Architecture",
      "reviewSaveTitle": "Review & Save",
      "reviewRegisterTitle": "Review & Register",
      "stepReview": "Révision",
      "stepPlatform": "Plateforme",
      "stepConfigure": "Configurer",
      "stepArchitecture": "Architecture",
      "savingBtn": "Saving...",
      "registeringBtn": "Registering...",
      "saveChangesBtn": "Save changes",
      "statusActive": "active",
      "statusInactive": "inactive",
      "statusPublished": "PUBLISHED",
      "actionDeleteSelected": "Delete Selected",
      "columnName": "Name",
      "columnDescription": "Description",
      "expectedColumns": "COLONNES ATTENDUES",
      "platformAdminConfigureFields": "Champs de configuration de l'administrateur",
      "downloadTemplate": "Télécharger le modèle",
      "chooseCsv": "Choisir un CSV",
      "importBtn": "Importer",
      "importingBtn": "Importation...",
      "dynamicOption_agent": "Agent",
      "dynamicOption_sub-agent": "Sous-agent",
      "closeBtn": "Fermer",
      "statRows": "Lignes",
      "statCreated": "Créé",
      "statDuplicates": "Doublons",
      "statErrors": "Erreurs",
      "viewDuplicates": "Voir les doublons",
      "dupTitle": "Doublons d'importation ignorés",
      "dupRowsProcessed": "Lignes traitées",
      "dupCreated": "Créé",
      "dupSkipped": "Doublons ignorés",
      "dupHint2": "ont déjà ce nom dans la base de données mais n'étaient pas affichés dans le registre ; renommez ou incrémentez",
      "dupNoMatch": "Aucun doublon ne correspond à ce filtre.",
      "dupSearchPlaceholder": "Rechercher des doublons...",
      "dupRowsPerPage": "Lignes par page :",
      "hideAll": "Masquer tout",
      "showAll": "Afficher tout",
      "loading": "Chargement..."
    }
  },
  "exportImport": {
    "import": {
      "dialogTitle": "Importer du YAML",
      "bulkDialogTitle": "Importation en masse",
      "filesCount": "{{count}} fichier",
      "filesCount_plural": "{{count}} fichiers",
      "validFilesCount": "{{count}} fichier valide",
      "validFilesCount_plural": "{{count}} fichiers valides",
      "withErrorsCount": "{{count}} avec erreur",
      "withErrorsCount_plural": "{{count}} avec des erreurs",
      "switchToSingle": "Passer au fichier unique",
      "switchToBulk": "Passer à l'importation en masse",
      "targetProject": "Projet cible",
      "optional": "(facultatif)",
      "selectTargetProject": "Sélectionner le projet cible...",
      "selectProjectOptional": "Sélectionner un projet (facultatif)...",
      "selectProjectWarning": "Veuillez sélectionner un projet pour importer {{entity}}",
      "thisEntity": "cette entité",
      "dropzoneBulk": "Déposez des fichiers YAML ou cliquez pour parcourir (plusieurs autorisés)",
      "dropzoneSingle": "Déposez un fichier YAML ou cliquez pour parcourir",
      "fileTypes": ".yaml, .yml",
      "importingProgress": "Importation de {{current}} sur {{total}}...",
      "yamlContentLabel": "Contenu YAML",
      "yamlPlaceholderComment": "Collez ou modifiez le contenu YAML ici",
      "importBehavior": "Comportement d'importation",
      "matchOrCreate": "Faire correspondre ou créer",
      "matchOrCreateDesc": "Lier aux entités existantes, créer si non trouvé",
      "matchOnly": "Correspondance uniquement",
      "matchOnlyDesc": "Lier uniquement aux existantes, ignorer si non trouvé",
      "createNew": "Créer nouveau",
      "createNewDesc": "Toujours créer un nouveau, échouer si existe déjà",
      "previewResults": "Résultats de l'aperçu",
      "newBadge": "+{{count}} nouveau",
      "skippedBadge": "{{count}} ignoré(s)",
      "failedBadge": "{{count}} échoué(s)",
      "createdBadge": "+{{count}} créé(s)",
      "moreEntities": "+{{count}} autres entités",
      "moreErrors": "+{{count}} autres erreurs",
      "moreWarnings": "+{{count}} de plus",
      "importSuccessful": "Importation réussie",
      "bulkImportComplete": "Importation en masse terminée",
      "importFailed": "Échec de l'importation",
      "bulkImportCompletedWithErrors": "Importation en masse terminée avec des erreurs",
      "notes": "Remarques :",
      "errors": "Erreurs :",
      "done": "Terminé",
      "cancel": "Annuler",
      "preview": "Aperçu",
      "import": "Importer",
      "importing": "Importation en cours...",
      "importAll": "Tout importer ({{count}})",
      "removeFile": "Supprimer le fichier",
      "buttonTitle": "Importer du YAML",
      "buttonAria": "Importer du YAML",
      "buttonLabel": "Importer",
      "failedToReadFile": "Échec de lecture du fichier",
      "invalidYaml": "YAML non valide",
      "importFailedGeneric": "Échec de l'importation",
      "typeMismatchError": "Ce fichier contient un(e) {{detectedName}}, mais vous êtes sur la page {{expectedName}}s. Veuillez importer ce fichier depuis la bonne page."
    },
    "configWarnings": {
      "title": "Configuration requise",
      "subtitle": "L'entité importée peut ne pas fonctionner correctement tant que les éléments suivants ne sont pas configurés :",
      "actionRequired": "Action requise :",
      "actionRequiredDesc": "{{criticalCount}} {{criticalLabel}} critique(s) et {{warningCount}} {{warningLabel}} trouvé(s). L'agent peut ne pas fonctionner sans résoudre les problèmes critiques.",
      "actionRequiredOnlyCritical": "{{criticalCount}} {{criticalLabel}} critique(s) trouvé(s). L'agent peut ne pas fonctionner sans résoudre les problèmes critiques.",
      "issue": "problème",
      "issues": "problèmes",
      "warning": "avertissement",
      "warnings": "avertissements",
      "critical": "Critique",
      "categories": {
        "model": "Modèles d'IA",
        "models": "Modèles d'IA",
        "prompt": "Prompts",
        "prompts": "Prompts",
        "tool": "Outils",
        "tools": "Outils",
        "knowledge": "Sources de connaissances",
        "skill": "Compétences",
        "skills": "Compétences",
        "connector": "Connecteurs",
        "connectors": "Connecteurs",
        "iam": "Configurations IAM",
        "other": "Autre"
      }
    },
    "export": {
      "export": "Exporter",
      "exportSelected": "Exporter la sélection",
      "exportYaml": "Exporter en YAML",
      "exportAgent": "Exporter l'agent",
      "agentAlwaysIncluded": "Agent (toujours inclus)",
      "included": "Inclus",
      "dependencies": "Dépendances",
      "selectedOf": "{{selected}} sur {{total}} sélectionnés",
      "selectAll": "Tout sélectionner",
      "deselectAll": "Tout désélectionner",
      "loadingDeps": "Chargement des dépendances...",
      "noDeps": "Aucune dépendance trouvée. Seul l'agent sera exporté.",
      "permissionDenied": "Vous n'avez pas l'autorisation d'exporter cet agent. Veuillez contacter votre administrateur.",
      "failedToLoadDeps": "Échec du chargement des dépendances",
      "filesWillBeExported": "{{count}} fichier YAML sera exporté",
      "filesWillBeExported_plural": "{{count}} fichiers YAML seront exportés",
      "cancel": "Annuler",
      "confirmExport": "Confirmer l'exportation",
      "exporting": "Exportation en cours..."
    },
    "entityTypes": {
      "model": "Modèle",
      "tool": "Outil",
      "prompt": "Prompt",
      "skill": "Compétence",
      "agent": "Agent",
      "knowledge": "Source de connaissances",
      "storage_folder": "Dossier de stockage",
      "connector": "Connecteur",
      "iam": "Configuration IAM",
      "bundle": "Bundle",
      "workflow": "Workflow"
    }
  }
}